/**
 * The default luckysheet config object.
 */
const customColumnTitles = [
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6243,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "配电线路总览",
        "optionName": "杆塔编号/设备名称",
        "optionContent": null,
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "rodTowerNo",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "1",
        "width": "8%",
        "isLeft": "1#&#2#&#3",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "rodTowerNo",
        "name": "杆塔编号/设备名称",
        "conditionMap": []
    },
    {
        "name": "配置信息",
        "width": "0%",
        "fieldName": "rowConfig",
        "optionType": "hidden"
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6244,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "配电线路总览",
        "optionName": "是否变电站前三基",
        "optionContent": "是#&#否",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "isBase",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "1",
        "width": "2%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "isBase",
        "name": "是否变电站前三基",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6245,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "配电线路总览",
        "optionName": "杆塔/设备状态",
        "optionContent": "原有#&#新建",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "moduleState",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "1",
        "width": "3%",
        "isLeft": "1#&#2",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "moduleState",
        "name": "杆塔/设备状态",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6246,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "配电线路总览",
        "optionName": "杆塔结构",
        "optionContent": "单杆#&#双杆#&#侧担杆#&#窄基塔#&#钢管杆#&#宽基塔",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "rodTowerMaterial",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "1",
        "width": "3%",
        "isLeft": "1#&#2#&#3",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "rodTowerMaterial",
        "name": "杆塔结构",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6247,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "配电线路总览",
        "optionName": "回路数",
        "optionContent": "单回#&#双回",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "loopNumber",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "1",
        "width": "3%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "loopNumber",
        "name": "回路数",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6248,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "配电线路总览",
        "optionName": "是否带低压",
        "optionContent": "是#&#否",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "isLowPressure",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "1",
        "width": "2%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "isLowPressure",
        "name": "是否带低压",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6249,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "配电线路总览",
        "optionName": "杆塔类型",
        "optionContent": "[\n  {\n    \"key\": \"直线杆\",\n    \"val\": \"1002\"\n  },\n  {\n    \"key\": \"直线转角杆\",\n    \"val\": \"1004\"\n  },\n  {\n    \"key\": \"直线耐张杆\",\n    \"val\": \"1003\"\n  },\n  {\n    \"key\": \"转角0°～15°耐张杆\",\n    \"val\": \"1007\"\n  },\n  {\n    \"key\": \"转角15°～45°耐张杆\",\n    \"val\": \"1005\"\n  },\n  {\n    \"key\": \"转角90°耐张杆\",\n    \"val\": \"1006\"\n  },\n  {\n    \"key\": \"终端杆\",\n    \"val\": \"1001\"\n  }\n]",
        "optionContentType": "object",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "rodTowerTypeCode",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "1",
        "width": "5%",
        "isLeft": "0",
        "conditionList": "[\n    {\n        \"key\": \"rodTowerMaterial\",\n        \"name\": \"杆塔结构\",\n        \"val\": \"单杆\"\n    },\n    {\n        \"key\": \"loopNumber\",\n        \"name\": \"回路数\",\n        \"val\": \"单回\"\n    }\n]",
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "rodTowerTypeCode",
        "name": "杆塔类型",
        "conditionMap": [
            {
                "condition": [
                    {
                        "key": "rodTowerMaterial",
                        "name": "杆塔结构",
                        "val": "单杆"
                    },
                    {
                        "key": "loopNumber",
                        "name": "回路数",
                        "val": "单回"
                    }
                ],
                "opction": "[\n  {\n    \"key\": \"直线杆\",\n    \"val\": \"1002\"\n  },\n  {\n    \"key\": \"直线转角杆\",\n    \"val\": \"1004\"\n  },\n  {\n    \"key\": \"直线耐张杆\",\n    \"val\": \"1003\"\n  },\n  {\n    \"key\": \"转角0°～15°耐张杆\",\n    \"val\": \"1007\"\n  },\n  {\n    \"key\": \"转角15°～45°耐张杆\",\n    \"val\": \"1005\"\n  },\n  {\n    \"key\": \"转角90°耐张杆\",\n    \"val\": \"1006\"\n  },\n  {\n    \"key\": \"终端杆\",\n    \"val\": \"1001\"\n  }\n]",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "1",
                "defaultVal": null
            },
            {
                "condition": [
                    {
                        "key": "rodTowerMaterial",
                        "name": "杆塔结构",
                        "val": "单杆"
                    },
                    {
                        "key": "loopNumber",
                        "name": "回路数",
                        "val": "双回"
                    }
                ],
                "opction": "[\n  {\n    \"key\": \"直线杆\",\n    \"val\": \"1002\"\n  },\n  {\n    \"key\": \"直线转角杆\",\n    \"val\": \"1004\"\n  },\n  {\n    \"key\": \"直线耐张杆\",\n    \"val\": \"1003\"\n  },\n  {\n    \"key\": \"转角45°耐张杆\",\n    \"val\": \"1005\"\n  },\n  {\n    \"key\": \"转角90°耐张杆\",\n    \"val\": \"1006\"\n  },\n  {\n    \"key\": \"终端杆\",\n    \"val\": \"1001\"\n  }\n]",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "1",
                "defaultVal": null
            },
            {
                "condition": [
                    {
                        "key": "rodTowerMaterial",
                        "name": "杆塔结构",
                        "val": "双杆"
                    }
                ],
                "opction": "[\n  {\n    \"key\": \"直线杆\",\n    \"val\": \"1002\"\n  },\n  {\n    \"key\": \"转角0°～10°耐张杆\",\n    \"val\": \"2003\"\n  },\n  {\n    \"key\": \"转角10°～30°耐张杆\",\n    \"val\": \"2004\"\n  },\n  {\n    \"key\": \"转角30°～60°耐张杆\",\n    \"val\": \"2005\"\n  },\n  {\n    \"key\": \"转角60°～90°耐张杆\",\n    \"val\": \"2006\"\n  },\n  {\n    \"key\": \"终端杆\",\n    \"val\": \"1001\"\n  }\n]",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "1",
                "defaultVal": null
            },
            {
                "condition": [
                    {
                        "key": "rodTowerMaterial",
                        "name": "杆塔结构",
                        "val": "侧担杆"
                    }
                ],
                "opction": "[\n  {\n    \"key\": \"直线杆\",\n    \"val\": \"1002\"\n  },\n  {\n    \"key\": \"直线转角杆\",\n    \"val\": \"1004\"\n  },\n  {\n    \"key\": \"直线耐张杆\",\n    \"val\": \"1003\"\n  },\n  {\n    \"key\": \"转角45°耐张杆\",\n    \"val\": \"1005\"\n  },\n  {\n    \"key\": \"终端杆\",\n    \"val\": \"1001\"\n  }\n]",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "1",
                "defaultVal": null
            },
            {
                "condition": [
                    {
                        "key": "rodTowerMaterial",
                        "name": "杆塔结构",
                        "val": "窄基塔"
                    }
                ],
                "opction": "[\n  {\n    \"key\": \"直线塔\",\n    \"val\": \"3002\"\n  },\n  {\n    \"key\": \"转角0°～30°耐张塔\",\n    \"val\": \"3004\"\n  },\n  {\n    \"key\": \"转角30°～60°耐张塔\",\n    \"val\": \"3005\"\n  },\n  {\n    \"key\": \"转角60°～90°耐张塔\",\n    \"val\": \"3006\"\n  },\n  {\n    \"key\": \"终端塔\",\n    \"val\": \"3001\"\n  }\n]",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "1",
                "defaultVal": null
            },
            {
                "condition": [
                    {
                        "key": "rodTowerMaterial",
                        "name": "杆塔结构",
                        "val": "宽基塔"
                    }
                ],
                "opction": "[\n  {\n    \"key\": \"直线塔\",\n    \"val\": \"3002\"\n  },\n  {\n    \"key\": \"转角0°～30°耐张塔\",\n    \"val\": \"3004\"\n  },\n  {\n    \"key\": \"转角30°～60°耐张塔\",\n    \"val\": \"3005\"\n  },\n  {\n    \"key\": \"转角60°～90°耐张塔\",\n    \"val\": \"3006\"\n  },\n  {\n    \"key\": \"终端塔\",\n    \"val\": \"3001\"\n  }\n]",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "1",
                "defaultVal": null
            },
            {
                "condition": [
                    {
                        "key": "rodTowerMaterial",
                        "name": "杆塔结构",
                        "val": "钢管杆"
                    }
                ],
                "opction": "[\n  {\n    \"key\": \"直线杆\",\n    \"val\": \"1002\"\n  },\n  {\n    \"key\": \"转角45°耐张杆\",\n    \"val\": \"1005\"\n  },\n  {\n    \"key\": \"转角90°耐张杆\",\n    \"val\": \"1006\"\n  },\n  {\n    \"key\": \"终端杆\",\n    \"val\": \"1001\"\n  }\n]",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "1",
                "defaultVal": null
            }
        ]
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6256,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "配电线路总览",
        "optionName": "线缆状态",
        "optionContent": "原有#&#新建#&#利旧",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "wireModuleState",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "1",
        "width": "3%",
        "isLeft": "3",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "wireModuleState",
        "name": "线缆状态",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6257,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "配电线路总览",
        "optionName": "线缆类型",
        "optionContent": null,
        "optionContentType": "object",
        "showNameVal": "writeType#&#writeType",
        "defaultVal": null,
        "fieldName": "writeType",
        "componentType": "2",
        "requestFlag": "1",
        "requestMethod": "get",
        "requestPath": "/sl/wireModule/listNoPage",
        "requestParam": "[\n    {\n\n\"key\": \"moduleState\",\n\n\"val\": \"wireModuleState\",\n\n\"source\": \"this\"\n    },\n    {\n\n\"key\": \"voltageLevel\",\n\n\"val\": \"\",\n\n\"defaultVal\": \"10kV\",\n\n\"source\": \"default\"\n    }\n]",
        "requiredFlag": "1",
        "width": "4%",
        "isLeft": "3",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "writeType",
        "name": "线缆类型",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6258,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "配电线路总览",
        "optionName": "线缆截面",
        "optionContent": null,
        "optionContentType": "object",
        "showNameVal": "crossSectionAreaTwo#&#crossSectionAreaTwo",
        "defaultVal": null,
        "fieldName": "crossSectionAreaTwo",
        "componentType": "2",
        "requestFlag": "1",
        "requestMethod": "get",
        "requestPath": "/sl/wireModule/listNoPage",
        "requestParam": "[\n    {\n\n\"key\": \"moduleState\",\n\n\"val\": \"wireModuleState\",\n\n\"source\": \"this\"\n    },\n    {\n\n\"key\": \"voltageLevel\",\n\n\"val\": \"\",\n\n\"defaultVal\": \"10kV\",\n\n\"source\": \"default\"\n    },\n    {\n\n\"key\": \"writeType\",\n\n\"val\": \"writeType\",\n\n\"source\": \"this\"\n    }\n]",
        "requiredFlag": "1",
        "width": "3%",
        "isLeft": "3",
        "conditionList": "[\n    {\n\n\"key\": \"writeType\",\n\n\"name\":\"线缆类型\",\n\n\"val\": \"\"\n    }\n]",
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "crossSectionAreaTwo",
        "name": "线缆截面",
        "conditionMap": [
            {
                "condition": [
                    {
                        "key": "writeType",
                        "name": "线缆类型",
                        "val": ""
                    }
                ],
                "opction": null,
                "requestFlag": "1",
                "requestMethod": "get",
                "requestParam": "[\n    {\n\n\"key\": \"moduleState\",\n\n\"val\": \"wireModuleState\",\n\n\"source\": \"this\"\n    },\n    {\n\n\"key\": \"voltageLevel\",\n\n\"val\": \"\",\n\n\"defaultVal\": \"10kV\",\n\n\"source\": \"default\"\n    },\n    {\n\n\"key\": \"writeType\",\n\n\"val\": \"writeType\",\n\n\"source\": \"this\"\n    }\n]",
                "showNameVal": "crossSectionAreaTwo#&#crossSectionAreaTwo",
                "requestPath": "/sl/wireModule/listNoPage",
                "requiredFlag": "1",
                "defaultVal": null
            }
        ]
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6259,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "配电线路总览",
        "optionName": "档距或总长(m)",
        "optionContent": null,
        "optionContentType": "number",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "wireSpan",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "1",
        "width": "2%",
        "isLeft": "3",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "wireSpan",
        "name": "档距或总长(m)",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6260,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "配电线路总览",
        "optionName": "杆型代号",
        "optionContent": null,
        "optionContentType": "object",
        "showNameVal": "moduleId#&#moduleName",
        "defaultVal": null,
        "fieldName": "rodTypeModuleId",
        "componentType": "2",
        "requestFlag": "1",
        "requestMethod": "post",
        "requestPath": "/sl/rodTypeModule/codeList",
        "requestParam": "[\n    {\n        \"key\": \"moduleState\",\n        \"val\": \"moduleState\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"voltageLevel\",\n        \"val\": \"\",\n        \"defaultVal\": \"10kV\",\n        \"source\": \"default\"\n    },\n    {\n        \"key\": \"weatherzone\",\n        \"val\": \"weatherzone\",\n        \"source\": \"geoConfig\"\n    },\n    {\n        \"key\": \"loopNumber\",\n        \"val\": \"loopNumber\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"rodTowerMaterial\",\n        \"val\": \"rodTowerMaterial\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"rodTowerTypeCode\",\n        \"val\": \"rodTowerTypeCode\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"isLowPressure\",\n        \"val\": \"isLowPressure\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"poleMaterial\",\n        \"val\": \"coneRodMaterial\",\n        \"source\": \"globalConfig\"\n    }\n]",
        "requiredFlag": "1",
        "width": "5%",
        "isLeft": "1#&#3",
        "conditionList": "[\n    {\n\n\"key\": \"rodTowerMaterial\",\n\n\"name\":\"杆塔结构\",\n\n\"val\": \"单杆#&#双杆#&#侧担杆\"\n    }\n]",
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "rodTypeModuleId",
        "name": "杆型代号",
        "conditionMap": [
            {
                "condition": [
                    {
                        "key": "rodTowerMaterial",
                        "name": "杆塔结构",
                        "val": "单杆#&#双杆#&#侧担杆"
                    }
                ],
                "opction": null,
                "requestFlag": "1",
                "requestMethod": "post",
                "requestParam": "[\n    {\n        \"key\": \"moduleState\",\n        \"val\": \"moduleState\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"voltageLevel\",\n        \"val\": \"\",\n        \"defaultVal\": \"10kV\",\n        \"source\": \"default\"\n    },\n    {\n        \"key\": \"weatherzone\",\n        \"val\": \"weatherzone\",\n        \"source\": \"geoConfig\"\n    },\n    {\n        \"key\": \"loopNumber\",\n        \"val\": \"loopNumber\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"rodTowerMaterial\",\n        \"val\": \"rodTowerMaterial\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"rodTowerTypeCode\",\n        \"val\": \"rodTowerTypeCode\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"isLowPressure\",\n        \"val\": \"isLowPressure\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"poleMaterial\",\n        \"val\": \"coneRodMaterial\",\n        \"source\": \"globalConfig\"\n    }\n]",
                "showNameVal": "moduleId#&#moduleName",
                "requestPath": "/sl/rodTypeModule/codeList",
                "requiredFlag": "1",
                "defaultVal": null
            },
            {
                "condition": [
                    {
                        "key": "rodTowerMaterial",
                        "name": "杆塔结构",
                        "val": "窄基塔"
                    }
                ],
                "opction": null,
                "requestFlag": "1",
                "requestMethod": "post",
                "requestParam": "[\n {\n        \"key\": \"lastProjectData\",\n        \"val\": \"lastProjectData\",\n        \"source\": \"lastProjectData\"\n    }\n]",
                "showNameVal": "moduleId#&#moduleName",
                "requestPath": "/sl/towerTypeModule/codeList",
                "requiredFlag": "1",
                "defaultVal": null
            },
            {
                "condition": [
                    {
                        "key": "rodTowerMaterial",
                        "name": "杆塔结构",
                        "val": "宽基塔"
                    }
                ],
                "opction": null,
                "requestFlag": "1",
                "requestMethod": "post",
                "requestParam": "[\n {\n        \"key\": \"lastProjectData\",\n        \"val\": \"lastProjectData\",\n        \"source\": \"lastProjectData\"\n    }\n]",
                "showNameVal": "moduleId#&#moduleName",
                "requestPath": "/sl/baseTower/codeList",
                "requiredFlag": "1",
                "defaultVal": null
            },
            {
                "condition": [
                    {
                        "key": "rodTowerMaterial",
                        "name": "杆塔结构",
                        "val": "钢管杆"
                    }
                ],
                "opction": null,
                "requestFlag": "1",
                "requestMethod": "post",
                "requestParam": "[\n  {\n    \"key\": \"moduleState\",\n    \"val\": \"moduleState\",\n    \"source\": \"this\"\n  },\n  {\n    \"key\": \"voltageLevel\",\n    \"val\": \"\",\n    \"defaultVal\": \"10kV\",\n    \"source\": \"default\"\n  },\n  {\n    \"key\": \"weatherzone\",\n    \"val\": \"weatherzone\",\n    \"source\": \"geoConfig\"\n  },\n  {\n    \"key\": \"loopNumber\",\n    \"val\": \"loopNumber\",\n    \"source\": \"this\"\n  },\n  {\n    \"key\": \"rodTowerMaterial\",\n    \"val\": \"rodTowerMaterial\",\n    \"source\": \"this\"\n  },\n  {\n    \"key\": \"rodTowerTypeCode\",\n    \"val\": \"rodTowerTypeCode\",\n    \"source\": \"this\"\n  },\n  {\n    \"key\": \"isLowPressure\",\n    \"val\": \"isLowPressure\",\n    \"source\": \"this\"\n  }\n]",
                "showNameVal": "moduleId#&#moduleName",
                "requestPath": "/sl/steelPipeTypeModule/codeList",
                "requiredFlag": "1",
                "defaultVal": null
            }
        ]
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6264,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "配电线路总览",
        "optionName": "杆头代号",
        "optionContent": null,
        "optionContentType": "object",
        "showNameVal": "moduleId#&#moduleName",
        "defaultVal": null,
        "fieldName": "rodHeadModuleId",
        "componentType": "2",
        "requestFlag": "1",
        "requestMethod": "post",
        "requestPath": "/sl/rodHeadModule/codeList",
        "requestParam": "[\n    {\n\n\"key\": \"moduleState\",\n\n\"val\": \"moduleState\",\n\n\"source\": \"this\"\n    },\n    {\n\n\"key\": \"voltageLevel\",\n\n\"val\": \"\",\n\n\"defaultVal\": \"10kV\",\n\n\"source\": \"default\"\n    },\n    {\n\n\"key\": \"weatherzone\",\n\n\"val\": \"weatherzone\",\n\n\"source\": \"geoConfig\"\n    },\n    {\n\n\"key\": \"loopNumber\",\n\n\"val\": \"loopNumber\",\n\n\"source\": \"this\"\n    },\n    {\n\n\"key\": \"rodTowerMaterial\",\n\n\"val\": \"rodTowerMaterial\",\n\n\"source\": \"this\"\n    },\n    {\n\n\"key\": \"rodTowerTypeCode\",\n\n\"val\": \"rodTowerTypeCode\",\n\n\"source\": \"this\"\n    }\n]",
        "requiredFlag": "1",
        "width": "4%",
        "isLeft": "0",
        "conditionList": "[\n    {\n\n\"name\": \"杆塔状态\",\n\n\"key\": \"moduleState\",\n\n\"val\": \"原有\"\n    } \n]",
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "rodHeadModuleId",
        "name": "杆头代号",
        "conditionMap": [
            {
                "condition": [
                    {
                        "name": "杆塔状态",
                        "key": "moduleState",
                        "val": "原有"
                    }
                ],
                "opction": null,
                "requestFlag": "1",
                "requestMethod": "post",
                "requestParam": "[\n    {\n\n\"key\": \"moduleState\",\n\n\"val\": \"moduleState\",\n\n\"source\": \"this\"\n    },\n    {\n\n\"key\": \"voltageLevel\",\n\n\"val\": \"\",\n\n\"defaultVal\": \"10kV\",\n\n\"source\": \"default\"\n    },\n    {\n\n\"key\": \"weatherzone\",\n\n\"val\": \"weatherzone\",\n\n\"source\": \"geoConfig\"\n    },\n    {\n\n\"key\": \"loopNumber\",\n\n\"val\": \"loopNumber\",\n\n\"source\": \"this\"\n    },\n    {\n\n\"key\": \"rodTowerMaterial\",\n\n\"val\": \"rodTowerMaterial\",\n\n\"source\": \"this\"\n    },\n    {\n\n\"key\": \"rodTowerTypeCode\",\n\n\"val\": \"rodTowerTypeCode\",\n\n\"source\": \"this\"\n    }\n]",
                "showNameVal": "moduleId#&#moduleName",
                "requestPath": "/sl/rodHeadModule/codeList",
                "requiredFlag": "1",
                "defaultVal": null
            }
        ]
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6265,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "配电线路总览",
        "optionName": "电杆分段",
        "optionContent": "整根杆",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "cementPoleSection",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "1",
        "width": "4%",
        "isLeft": "1",
        "conditionList": "[\n    {\n\n\"name\": \"杆塔结构\",\n\n\"key\": \"rodTowerMaterial\",\n\n\"val\": \"单杆#&#双杆#&#侧担杆\"\n    },\n    {\n\n\"name\": \"杆高\",\n\n\"key\": \"rodHeight\",\n\n\"val\": \"10m#&#12m\"\n    },\n    {\n\n\"name\": \"电杆材质\",\n\n\"key\": \"poleMaterial\",\n\n\"val\": \"普通非预应力\"\n    }\n]",
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "cementPoleSection",
        "name": "电杆分段",
        "conditionMap": [
            {
                "condition": [
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "单杆#&#双杆#&#侧担杆"
                    },
                    {
                        "name": "杆高",
                        "key": "rodHeight",
                        "val": "10m#&#12m"
                    },
                    {
                        "name": "电杆材质",
                        "key": "poleMaterial",
                        "val": "普通非预应力"
                    }
                ],
                "opction": "整根杆",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "1",
                "defaultVal": null
            },
            {
                "condition": [
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "单杆#&#双杆#&#侧担杆"
                    },
                    {
                        "name": "杆高",
                        "key": "rodHeight",
                        "val": "15m"
                    },
                    {
                        "name": "电杆材质",
                        "key": "poleMaterial",
                        "val": "普通非预应力"
                    }
                ],
                "opction": "整根杆#&#法兰组装杆",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "1",
                "defaultVal": null
            },
            {
                "condition": [
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "单杆#&#双杆#&#侧担杆"
                    },
                    {
                        "name": "杆高",
                        "key": "rodHeight",
                        "val": "18m"
                    },
                    {
                        "name": "电杆材质",
                        "key": "poleMaterial",
                        "val": "普通非预应力"
                    }
                ],
                "opction": "法兰组装杆",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "1",
                "defaultVal": null
            },
            {
                "condition": [
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "单杆#&#双杆#&#侧担杆"
                    },
                    {
                        "name": "杆高",
                        "key": "rodHeight",
                        "val": "10m#&#12m"
                    },
                    {
                        "name": "电杆材质",
                        "key": "poleMaterial",
                        "val": "普通非预应力(带内接地)"
                    }
                ],
                "opction": "整根杆",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "1",
                "defaultVal": null
            },
            {
                "condition": [
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "单杆#&#双杆#&#侧担杆"
                    },
                    {
                        "name": "杆高",
                        "key": "rodHeight",
                        "val": "15m"
                    },
                    {
                        "name": "电杆材质",
                        "key": "poleMaterial",
                        "val": "普通非预应力(带内接地)"
                    }
                ],
                "opction": "整根杆#&#法兰组装杆",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "1",
                "defaultVal": null
            },
            {
                "condition": [
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "单杆#&#双杆#&#侧担杆"
                    },
                    {
                        "name": "电杆材质",
                        "key": "poleMaterial",
                        "val": "复合"
                    }
                ],
                "opction": "整根杆#&#插接杆",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "1",
                "defaultVal": null
            },
            {
                "condition": [
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "单杆#&#双杆#&#侧担杆"
                    },
                    {
                        "name": "电杆材质",
                        "key": "poleMaterial",
                        "val": "超高性能"
                    }
                ],
                "opction": "整根杆",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "1",
                "defaultVal": null
            }
        ]
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6272,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "配电线路总览",
        "optionName": "转角方向与度数",
        "optionContent": null,
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "angleDegree",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "3%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "angleDegree",
        "name": "转角方向与度数",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6273,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "配电线路总览",
        "optionName": "数智查验参阅意见",
        "optionContent": null,
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "opinion",
        "componentType": null,
        "requestFlag": null,
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": null,
        "width": "20%",
        "isLeft": null,
        "conditionList": null,
        "isMerge": null,
        "isMergeTitle": null,
        "mergeTitle": null,
        "value": "opinion",
        "name": "数智查验参阅意见",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6274,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "配电线路总览",
        "optionName": "意见出处",
        "optionContent": null,
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "source",
        "componentType": null,
        "requestFlag": null,
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": null,
        "width": "20%",
        "isLeft": null,
        "conditionList": null,
        "isMerge": null,
        "isMergeTitle": null,
        "mergeTitle": null,
        "value": "source",
        "name": "意见出处",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6275,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "配电线路总览",
        "optionName": "备注",
        "optionContent": null,
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "wireNote",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "6%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "wireNote",
        "name": "备注",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6276,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "柱上设备及附件配置",
        "optionName": "线路避雷器类型",
        "optionContent": null,
        "optionContentType": "object",
        "showNameVal": "moduleId#&#moduleCode",
        "defaultVal": null,
        "fieldName": "blqModuleId",
        "componentType": "2",
        "requestFlag": "1",
        "requestMethod": "get",
        "requestPath": "/sl/columnAttachments/listNoPage",
        "requestParam": "[\n    {\n        \"key\": \"annexType\",\n        \"val\": \"\",\n        \"defaultVal\": \"避雷器\",\n        \"source\": \"default\"\n    },\n    {\n        \"key\": \"voltageLevel\",\n        \"val\": \"\",\n        \"defaultVal\": \"10kV\",\n        \"source\": \"default\"\n    },\n    {\n        \"key\": \"moduleState\",\n        \"val\": \"\",\n        \"defaultVal\": \"新建\",\n        \"source\": \"default\"\n    },\n    {\n        \"key\": \"gapType\",\n        \"val\": \"\",\n        \"defaultVal\": \"带支撑件间隙\",\n        \"source\": \"default\"\n    }\n]",
        "requiredFlag": "0",
        "width": "8%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "blqModuleId",
        "name": "线路避雷器类型",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6277,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "柱上设备及附件配置",
        "optionName": "接地挂环型号",
        "optionContent": null,
        "optionContentType": "object",
        "showNameVal": "moduleId#&#moduleCode",
        "defaultVal": null,
        "fieldName": "jdghModuleId",
        "componentType": "2",
        "requestFlag": "1",
        "requestMethod": "get",
        "requestPath": "/sl/columnAttachments/listNoPage",
        "requestParam": "[\n    {\n        \"key\": \"annexType\",\n        \"val\": \"\",\n        \"defaultVal\": \"接地挂环\",\n        \"source\": \"default\"\n    },\n    {\n        \"key\": \"voltageLevel\",\n        \"val\": \"\",\n        \"defaultVal\": \"10kV\",\n        \"source\": \"default\"\n    },\n    {\n        \"key\": \"moduleState\",\n        \"val\": \"\",\n        \"defaultVal\": \"新建\",\n        \"source\": \"default\"\n    }\n]",
        "requiredFlag": "0",
        "width": "8%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "jdghModuleId",
        "name": "接地挂环型号",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6278,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "柱上设备及附件配置",
        "optionName": "防振锤型号",
        "optionContent": null,
        "optionContentType": "object",
        "showNameVal": "moduleId#&#moduleCode",
        "defaultVal": null,
        "fieldName": "fzcModuleId",
        "componentType": "2",
        "requestFlag": "1",
        "requestMethod": "get",
        "requestPath": "/sl/columnAttachments/listNoPage",
        "requestParam": "[\n    {\n        \"key\": \"annexType\",\n        \"val\": \"\",\n        \"defaultVal\": \"防振锤\",\n        \"source\": \"default\"\n    },\n    {\n        \"key\": \"voltageLevel\",\n        \"val\": \"\",\n        \"defaultVal\": \"10kV\",\n        \"source\": \"default\"\n    },\n    {\n        \"key\": \"moduleState\",\n        \"val\": \"\",\n        \"defaultVal\": \"新建\",\n        \"source\": \"default\"\n    }\n]",
        "requiredFlag": "0",
        "width": "8%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "fzcModuleId",
        "name": "防振锤型号",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6279,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "柱上设备及附件配置",
        "optionName": "防振锤数量",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "fzcCount",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "9%",
        "isLeft": "0",
        "conditionList": "[\n    {\n\n\"name\": \"防振锤型号\",\n\n\"key\": \"fzcModuleId\",\n\n\"val\": \"\"\n    }\n]",
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "fzcCount",
        "name": "防振锤数量",
        "conditionMap": [
            {
                "condition": [
                    {
                        "name": "防振锤型号",
                        "key": "fzcModuleId",
                        "val": ""
                    }
                ],
                "opction": null,
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "0",
                "defaultVal": null
            }
        ]
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6280,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "柱上设备及附件配置",
        "optionName": "设备类型",
        "optionContent": "柱上断路器#&#隔离开关#&#高压熔断器#&#柱上断路器(用户分界)",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "equipmentType",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "9%",
        "isLeft": "0",
        "conditionList": "[\n    {\n\n\"name\": \"杆塔结构分类\",\n\n\"key\": \"rodTowerMaterial\",\n\n\"val\": \"单杆#&#侧担杆#&#窄基塔\"\n    }\n]",
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "equipmentType",
        "name": "设备类型",
        "conditionMap": [
            {
                "condition": [
                    {
                        "name": "杆塔结构分类",
                        "key": "rodTowerMaterial",
                        "val": "单杆#&#侧担杆#&#窄基塔"
                    }
                ],
                "opction": "柱上断路器#&#隔离开关#&#高压熔断器#&#柱上断路器(用户分界)",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "0",
                "defaultVal": null
            },
            {
                "condition": [
                    {
                        "name": "杆塔结构分类",
                        "key": "rodTowerMaterial",
                        "val": "双杆"
                    }
                ],
                "opction": "柱上断路器",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "0",
                "defaultVal": null
            }
        ]
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6282,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "柱上设备及附件配置",
        "optionName": "柱上开关类型",
        "optionContent": "支柱式空气开关#&#接地自适应式开关#&#罐式环保气体开关",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "breakerType",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "1",
        "width": "9%",
        "isLeft": "0",
        "conditionList": "[\n    {\n\n\"name\": \"设备类型\",\n\n\"key\": \"equipmentType\",\n\n\"val\": \"柱上断路器#&#柱上断路器(用户分界)\"\n    }\n]",
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "breakerType",
        "name": "柱上开关类型",
        "conditionMap": [
            {
                "condition": [
                    {
                        "name": "设备类型",
                        "key": "equipmentType",
                        "val": "柱上断路器#&#柱上断路器(用户分界)"
                    }
                ],
                "opction": "支柱式空气开关#&#接地自适应式开关#&#罐式环保气体开关",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "1",
                "defaultVal": null
            }
        ]
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6283,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "柱上设备及附件配置",
        "optionName": "杆上设备代号",
        "optionContent": null,
        "optionContentType": "object",
        "showNameVal": "moduleId#&#moduleName",
        "defaultVal": null,
        "fieldName": "equipmentModuleId",
        "componentType": "2",
        "requestFlag": "1",
        "requestMethod": "get",
        "requestPath": "/sl/columnEquipment/codeList",
        "requestParam": "[\n    {\n        \"key\": \"equipmentType\",\n        \"val\": \"equipmentType\",\n        \"defaultVal\": \"\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"moduleState\",\n        \"val\": \"\",\n        \"defaultVal\": \"新建\",\n        \"source\": \"default\"\n    },\n    {\n        \"key\": \"isolatingSwitchType\",\n        \"val\": \"isolatingSwitchTypeVal\",\n        \"defaultVal\": \"\",\n        \"source\": \"disRodConfig\"\n    },\n    {\n        \"key\": \"leadSupportInsulatorType\",\n        \"val\": \"leadSupportInsulatorTypeVal\",\n        \"defaultVal\": \"\",\n        \"source\": \"disRodConfig\"\n    },\n    {\n        \"key\": \"rodTowerMaterial\",\n        \"val\": \"rodTowerMaterial\",\n        \"defaultVal\": \"\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"shaojing\",\n        \"val\": \"shaojing\",\n        \"defaultVal\": \"\",\n        \"source\": \"rodTypeModuleId\"\n    },\n    {\n        \"key\": \"rodTowerHeight\",\n        \"val\": \"rodHeight\",\n        \"defaultVal\": \"\",\n        \"source\": \"rodTypeModuleId\"\n    },\n    {\n        \"key\": \"loopNumber\",\n        \"val\": \"loopNumber\",\n        \"defaultVal\": \"\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"tvNumber\",\n        \"val\": \"\",\n        \"defaultVal\": \"2\",\n        \"source\": \"default\"\n    }\n]",
        "requiredFlag": "1",
        "width": "9%",
        "isLeft": "0",
        "conditionList": "[\n    {\n        \"name\": \"设备类型\",\n        \"key\": \"equipmentType\",\n        \"val\": \"隔离开关\"\n    },\n    {\n        \"name\": \"杆塔结构\",\n        \"key\": \"rodTowerMaterial\",\n        \"val\": \"单杆\"\n    }\n]",
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "equipmentModuleId",
        "name": "杆上设备代号",
        "conditionMap": [
            {
                "condition": [
                    {
                        "name": "设备类型",
                        "key": "equipmentType",
                        "val": "隔离开关"
                    },
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "单杆"
                    }
                ],
                "opction": null,
                "requestFlag": "1",
                "requestMethod": "get",
                "requestParam": "[\n    {\n        \"key\": \"equipmentType\",\n        \"val\": \"equipmentType\",\n        \"defaultVal\": \"\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"moduleState\",\n        \"val\": \"\",\n        \"defaultVal\": \"新建\",\n        \"source\": \"default\"\n    },\n    {\n        \"key\": \"isolatingSwitchType\",\n        \"val\": \"isolatingSwitchTypeVal\",\n        \"defaultVal\": \"\",\n        \"source\": \"disRodConfig\"\n    },\n    {\n        \"key\": \"leadSupportInsulatorType\",\n        \"val\": \"leadSupportInsulatorTypeVal\",\n        \"defaultVal\": \"\",\n        \"source\": \"disRodConfig\"\n    },\n    {\n        \"key\": \"rodTowerMaterial\",\n        \"val\": \"rodTowerMaterial\",\n        \"defaultVal\": \"\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"shaojing\",\n        \"val\": \"shaojing\",\n        \"defaultVal\": \"\",\n        \"source\": \"rodTypeModuleId\"\n    },\n    {\n        \"key\": \"rodTowerHeight\",\n        \"val\": \"rodHeight\",\n        \"defaultVal\": \"\",\n        \"source\": \"rodTypeModuleId\"\n    },\n    {\n        \"key\": \"loopNumber\",\n        \"val\": \"loopNumber\",\n        \"defaultVal\": \"\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"tvNumber\",\n        \"val\": \"\",\n        \"defaultVal\": \"2\",\n        \"source\": \"default\"\n    }\n]",
                "showNameVal": "moduleId#&#moduleName",
                "requestPath": "/sl/columnEquipment/codeList",
                "requiredFlag": "1",
                "defaultVal": null
            },
            {
                "condition": [
                    {
                        "name": "设备类型",
                        "key": "equipmentType",
                        "val": "隔离开关"
                    },
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "窄基塔"
                    }
                ],
                "opction": null,
                "requestFlag": "1",
                "requestMethod": "get",
                "requestParam": "[\n    {\n        \"key\": \"equipmentType\",\n        \"val\": \"equipmentType\",\n        \"defaultVal\": \"\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"moduleState\",\n        \"val\": \"\",\n        \"defaultVal\": \"新建\",\n        \"source\": \"default\"\n    },\n    {\n        \"key\": \"isolatingSwitchType\",\n        \"val\": \"isolatingSwitchTypeVal\",\n        \"defaultVal\": \"\",\n        \"source\": \"disTowerConfig\"\n    },\n    {\n        \"key\": \"leadSupportInsulatorType\",\n        \"val\": \"leadSupportInsulatorTypeVal\",\n        \"defaultVal\": \"\",\n        \"source\": \"disTowerConfig\"\n    },\n    {\n        \"key\": \"rodTowerMaterial\",\n        \"val\": \"rodTowerMaterial\",\n        \"defaultVal\": \"\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"rodTowerHeight\",\n        \"val\": \"rodHeight\",\n        \"defaultVal\": \"\",\n        \"source\": \"rodTypeModuleId\"\n    },\n    {\n        \"key\": \"loopNumber\",\n        \"val\": \"loopNumber\",\n        \"defaultVal\": \"\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"tvNumber\",\n        \"val\": \"\",\n        \"defaultVal\": \"2\",\n        \"source\": \"default\"\n    }\n]",
                "showNameVal": "moduleId#&#moduleName",
                "requestPath": "/sl/columnEquipment/codeList",
                "requiredFlag": "1",
                "defaultVal": null
            },
            {
                "condition": [
                    {
                        "name": "设备类型",
                        "key": "equipmentType",
                        "val": "隔离开关"
                    },
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "侧担杆"
                    }
                ],
                "opction": null,
                "requestFlag": "1",
                "requestMethod": "get",
                "requestParam": "[\n    {\n        \"key\": \"equipmentType\",\n        \"val\": \"equipmentType\",\n        \"defaultVal\": \"\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"moduleState\",\n        \"val\": \"\",\n        \"defaultVal\": \"新建\",\n        \"source\": \"default\"\n    },\n    {\n        \"key\": \"isolatingSwitchType\",\n        \"val\": \"isolatingSwitchTypeVal\",\n        \"defaultVal\": \"\",\n        \"source\": \"disSideConfig\"\n    },\n    {\n        \"key\": \"leadSupportInsulatorType\",\n        \"val\": \"leadSupportInsulatorTypeVal\",\n        \"defaultVal\": \"\",\n        \"source\": \"disSideConfig\"\n    },\n    {\n        \"key\": \"rodTowerMaterial\",\n        \"val\": \"rodTowerMaterial\",\n        \"defaultVal\": \"\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"shaojing\",\n        \"val\": \"shaojing\",\n        \"defaultVal\": \"\",\n        \"source\": \"rodTypeModuleId\"\n    },\n    {\n        \"key\": \"rodTowerHeight\",\n        \"val\": \"rodHeight\",\n        \"defaultVal\": \"\",\n        \"source\": \"rodTypeModuleId\"\n    },\n    {\n        \"key\": \"loopNumber\",\n        \"val\": \"loopNumber\",\n        \"defaultVal\": \"\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"tvNumber\",\n        \"val\": \"\",\n        \"defaultVal\": \"2\",\n        \"source\": \"default\"\n    }\n]",
                "showNameVal": "moduleId#&#moduleName",
                "requestPath": "/sl/columnEquipment/codeList",
                "requiredFlag": "1",
                "defaultVal": null
            },
            {
                "condition": [
                    {
                        "name": "设备类型",
                        "key": "equipmentType",
                        "val": "高压熔断器"
                    },
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "单杆"
                    }
                ],
                "opction": null,
                "requestFlag": "1",
                "requestMethod": "get",
                "requestParam": "[\n    {\n        \"key\": \"equipmentType\",\n        \"val\": \"equipmentType\",\n        \"defaultVal\": \"\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"moduleState\",\n        \"val\": \"\",\n        \"defaultVal\": \"新建\",\n        \"source\": \"default\"\n    },\n    {\n        \"key\": \"fuseType\",\n        \"val\": \"fuseTypeVal\",\n        \"defaultVal\": \"\",\n        \"source\": \"disRodConfig\"\n    },\n    {\n        \"key\": \"leadSupportInsulatorType\",\n        \"val\": \"leadSupportInsulatorTypeVal\",\n        \"defaultVal\": \"\",\n        \"source\": \"disRodConfig\"\n    },\n    {\n        \"key\": \"rodTowerMaterial\",\n        \"val\": \"rodTowerMaterial\",\n        \"defaultVal\": \"\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"shaojing\",\n        \"val\": \"shaojing\",\n        \"defaultVal\": \"\",\n        \"source\": \"rodTypeModuleId\"\n    },\n    {\n        \"key\": \"rodTowerHeight\",\n        \"val\": \"rodHeight\",\n        \"defaultVal\": \"\",\n        \"source\": \"rodTypeModuleId\"\n    },\n    {\n        \"key\": \"loopNumber\",\n        \"val\": \"loopNumber\",\n        \"defaultVal\": \"\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"tvNumber\",\n        \"val\": \"\",\n        \"defaultVal\": \"2\",\n        \"source\": \"default\"\n    }\n]",
                "showNameVal": "moduleId#&#moduleName",
                "requestPath": "/sl/columnEquipment/codeList",
                "requiredFlag": "1",
                "defaultVal": null
            },
            {
                "condition": [
                    {
                        "name": "设备类型",
                        "key": "equipmentType",
                        "val": "高压熔断器"
                    },
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "窄基塔"
                    }
                ],
                "opction": null,
                "requestFlag": "1",
                "requestMethod": "get",
                "requestParam": "[\n    {\n        \"key\": \"equipmentType\",\n        \"val\": \"equipmentType\",\n        \"defaultVal\": \"\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"moduleState\",\n        \"val\": \"\",\n        \"defaultVal\": \"新建\",\n        \"source\": \"default\"\n    },\n    {\n        \"key\": \"fuseType\",\n        \"val\": \"fuseTypeVal\",\n        \"defaultVal\": \"\",\n        \"source\": \"disTowerConfig\"\n    },\n    {\n        \"key\": \"leadSupportInsulatorType\",\n        \"val\": \"leadSupportInsulatorTypeVal\",\n        \"defaultVal\": \"\",\n        \"source\": \"disTowerConfig\"\n    },\n    {\n        \"key\": \"rodTowerMaterial\",\n        \"val\": \"rodTowerMaterial\",\n        \"defaultVal\": \"\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"rodTowerHeight\",\n        \"val\": \"rodHeight\",\n        \"defaultVal\": \"\",\n        \"source\": \"rodTypeModuleId\"\n    },\n    {\n        \"key\": \"loopNumber\",\n        \"val\": \"loopNumber\",\n        \"defaultVal\": \"\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"tvNumber\",\n        \"val\": \"\",\n        \"defaultVal\": \"2\",\n        \"source\": \"default\"\n    }\n]",
                "showNameVal": "moduleId#&#moduleName",
                "requestPath": "/sl/columnEquipment/codeList",
                "requiredFlag": "1",
                "defaultVal": null
            },
            {
                "condition": [
                    {
                        "name": "设备类型",
                        "key": "equipmentType",
                        "val": "高压熔断器"
                    },
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "侧担杆"
                    }
                ],
                "opction": null,
                "requestFlag": "1",
                "requestMethod": "get",
                "requestParam": "[\n    {\n        \"key\": \"equipmentType\",\n        \"val\": \"equipmentType\",\n        \"defaultVal\": \"\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"moduleState\",\n        \"val\": \"\",\n        \"defaultVal\": \"新建\",\n        \"source\": \"default\"\n    },\n    {\n        \"key\": \"fuseType\",\n        \"val\": \"fuseTypeVal\",\n        \"defaultVal\": \"\",\n        \"source\": \"disSideConfig\"\n    },\n    {\n        \"key\": \"leadSupportInsulatorType\",\n        \"val\": \"leadSupportInsulatorTypeVal\",\n        \"defaultVal\": \"\",\n        \"source\": \"disSideConfig\"\n    },\n    {\n        \"key\": \"rodTowerMaterial\",\n        \"val\": \"rodTowerMaterial\",\n        \"defaultVal\": \"\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"rodTowerHeight\",\n        \"val\": \"rodHeight\",\n        \"defaultVal\": \"\",\n        \"source\": \"rodTypeModuleId\"\n    },\n    {\n        \"key\": \"loopNumber\",\n        \"val\": \"loopNumber\",\n        \"defaultVal\": \"\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"tvNumber\",\n        \"val\": \"\",\n        \"defaultVal\": \"2\",\n        \"source\": \"default\"\n    }\n]",
                "showNameVal": "moduleId#&#moduleName",
                "requestPath": "/sl/columnEquipment/codeList",
                "requiredFlag": "1",
                "defaultVal": null
            },
            {
                "condition": [
                    {
                        "name": "柱上开关类型",
                        "key": "breakerType",
                        "val": "支柱式空气开关#&#接地自适应式开关#&#罐式环保气体开关"
                    },
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "单杆"
                    }
                ],
                "opction": null,
                "requestFlag": "1",
                "requestMethod": "get",
                "requestParam": "[\n    {\n        \"key\": \"equipmentType\",\n        \"val\": \"equipmentType\",\n        \"defaultVal\": \"\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"moduleState\",\n        \"val\": \"\",\n        \"defaultVal\": \"新建\",\n        \"source\": \"default\"\n    },\n    {\n        \"key\": \"breakerType\",\n        \"val\": \"breakerType\",\n        \"defaultVal\": \"\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"ftuType\",\n        \"val\": \"\",\n        \"defaultVal\": \"罩式\",\n        \"source\": \"default\"\n    },\n    {\n        \"key\": \"isolatingSwitchType\",\n        \"val\": \"isolatingSwitchTypeVal\",\n        \"defaultVal\": \"\",\n        \"source\": \"disRodConfig\"\n    },\n    {\n        \"key\": \"leadSupportInsulatorType\",\n        \"val\": \"leadSupportInsulatorTypeVal\",\n        \"defaultVal\": \"\",\n        \"source\": \"disRodConfig\"\n    },\n    {\n        \"key\": \"rodTowerMaterial\",\n        \"val\": \"rodTowerMaterial\",\n        \"defaultVal\": \"\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"shaojing\",\n        \"val\": \"shaojing\",\n        \"defaultVal\": \"\",\n        \"source\": \"rodTypeModuleId\"\n    },\n    {\n        \"key\": \"rodTowerHeight\",\n        \"val\": \"rodHeight\",\n        \"defaultVal\": \"\",\n        \"source\": \"rodTypeModuleId\"\n    },\n    {\n        \"key\": \"loopNumber\",\n        \"val\": \"loopNumber\",\n        \"defaultVal\": \"\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"tvNumber\",\n        \"val\": \"\",\n        \"defaultVal\": \"2\",\n        \"source\": \"default\"\n    }\n]",
                "showNameVal": "moduleId#&#moduleName",
                "requestPath": "/sl/columnEquipment/codeList",
                "requiredFlag": "1",
                "defaultVal": null
            },
            {
                "condition": [
                    {
                        "name": "柱上开关类型",
                        "key": "breakerType",
                        "val": "支柱式空气开关#&#接地自适应式开关#&#罐式环保气体开关"
                    },
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "窄基塔"
                    }
                ],
                "opction": null,
                "requestFlag": "1",
                "requestMethod": "get",
                "requestParam": "[\n    {\n        \"key\": \"equipmentType\",\n        \"val\": \"equipmentType\",\n        \"defaultVal\": \"\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"moduleState\",\n        \"val\": \"\",\n        \"defaultVal\": \"新建\",\n        \"source\": \"default\"\n    },\n    {\n        \"key\": \"breakerType\",\n        \"val\": \"breakerType\",\n        \"defaultVal\": \"\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"ftuType\",\n        \"val\": \"\",\n        \"defaultVal\": \"罩式\",\n        \"source\": \"default\"\n    },\n    {\n        \"key\": \"isolatingSwitchType\",\n        \"val\": \"isolatingSwitchTypeVal\",\n        \"defaultVal\": \"\",\n        \"source\": \"disTowerConfig\"\n    },\n    {\n        \"key\": \"leadSupportInsulatorType\",\n        \"val\": \"leadSupportInsulatorTypeVal\",\n        \"defaultVal\": \"\",\n        \"source\": \"disTowerConfig\"\n    },\n    {\n        \"key\": \"rodTowerMaterial\",\n        \"val\": \"rodTowerMaterial\",\n        \"defaultVal\": \"\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"rodTowerHeight\",\n        \"val\": \"rodHeight\",\n        \"defaultVal\": \"\",\n        \"source\": \"rodTypeModuleId\"\n    },\n    {\n        \"key\": \"loopNumber\",\n        \"val\": \"loopNumber\",\n        \"defaultVal\": \"\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"tvNumber\",\n        \"val\": \"\",\n        \"defaultVal\": \"2\",\n        \"source\": \"default\"\n    }\n]",
                "showNameVal": "moduleId#&#moduleName",
                "requestPath": "/sl/columnEquipment/codeList",
                "requiredFlag": "1",
                "defaultVal": null
            },
            {
                "condition": [
                    {
                        "name": "柱上开关类型",
                        "key": "breakerType",
                        "val": "支柱式空气开关#&#接地自适应式开关#&#罐式环保气体开关"
                    },
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "侧担杆"
                    }
                ],
                "opction": null,
                "requestFlag": "1",
                "requestMethod": "get",
                "requestParam": "[\n    {\n        \"key\": \"equipmentType\",\n        \"val\": \"equipmentType\",\n        \"defaultVal\": \"\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"moduleState\",\n        \"val\": \"\",\n        \"defaultVal\": \"新建\",\n        \"source\": \"default\"\n    },\n    {\n        \"key\": \"breakerType\",\n        \"val\": \"breakerType\",\n        \"defaultVal\": \"\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"ftuType\",\n        \"val\": \"\",\n        \"defaultVal\": \"罩式\",\n        \"source\": \"default\"\n    },\n    {\n        \"key\": \"isolatingSwitchType\",\n        \"val\": \"isolatingSwitchTypeVal\",\n        \"defaultVal\": \"\",\n        \"source\": \"disSideConfig\"\n    },\n    {\n        \"key\": \"leadSupportInsulatorType\",\n        \"val\": \"leadSupportInsulatorTypeVal\",\n        \"defaultVal\": \"\",\n        \"source\": \"disSideConfig\"\n    },\n    {\n        \"key\": \"rodTowerMaterial\",\n        \"val\": \"rodTowerMaterial\",\n        \"defaultVal\": \"\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"shaojing\",\n        \"val\": \"shaojing\",\n        \"defaultVal\": \"\",\n        \"source\": \"rodTypeModuleId\"\n    },\n    {\n        \"key\": \"rodTowerHeight\",\n        \"val\": \"rodHeight\",\n        \"defaultVal\": \"\",\n        \"source\": \"rodTypeModuleId\"\n    },\n    {\n        \"key\": \"loopNumber\",\n        \"val\": \"loopNumber\",\n        \"defaultVal\": \"\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"tvNumber\",\n        \"val\": \"\",\n        \"defaultVal\": \"2\",\n        \"source\": \"default\"\n    }\n]",
                "showNameVal": "moduleId#&#moduleName",
                "requestPath": "/sl/columnEquipment/codeList",
                "requiredFlag": "1",
                "defaultVal": null
            }
        ]
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6292,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "柱上设备及附件配置",
        "optionName": "接地材质",
        "optionContent": null,
        "optionContentType": "object",
        "showNameVal": "groundMaterial#&#groundMaterial",
        "defaultVal": null,
        "fieldName": "groundMaterial",
        "componentType": "2",
        "requestFlag": "1",
        "requestMethod": "get",
        "requestPath": "/sl/grounding/getGroundMaterial",
        "requestParam": null,
        "requiredFlag": "0",
        "width": "9%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "groundMaterial",
        "name": "接地材质",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6293,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "柱上设备及附件配置",
        "optionName": "接地类型",
        "optionContent": null,
        "optionContentType": "object",
        "showNameVal": "groundApplyType#&#groundApplyType",
        "defaultVal": null,
        "fieldName": "groundApplyType",
        "componentType": "2",
        "requestFlag": "1",
        "requestMethod": "get",
        "requestPath": "/sl/grounding/getGroundApplyType",
        "requestParam": "[\n    {\n        \"key\": \"groundMaterial\",\n        \"val\": \"groundMaterial\",\n        \"source\": \"this\"\n    }\n]",
        "requiredFlag": "0",
        "width": "9%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "groundApplyType",
        "name": "接地类型",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6294,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "柱上设备及附件配置",
        "optionName": "接地装置型号",
        "optionContent": null,
        "optionContentType": "object",
        "showNameVal": "moduleId#&#moduleCode",
        "defaultVal": null,
        "fieldName": "groundingModuleId",
        "componentType": "2",
        "requestFlag": "1",
        "requestMethod": "get",
        "requestPath": "/sl/grounding/listNoPage",
        "requestParam": "[\n    {\n        \"key\": \"groundMaterial\",\n        \"val\": \"groundMaterial\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"groundApplyType\",\n        \"val\": \"groundApplyType\",\n        \"source\": \"this\"\n    }\n]",
        "requiredFlag": "0",
        "width": "9%",
        "isLeft": "0",
        "conditionList": "[\n    {\n\n\"name\": \"接地材质\",\n\n\"key\": \"groundMaterial\",\n\n\"val\": \"\"\n    },\n    {\n\n\"name\": \"接地类型\",\n\n\"key\": \"groundApplyType\",\n\n\"val\": \"\"\n    }\n]",
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "groundingModuleId",
        "name": "接地装置型号",
        "conditionMap": [
            {
                "condition": [
                    {
                        "name": "接地材质",
                        "key": "groundMaterial",
                        "val": ""
                    },
                    {
                        "name": "接地类型",
                        "key": "groundApplyType",
                        "val": ""
                    }
                ],
                "opction": null,
                "requestFlag": "1",
                "requestMethod": "get",
                "requestParam": "[\n    {\n        \"key\": \"groundMaterial\",\n        \"val\": \"groundMaterial\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"groundApplyType\",\n        \"val\": \"groundApplyType\",\n        \"source\": \"this\"\n    }\n]",
                "showNameVal": "moduleId#&#moduleCode",
                "requestPath": "/sl/grounding/listNoPage",
                "requiredFlag": "0",
                "defaultVal": null
            }
        ]
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6295,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "柱上设备及附件配置",
        "optionName": "备注",
        "optionContent": null,
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "equipmentNote",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "3%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "equipmentNote",
        "name": "备注",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6296,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "杆塔组立",
        "optionName": "杆塔位置",
        "optionContent": "土路#&#绿化带#&#人行道#&#机动车道#&#辅道#&#非机动车道#&#乡村道路",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": "土路",
        "fieldName": "rodTowerPoint",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "1",
        "width": "5%",
        "isLeft": "0",
        "conditionList": "[\n    {\n        \"name\": \"杆塔状态\",\n        \"key\": \"moduleState\",\n        \"val\": \"新建\"\n    },\n    {\n        \"name\": \"杆塔结构\",\n        \"key\": \"rodTowerMaterial\",\n        \"val\": \"单杆#&#侧担杆#&#双杆#&#窄基塔#&#钢管杆#&#宽基塔\"\n    }\n]",
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "rodTowerPoint",
        "name": "杆塔位置",
        "conditionMap": [
            {
                "condition": [
                    {
                        "name": "杆塔状态",
                        "key": "moduleState",
                        "val": "新建"
                    },
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "单杆#&#侧担杆#&#双杆#&#窄基塔#&#钢管杆#&#宽基塔"
                    }
                ],
                "opction": "土路#&#绿化带#&#人行道#&#机动车道#&#辅道#&#非机动车道#&#乡村道路",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "1",
                "defaultVal": "土路"
            }
        ]
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6297,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "杆塔组立",
        "optionName": "基础路面结构类型",
        "optionContent": "土路",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": "土路",
        "fieldName": "groundType",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "1",
        "width": "5%",
        "isLeft": "0",
        "conditionList": "[\n    {\n        \"name\": \"杆塔状态\",\n        \"key\": \"moduleState\",\n        \"val\": \"新建\"\n    },\n    {\n        \"name\": \"杆塔结构\",\n        \"key\": \"rodTowerMaterial\",\n        \"val\": \"单杆#&#侧担杆#&#双杆#&#窄基塔#&#钢管杆#&#宽基塔\"\n    },\n    {\n        \"name\": \"杆塔位置\",\n        \"key\": \"rodTowerPoint\",\n        \"val\": \"土路\"\n    }\n]",
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "groundType",
        "name": "基础路面结构类型",
        "conditionMap": [
            {
                "condition": [
                    {
                        "name": "杆塔状态",
                        "key": "moduleState",
                        "val": "新建"
                    },
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "单杆#&#侧担杆#&#双杆#&#窄基塔#&#钢管杆#&#宽基塔"
                    },
                    {
                        "name": "杆塔位置",
                        "key": "rodTowerPoint",
                        "val": "土路"
                    }
                ],
                "opction": "土路",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "1",
                "defaultVal": "土路"
            },
            {
                "condition": [
                    {
                        "name": "杆塔状态",
                        "key": "moduleState",
                        "val": "新建"
                    },
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "单杆#&#侧担杆#&#双杆#&#窄基塔#&#钢管杆#&#宽基塔"
                    },
                    {
                        "name": "杆塔位置",
                        "key": "rodTowerPoint",
                        "val": "机动车道#&#辅道#&#非机动车道"
                    }
                ],
                "opction": "沥青#&#水泥",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "1",
                "defaultVal": "水泥"
            },
            {
                "condition": [
                    {
                        "name": "杆塔状态",
                        "key": "moduleState",
                        "val": "新建"
                    },
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "单杆#&#侧担杆#&#双杆#&#窄基塔#&#钢管杆#&#宽基塔"
                    },
                    {
                        "name": "杆塔位置",
                        "key": "rodTowerPoint",
                        "val": "人行道"
                    }
                ],
                "opction": "透水砖#&#花岗岩板材",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "1",
                "defaultVal": "透水砖"
            },
            {
                "condition": [
                    {
                        "name": "杆塔状态",
                        "key": "moduleState",
                        "val": "新建"
                    },
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "单杆#&#侧担杆#&#双杆#&#窄基塔#&#钢管杆#&#宽基塔"
                    },
                    {
                        "name": "杆塔位置",
                        "key": "rodTowerPoint",
                        "val": "乡村道路"
                    }
                ],
                "opction": "沥青#&#水泥#&#水泥路面(简易)",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "1",
                "defaultVal": "水泥"
            },
            {
                "condition": [
                    {
                        "name": "杆塔状态",
                        "key": "moduleState",
                        "val": "新建"
                    },
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "单杆#&#侧担杆#&#双杆#&#窄基塔#&#钢管杆#&#宽基塔"
                    },
                    {
                        "name": "杆塔位置",
                        "key": "rodTowerPoint",
                        "val": "绿化带"
                    }
                ],
                "opction": "绿化带",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "1",
                "defaultVal": "绿化带"
            }
        ]
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6302,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "杆塔组立",
        "optionName": "地质情况",
        "optionContent": "Ⅰ类土(松软土)#&#Ⅱ类土(普通土)#&#Ⅲ类土(坚土)#&#Ⅳ类土(砂砾土)#&#淤泥#&#流砂#&#极软岩#&#软岩#&#较软岩#&#较坚硬岩#&#坚硬岩",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": "Ⅱ类土(普通土)",
        "fieldName": "geoCase",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "1",
        "width": "5%",
        "isLeft": "0",
        "conditionList": "[\n    {\n        \"name\": \"杆塔状态\",\n        \"key\": \"moduleState\",\n        \"val\": \"新建\"\n    },\n    {\n        \"name\": \"杆塔结构\",\n        \"key\": \"rodTowerMaterial\",\n        \"val\": \"单杆#&#侧担杆#&#双杆#&#窄基塔#&#钢管杆#&#宽基塔\"\n    }\n]",
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "geoCase",
        "name": "地质情况",
        "conditionMap": [
            {
                "condition": [
                    {
                        "name": "杆塔状态",
                        "key": "moduleState",
                        "val": "新建"
                    },
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "单杆#&#侧担杆#&#双杆#&#窄基塔#&#钢管杆#&#宽基塔"
                    }
                ],
                "opction": "Ⅰ类土(松软土)#&#Ⅱ类土(普通土)#&#Ⅲ类土(坚土)#&#Ⅳ类土(砂砾土)#&#淤泥#&#流砂#&#极软岩#&#软岩#&#较软岩#&#较坚硬岩#&#坚硬岩",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "1",
                "defaultVal": "Ⅱ类土(普通土)"
            }
        ]
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6303,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "杆塔基础配置",
        "optionName": "基础类型",
        "optionContent": "直埋式#&#底卡盘#&#套筒无筋式#&#套筒翼板式#&#套筒桩式#&#台阶式",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": "直埋式",
        "fieldName": "baseType",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "8%",
        "isLeft": "0",
        "conditionList": "[\n    {\n\n\"name\": \"杆塔结构\",\n\n\"key\": \"rodTowerMaterial\",\n\n\"val\": \"单杆#&#侧担杆\"\n    } \n]",
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "baseType",
        "name": "基础类型",
        "conditionMap": [
            {
                "condition": [
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "单杆#&#侧担杆"
                    }
                ],
                "opction": "直埋式#&#底卡盘#&#套筒无筋式#&#套筒翼板式#&#套筒桩式#&#台阶式",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "0",
                "defaultVal": "直埋式"
            },
            {
                "condition": [
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "双杆"
                    }
                ],
                "opction": "直埋式#&#套筒无筋式#&#套筒翼板式#&#套筒桩式#&#台阶式",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "0",
                "defaultVal": "直埋式"
            },
            {
                "condition": [
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "窄基塔"
                    }
                ],
                "opction": "台阶式#&#灌注桩",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "0",
                "defaultVal": null
            },
            {
                "condition": [
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "宽基塔"
                    }
                ],
                "opction": "台阶式#&#板式#&#掏挖基础#&#灌注桩",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "0",
                "defaultVal": null
            },
            {
                "condition": [
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "钢管杆"
                    }
                ],
                "opction": "台阶式#&#灌注桩#&#钢管桩",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "0",
                "defaultVal": null
            }
        ]
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6308,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "杆塔基础配置",
        "optionName": "底盘代号",
        "optionContent": "DP-8#&#DP-10#&#DP-12",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "kpCode",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "8%",
        "isLeft": "0",
        "conditionList": "[\n    {\n\n\"name\": \"基础类型\",\n\n\"key\": \"baseType\",\n\n\"val\": \"底卡盘\"\n    } \n]",
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "kpCode",
        "name": "底盘代号",
        "conditionMap": [
            {
                "condition": [
                    {
                        "name": "基础类型",
                        "key": "baseType",
                        "val": "底卡盘"
                    }
                ],
                "opction": "DP-8#&#DP-10#&#DP-12",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "0",
                "defaultVal": null
            }
        ]
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6309,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "杆塔基础配置",
        "optionName": "卡盘数量",
        "optionContent": "0#&#2#&#4",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "kpCount",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "8%",
        "isLeft": "0",
        "conditionList": "[\n    {\n\n\"name\": \"基础类型\",\n\n\"key\": \"baseType\",\n\n\"val\": \"底卡盘\"\n    } \n]",
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "kpCount",
        "name": "卡盘数量",
        "conditionMap": [
            {
                "condition": [
                    {
                        "name": "基础类型",
                        "key": "baseType",
                        "val": "底卡盘"
                    }
                ],
                "opction": "0#&#2#&#4",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "0",
                "defaultVal": null
            }
        ]
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6310,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "杆塔基础配置",
        "optionName": "防撞配置",
        "optionContent": "塑料防撞墩#&#防撞标贴",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "antiConfig",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "9%",
        "isLeft": "0",
        "conditionList": "[\n    {\n\n\"name\": \"杆塔结构\",\n\n\"key\": \"rodTowerMaterial\",\n\n\"val\": \"单杆#&#双杆#&#侧担杆\"\n    } \n]",
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "antiConfig",
        "name": "防撞配置",
        "conditionMap": [
            {
                "condition": [
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "单杆#&#双杆#&#侧担杆"
                    }
                ],
                "opction": "塑料防撞墩#&#防撞标贴",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "0",
                "defaultVal": null
            }
        ]
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6311,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "杆塔基础配置",
        "optionName": "备注",
        "optionContent": null,
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "towerSettingNote",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": null,
        "width": "10%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "towerSettingNote",
        "name": "备注",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6312,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "宽基塔塔腿",
        "optionName": "宽基塔A腿高",
        "optionContent": "0#&#-1#&#-2",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "legA",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "1",
        "width": "8%",
        "isLeft": "0",
        "conditionList": "[\n    {\n\n\"name\": \"杆塔结构\",\n\n\"key\": \"rodTowerMaterial\",\n\n\"val\": \"宽基塔\"\n    } \n]",
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "legA",
        "name": "宽基塔A腿高",
        "conditionMap": [
            {
                "condition": [
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "宽基塔"
                    }
                ],
                "opction": "0#&#-1#&#-2",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "1",
                "defaultVal": null
            }
        ]
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6313,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "宽基塔塔腿",
        "optionName": "宽基塔B腿高",
        "optionContent": "0#&#-1#&#-2",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "legB",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "1",
        "width": "8%",
        "isLeft": "0",
        "conditionList": "[\n    {\n\n\"name\": \"杆塔结构\",\n\n\"key\": \"rodTowerMaterial\",\n\n\"val\": \"宽基塔\"\n    } \n]",
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "legB",
        "name": "宽基塔B腿高",
        "conditionMap": [
            {
                "condition": [
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "宽基塔"
                    }
                ],
                "opction": "0#&#-1#&#-2",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "1",
                "defaultVal": null
            }
        ]
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6314,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "宽基塔塔腿",
        "optionName": "宽基塔C腿高",
        "optionContent": "0#&#-1#&#-2",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "legC",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "1",
        "width": "8%",
        "isLeft": "0",
        "conditionList": "[\n    {\n\n\"name\": \"杆塔结构\",\n\n\"key\": \"rodTowerMaterial\",\n\n\"val\": \"宽基塔\"\n    } \n]",
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "legC",
        "name": "宽基塔C腿高",
        "conditionMap": [
            {
                "condition": [
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "宽基塔"
                    }
                ],
                "opction": "0#&#-1#&#-2",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "1",
                "defaultVal": null
            }
        ]
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6315,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "宽基塔塔腿",
        "optionName": "宽基塔D腿高",
        "optionContent": "0#&#-1#&#-2",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "legD",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "1",
        "width": "8%",
        "isLeft": "0",
        "conditionList": "[\n    {\n\n\"name\": \"杆塔结构\",\n\n\"key\": \"rodTowerMaterial\",\n\n\"val\": \"宽基塔\"\n    } \n]",
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "legD",
        "name": "宽基塔D腿高",
        "conditionMap": [
            {
                "condition": [
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "宽基塔"
                    }
                ],
                "opction": "0#&#-1#&#-2",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "1",
                "defaultVal": null
            }
        ]
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6316,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "宽基塔塔腿",
        "optionName": "备注",
        "optionContent": null,
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "towerLegNote",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "8%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "towerLegNote",
        "name": "备注",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6317,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "电缆参数配置",
        "optionName": "电缆编号",
        "optionContent": null,
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "cableNo",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "cableNo",
        "name": "电缆编号",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6318,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "电缆参数配置",
        "optionName": "电缆名称",
        "optionContent": null,
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "cableName",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "cableName",
        "name": "电缆名称",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6319,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "电缆参数配置",
        "optionName": "终端头型号",
        "optionContent": null,
        "optionContentType": "object",
        "showNameVal": "moduleId#&#moduleName",
        "defaultVal": null,
        "fieldName": "terminalHeadId",
        "componentType": "2",
        "requestFlag": "1",
        "requestMethod": "get",
        "requestPath": "/sl/module/getTerminalHeadModuleList",
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "terminalHeadId",
        "name": "终端头型号",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6320,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "电缆参数配置",
        "optionName": "终端头数量",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "terminalHeadCount",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "3%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "terminalHeadCount",
        "name": "终端头数量",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6321,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "电缆参数配置",
        "optionName": "中间接头型号",
        "optionContent": null,
        "optionContentType": "object",
        "showNameVal": "moduleId#&#moduleName",
        "defaultVal": null,
        "fieldName": "intermediateJointId",
        "componentType": "2",
        "requestFlag": "1",
        "requestMethod": "get",
        "requestPath": "/sl/module/getIntermediateJointModuleList",
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "intermediateJointId",
        "name": "中间接头型号",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6322,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "电缆参数配置",
        "optionName": "中间接头数量",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "intermediateJointCount",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "3%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "intermediateJointCount",
        "name": "中间接头数量",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6323,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "电缆参数配置",
        "optionName": "防火封堵材质",
        "optionContent": null,
        "optionContentType": "object",
        "showNameVal": "blockingMaterial#&#blockingMaterial",
        "defaultVal": null,
        "fieldName": "blockingMaterial",
        "componentType": "2",
        "requestFlag": "1",
        "requestMethod": "get",
        "requestPath": "/sl/blockingMatch/getMaterial",
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "blockingMaterial",
        "name": "防火封堵材质",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6324,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "电缆参数配置",
        "optionName": "防火封堵型号",
        "optionContent": null,
        "optionContentType": "object",
        "showNameVal": "materialId#&#description",
        "defaultVal": null,
        "fieldName": "blockingId",
        "componentType": "2",
        "requestFlag": "1",
        "requestMethod": "get",
        "requestPath": "/sl/blockingMatch/getBlockingList",
        "requestParam": "[\n    {\n\n\"key\": \"blockingMaterial\",\n\n\"val\": \"blockingMaterial\",\n\n\"source\": \"this\"\n    }\n]",
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": "[\n    {\n\n\"name\": \"防火封堵材质\",\n\n\"key\": \"blockingMaterial\",\n\n\"val\": \"\"\n    }\n]",
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "blockingId",
        "name": "防火封堵型号",
        "conditionMap": [
            {
                "condition": [
                    {
                        "name": "防火封堵材质",
                        "key": "blockingMaterial",
                        "val": ""
                    }
                ],
                "opction": null,
                "requestFlag": "1",
                "requestMethod": "get",
                "requestParam": "[\n    {\n\n\"key\": \"blockingMaterial\",\n\n\"val\": \"blockingMaterial\",\n\n\"source\": \"this\"\n    }\n]",
                "showNameVal": "materialId#&#description",
                "requestPath": "/sl/blockingMatch/getBlockingList",
                "requiredFlag": "0",
                "defaultVal": null
            }
        ]
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6325,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "电缆参数配置",
        "optionName": "防火封堵孔数",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "blockingCount",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "3%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "blockingCount",
        "name": "防火封堵孔数",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6326,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "电缆参数配置",
        "optionName": "电缆标识牌数量",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "signageCount",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "3%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "signageCount",
        "name": "电缆标识牌数量",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6327,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "电缆参数配置",
        "optionName": "电缆预留备注",
        "optionContent": null,
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "resNote",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "8%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "resNote",
        "name": "电缆预留备注",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6328,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "电缆参数配置",
        "optionName": "备注",
        "optionContent": null,
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "cableNote",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "8%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "cableNote",
        "name": "备注",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6329,
        "optionOrder": null,
        "paramType": "造价参数",
        "optionType": "杆塔组立",
        "optionName": "混凝土杆立杆方式",
        "optionContent": "打洞立杆机#&#非打洞立杆机",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": "非打洞立杆机",
        "fieldName": "rodMethod",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "1",
        "width": "5%",
        "isLeft": "0",
        "conditionList": "[\n    {\n\n\"name\": \"杆塔状态\",\n\n\"key\": \"moduleState\",\n\n\"val\": \"新建\"\n    },\n    {\n\n\"name\": \"杆塔结构\",\n\n\"key\": \"rodTowerMaterial\",\n\n\"val\": \"单杆#&#双杆#&#侧担杆\"\n    }\n]",
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "rodMethod",
        "name": "混凝土杆立杆方式",
        "conditionMap": [
            {
                "condition": [
                    {
                        "name": "杆塔状态",
                        "key": "moduleState",
                        "val": "新建"
                    },
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "单杆#&#双杆#&#侧担杆"
                    }
                ],
                "opction": "打洞立杆机#&#非打洞立杆机",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "1",
                "defaultVal": "非打洞立杆机"
            }
        ]
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6330,
        "optionOrder": null,
        "paramType": "造价参数",
        "optionType": "杆塔组立",
        "optionName": "杆塔坑开挖方式",
        "optionContent": "人工#&#机械#&#爆破",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": "机械",
        "fieldName": "digMethod",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "1",
        "width": "5%",
        "isLeft": "0",
        "conditionList": "[\n    {\n\n\"name\": \"杆塔状态\",\n\n\"key\": \"moduleState\",\n\n\"val\": \"新建\"\n    },\n    {\n\n\"name\": \"杆塔结构\",\n\n\"key\": \"rodTowerMaterial\",\n\n\"val\": \"单杆#&#双杆#&#侧担杆\"\n    },\n    {\n\n\"name\": \"混凝土杆立杆方式\",\n\n\"key\": \"rodMethod\",\n\n\"val\": \"非打洞立杆机\"\n    }\n]",
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "digMethod",
        "name": "杆塔坑开挖方式",
        "conditionMap": [
            {
                "condition": [
                    {
                        "name": "杆塔状态",
                        "key": "moduleState",
                        "val": "新建"
                    },
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "单杆#&#双杆#&#侧担杆"
                    },
                    {
                        "name": "混凝土杆立杆方式",
                        "key": "rodMethod",
                        "val": "非打洞立杆机"
                    }
                ],
                "opction": "人工#&#机械#&#爆破",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "1",
                "defaultVal": "机械"
            },
            {
                "condition": [
                    {
                        "name": "杆塔状态",
                        "key": "moduleState",
                        "val": "新建"
                    },
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "窄基塔#&#钢管杆#&#宽基塔"
                    }
                ],
                "opction": "人工#&#机械#&#爆破",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "1",
                "defaultVal": "机械"
            }
        ]
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6332,
        "optionOrder": null,
        "paramType": "造价参数",
        "optionType": "杆塔组立",
        "optionName": "杆塔坑开挖方案",
        "optionContent": "支挡土板#&#放坡开挖",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": "放坡开挖",
        "fieldName": "digPlan",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "1",
        "width": "5%",
        "isLeft": "0",
        "conditionList": "[\n    {\n\n\"name\": \"地质情况\",\n\n\"key\": \"geoCase\",\n\n\"val\": \"Ⅰ类土(松软土)#&#Ⅱ类土(普通土)#&#Ⅲ类土(坚土)#&#Ⅳ类土(砂砾土)\"\n    },\n    {\n\n\"name\": \"杆塔结构\",\n\n\"key\": \"rodTowerMaterial\",\n\n\"val\": \"单杆#&#双杆#&#侧担杆\"\n    },\n    {\n\n\"name\": \"混凝土杆立杆方式\",\n\n\"key\": \"rodMethod\",\n\n\"val\": \"非打洞立杆机\"\n    },\n    {\n\n\"name\": \"杆塔坑开挖方式\",\n\n\"key\": \"digMethod\",\n\n\"val\": \"人工#&#机械\"\n    }\n]",
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "digPlan",
        "name": "杆塔坑开挖方案",
        "conditionMap": [
            {
                "condition": [
                    {
                        "name": "地质情况",
                        "key": "geoCase",
                        "val": "Ⅰ类土(松软土)#&#Ⅱ类土(普通土)#&#Ⅲ类土(坚土)#&#Ⅳ类土(砂砾土)"
                    },
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "单杆#&#双杆#&#侧担杆"
                    },
                    {
                        "name": "混凝土杆立杆方式",
                        "key": "rodMethod",
                        "val": "非打洞立杆机"
                    },
                    {
                        "name": "杆塔坑开挖方式",
                        "key": "digMethod",
                        "val": "人工#&#机械"
                    }
                ],
                "opction": "支挡土板#&#放坡开挖",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "1",
                "defaultVal": "放坡开挖"
            },
            {
                "condition": [
                    {
                        "name": "地质情况",
                        "key": "geoCase",
                        "val": "Ⅰ类土(松软土)#&#Ⅱ类土(普通土)#&#Ⅲ类土(坚土)#&#Ⅳ类土(砂砾土)"
                    },
                    {
                        "name": "杆塔结构",
                        "key": "rodTowerMaterial",
                        "val": "窄基塔#&#钢管杆#&#宽基塔"
                    },
                    {
                        "name": "杆塔坑开挖方式",
                        "key": "digMethod",
                        "val": "人工#&#机械"
                    }
                ],
                "opction": "支挡土板#&#放坡开挖",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "1",
                "defaultVal": "放坡开挖"
            }
        ]
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6334,
        "optionOrder": null,
        "paramType": "造价参数",
        "optionType": "杆塔组立",
        "optionName": "备注",
        "optionContent": null,
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "costParamNote",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "costParamNote",
        "name": "备注",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6335,
        "optionOrder": null,
        "paramType": "造价参数",
        "optionType": "电缆敷设",
        "optionName": "直埋(m)",
        "optionContent": null,
        "optionContentType": "number",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "directBurial",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "6%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "directBurial",
        "name": "直埋(m)",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6336,
        "optionOrder": null,
        "paramType": "造价参数",
        "optionType": "电缆敷设",
        "optionName": "电缆沟(隧)道(m)",
        "optionContent": null,
        "optionContentType": "number",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "cableTrench",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "6%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "cableTrench",
        "name": "电缆沟(隧)道(m)",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6337,
        "optionOrder": null,
        "paramType": "造价参数",
        "optionType": "电缆敷设",
        "optionName": "排管内(m)",
        "optionContent": null,
        "optionContentType": "number",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "pipeLaying",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "6%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "pipeLaying",
        "name": "排管内(m)",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6338,
        "optionOrder": null,
        "paramType": "造价参数",
        "optionType": "电缆敷设",
        "optionName": "沿支架、墙面卡设(m)",
        "optionContent": null,
        "optionContentType": "number",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "support",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "6%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "support",
        "name": "沿支架、墙面卡设(m)",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6339,
        "optionOrder": null,
        "paramType": "造价参数",
        "optionType": "电缆敷设",
        "optionName": "沿桥架(m)",
        "optionContent": null,
        "optionContentType": "number",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "cableTray",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "6%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "cableTray",
        "name": "沿桥架(m)",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6340,
        "optionOrder": null,
        "paramType": "造价参数",
        "optionType": "电缆敷设",
        "optionName": "竖直通道(m)",
        "optionContent": null,
        "optionContentType": "number",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "channel",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "6%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "channel",
        "name": "竖直通道(m)",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6341,
        "optionOrder": null,
        "paramType": "造价参数",
        "optionType": "电缆敷设",
        "optionName": "电缆上杆或进、出设备柜(m)",
        "optionContent": null,
        "optionContentType": "number",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "cableOnPole",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "6%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "cableOnPole",
        "name": "电缆上杆或进、出设备柜(m)",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6342,
        "optionOrder": null,
        "paramType": "造价参数",
        "optionType": "电缆敷设",
        "optionName": "电缆调试说明",
        "optionContent": "第一回路#&#第二回路起",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": "第一回路",
        "fieldName": "cableDescribe",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "6%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "cableDescribe",
        "name": "电缆调试说明",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6343,
        "optionOrder": null,
        "paramType": "造价参数",
        "optionType": "电缆敷设",
        "optionName": "备注",
        "optionContent": null,
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "layNote",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "6%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "layNote",
        "name": "备注",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6344,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "环网箱",
        "optionName": "性能等级",
        "optionContent": "高性能#&#普通型",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "hwxPerformanceLevel",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "10%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "hwxPerformanceLevel",
        "name": "性能等级",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6345,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "环网箱",
        "optionName": "设备间隔",
        "optionContent": "二进二出#&#二进四出",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "hwxEquipmentSpacing",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "10%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "hwxEquipmentSpacing",
        "name": "设备间隔",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6346,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "环网箱",
        "optionName": "是否带应急接口",
        "optionContent": "是#&#否",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "hwxIsInterface",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "10%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "hwxIsInterface",
        "name": "是否带应急接口",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6347,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "环网箱",
        "optionName": "备注",
        "optionContent": null,
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "hwxNote",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "10%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "hwxNote",
        "name": "备注",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6348,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "箱式变电站",
        "optionName": "适用类型",
        "optionContent": "内陆型#&#沿海型",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "xsbdzApplyType",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "10%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "xsbdzApplyType",
        "name": "适用类型",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6349,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "箱式变电站",
        "optionName": "设备规格",
        "optionContent": "标准型#&#紧凑型",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "xsbdzEquipmentSpecifications",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "10%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "xsbdzEquipmentSpecifications",
        "name": "设备规格",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6350,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "箱式变电站",
        "optionName": "设备类型",
        "optionContent": "环网型#&#终端型",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "xsbdzEquipmentType",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "10%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "xsbdzEquipmentType",
        "name": "设备类型",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6351,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "箱式变电站",
        "optionName": "变压器容量",
        "optionContent": "400#&#630",
        "optionContentType": "int",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "xsbdzTransformerCapacity",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "10%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "xsbdzTransformerCapacity",
        "name": "变压器容量",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6352,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "箱式变电站",
        "optionName": "备注",
        "optionContent": null,
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "xsbdzNote",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "10%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "xsbdzNote",
        "name": "备注",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6353,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "双杆变",
        "optionName": "柱上变压器状态",
        "optionContent": "新建#&#原有",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "sgzsbyqState",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "sgzsbyqState",
        "name": "柱上变压器状态",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6354,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "双杆变",
        "optionName": "应用场景",
        "optionContent": "内陆型#&#沿海型",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "sgzsbyqScene",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "sgzsbyqScene",
        "name": "应用场景",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6355,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "双杆变",
        "optionName": "是否成套",
        "optionContent": "成套#&#非成套",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "sgzsbyqIsComplete",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "sgzsbyqIsComplete",
        "name": "是否成套",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6356,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "双杆变",
        "optionName": "变压器类型",
        "optionContent": "SZBH21#&#SBH21#&#SBH25#&#SZBH25#&#SZ20#&#S20",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "sgzsbyqType",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "sgzsbyqType",
        "name": "变压器类型",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6357,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "双杆变",
        "optionName": "变压器容量",
        "optionContent": "100kVA#&#200kVA#&#400kVA",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "sgzsbyqCapacity",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": "[\n    {\n\n\"name\": \"是否成套\",\n\n\"key\": \"sgzsbyqIsComplete\",\n\n\"val\": \"成套\"\n    } \n]",
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "sgzsbyqCapacity",
        "name": "变压器容量",
        "conditionMap": [
            {
                "condition": [
                    {
                        "name": "是否成套",
                        "key": "sgzsbyqIsComplete",
                        "val": "成套"
                    }
                ],
                "opction": "100kVA#&#200kVA#&#400kVA",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "0",
                "defaultVal": null
            },
            {
                "condition": [
                    {
                        "name": "是否成套",
                        "key": "sgzsbyqIsComplete",
                        "val": "非成套"
                    }
                ],
                "opction": "100kVA#&#200kVA#&#400kVA#&#630kVA",
                "requestFlag": "0",
                "requestMethod": null,
                "requestParam": null,
                "showNameVal": null,
                "requestPath": null,
                "requiredFlag": "0",
                "defaultVal": null
            }
        ]
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6359,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "双杆变",
        "optionName": "接地材质",
        "optionContent": "角钢#&#镀铜",
        "optionContentType": "object",
        "showNameVal": "groundMaterial#&#groundMaterial",
        "defaultVal": null,
        "fieldName": "sgzsbyqJdcz",
        "componentType": "2",
        "requestFlag": "1",
        "requestMethod": "get",
        "requestPath": "/sl/grounding/getGroundMaterial",
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": "[\n    {\n\n\"name\": \"是否成套\",\n\n\"key\": \"sgzsbyqIsComplete\",\n\n\"val\": \"非成套\"\n    } \n]",
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "sgzsbyqJdcz",
        "name": "接地材质",
        "conditionMap": [
            {
                "condition": [
                    {
                        "name": "是否成套",
                        "key": "sgzsbyqIsComplete",
                        "val": "非成套"
                    }
                ],
                "opction": "角钢#&#镀铜",
                "requestFlag": "1",
                "requestMethod": "get",
                "requestParam": null,
                "showNameVal": "groundMaterial#&#groundMaterial",
                "requestPath": "/sl/grounding/getGroundMaterial",
                "requiredFlag": "0",
                "defaultVal": null
            }
        ]
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6360,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "双杆变",
        "optionName": "接地装置型号",
        "optionContent": null,
        "optionContentType": "object",
        "showNameVal": "moduleId#&#moduleCode",
        "defaultVal": null,
        "fieldName": "sgzsbyqJdModuleId",
        "componentType": "2",
        "requestFlag": "1",
        "requestMethod": "get",
        "requestPath": "/sl/grounding/listNoPage",
        "requestParam": "[\n    {\n        \"key\": \"groundMaterial\",\n        \"val\": \"sgzsbyqJdcz\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"installPosition\",\n        \"val\": \"\",\n        \"defaultVal\": \"柱上变压器\",\n        \"source\": \"default\"\n    }\n]",
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": "[\n    {\n\n\"name\": \"接地材质\",\n\n\"key\": \"sgzsbyqJdcz\",\n\n\"val\": \"\"\n    }\n]",
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "sgzsbyqJdModuleId",
        "name": "接地装置型号",
        "conditionMap": [
            {
                "condition": [
                    {
                        "name": "接地材质",
                        "key": "sgzsbyqJdcz",
                        "val": ""
                    }
                ],
                "opction": null,
                "requestFlag": "1",
                "requestMethod": "get",
                "requestParam": "[\n    {\n        \"key\": \"groundMaterial\",\n        \"val\": \"sgzsbyqJdcz\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"installPosition\",\n        \"val\": \"\",\n        \"defaultVal\": \"柱上变压器\",\n        \"source\": \"default\"\n    }\n]",
                "showNameVal": "moduleId#&#moduleCode",
                "requestPath": "/sl/grounding/listNoPage",
                "requiredFlag": "0",
                "defaultVal": null
            }
        ]
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6361,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "双杆变",
        "optionName": "备注",
        "optionContent": null,
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "sgzsbyqNote",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "sgzsbyqNote",
        "name": "备注",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6362,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "单杆变",
        "optionName": "柱上变压器状态",
        "optionContent": "新建#&#原有",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "dgzsbyqState",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "dgzsbyqState",
        "name": "柱上变压器状态",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6363,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "单杆变",
        "optionName": "应用场景",
        "optionContent": "内陆型#&#沿海型",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "dgzsbyqScene",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "dgzsbyqScene",
        "name": "应用场景",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6364,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "单杆变",
        "optionName": "是否成套",
        "optionContent": "成套#&#非成套",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "dgzsbyqIsComplete",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "dgzsbyqIsComplete",
        "name": "是否成套",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6365,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "单杆变",
        "optionName": "变压器类型",
        "optionContent": "SZ20-RL#&#S20-RL",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "dgzsbyqType",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "dgzsbyqType",
        "name": "变压器类型",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6366,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "单杆变",
        "optionName": "变压器容量",
        "optionContent": "50kVA#&#100kVA",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "dgzsbyqCapacity",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "dgzsbyqCapacity",
        "name": "变压器容量",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6367,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "单杆变",
        "optionName": "接地材质",
        "optionContent": "角钢#&#镀铜",
        "optionContentType": "object",
        "showNameVal": "groundMaterial#&#groundMaterial",
        "defaultVal": null,
        "fieldName": "dgzsbyqJdcz",
        "componentType": "2",
        "requestFlag": "1",
        "requestMethod": "get",
        "requestPath": "/sl/grounding/getGroundMaterial",
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "dgzsbyqJdcz",
        "name": "接地材质",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6368,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "单杆变",
        "optionName": "接地类型",
        "optionContent": "水平放射形#&#垂直放射形#&#水平环形#&#垂直环形",
        "optionContentType": "object",
        "showNameVal": "groundApplyType#&#groundApplyType",
        "defaultVal": null,
        "fieldName": "dgzsbyqJdlx",
        "componentType": "2",
        "requestFlag": "1",
        "requestMethod": "get",
        "requestPath": "/sl/grounding/getGroundApplyType",
        "requestParam": "[\n    {\n        \"key\": \"groundMaterial\",\n        \"val\": \"dgzsbyqJdcz\",\n        \"source\": \"this\"\n    }\n]",
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": "[\n    {\n\n\"name\": \"接地材质\",\n\n\"key\": \"dgzsbyqJdcz\",\n\n\"val\": \"\"\n    } \n]",
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "dgzsbyqJdlx",
        "name": "接地类型",
        "conditionMap": [
            {
                "condition": [
                    {
                        "name": "接地材质",
                        "key": "dgzsbyqJdcz",
                        "val": ""
                    }
                ],
                "opction": "水平放射形#&#垂直放射形#&#水平环形#&#垂直环形",
                "requestFlag": "1",
                "requestMethod": "get",
                "requestParam": "[\n    {\n        \"key\": \"groundMaterial\",\n        \"val\": \"dgzsbyqJdcz\",\n        \"source\": \"this\"\n    }\n]",
                "showNameVal": "groundApplyType#&#groundApplyType",
                "requestPath": "/sl/grounding/getGroundApplyType",
                "requiredFlag": "0",
                "defaultVal": null
            }
        ]
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6369,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "单杆变",
        "optionName": "接地装置型号",
        "optionContent": null,
        "optionContentType": "object",
        "showNameVal": "moduleId#&#moduleCode",
        "defaultVal": null,
        "fieldName": "dgzsbyqJdModuleId",
        "componentType": "2",
        "requestFlag": "1",
        "requestMethod": "get",
        "requestPath": "/sl/grounding/listNoPage",
        "requestParam": "[\n    {\n        \"key\": \"groundMaterial\",\n        \"val\": \"dgzsbyqJdcz\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"groundApplyType\",\n        \"val\": \"dgzsbyqJdlx\",\n        \"source\": \"this\"\n    }\n]",
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": "[\n    {\n\n\"name\": \"接地材质\",\n\n\"key\": \"dgzsbyqJdcz\",\n\n\"val\": \"\"\n    },\n    {\n\n\"name\": \"接地类型\",\n\n\"key\": \"dgzsbyqJdlx\",\n\n\"val\": \"\"\n    }\n]",
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "dgzsbyqJdModuleId",
        "name": "接地装置型号",
        "conditionMap": [
            {
                "condition": [
                    {
                        "name": "接地材质",
                        "key": "dgzsbyqJdcz",
                        "val": ""
                    },
                    {
                        "name": "接地类型",
                        "key": "dgzsbyqJdlx",
                        "val": ""
                    }
                ],
                "opction": null,
                "requestFlag": "1",
                "requestMethod": "get",
                "requestParam": "[\n    {\n        \"key\": \"groundMaterial\",\n        \"val\": \"dgzsbyqJdcz\",\n        \"source\": \"this\"\n    },\n    {\n        \"key\": \"groundApplyType\",\n        \"val\": \"dgzsbyqJdlx\",\n        \"source\": \"this\"\n    }\n]",
                "showNameVal": "moduleId#&#moduleCode",
                "requestPath": "/sl/grounding/listNoPage",
                "requiredFlag": "0",
                "defaultVal": null
            }
        ]
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6370,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "单杆变",
        "optionName": "备注",
        "optionContent": null,
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "dgzsbyqNote",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "dgzsbyqNote",
        "name": "备注",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6371,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "交叉跨越配置",
        "optionName": "50以内",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "within50",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "1",
        "mergeTitle": "河流(宽度)",
        "value": "within50",
        "name": "50以内",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6372,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "交叉跨越配置",
        "optionName": "150以内",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "within150",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "1",
        "mergeTitle": "河流(宽度)",
        "value": "within150",
        "name": "150以内",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6373,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "交叉跨越配置",
        "optionName": "150以上",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "above150",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "1",
        "mergeTitle": "河流(宽度)",
        "value": "above150",
        "name": "150以上",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6374,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "交叉跨越配置",
        "optionName": "一般公路（双向4车道及以下）",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "highway4lane",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "1",
        "mergeTitle": "公路(车道数量)",
        "value": "highway4lane",
        "name": "一般公路（双向4车道及以下）",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6375,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "交叉跨越配置",
        "optionName": "双向6车道",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "highway6lane",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "1",
        "mergeTitle": "公路(车道数量)",
        "value": "highway6lane",
        "name": "双向6车道",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6376,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "交叉跨越配置",
        "optionName": "双向8车道",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "highway8lane",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "1",
        "mergeTitle": "公路(车道数量)",
        "value": "highway8lane",
        "name": "双向8车道",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6377,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "交叉跨越配置",
        "optionName": "普通铁路（上下行2道）",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "expWay4lane",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "1",
        "mergeTitle": "高速公路(车道数量)",
        "value": "expWay4lane",
        "name": "普通铁路（上下行2道）",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6378,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "交叉跨越配置",
        "optionName": "上下行4道",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "expWay6lane",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "1",
        "mergeTitle": "高速公路(车道数量)",
        "value": "expWay6lane",
        "name": "上下行4道",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6379,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "交叉跨越配置",
        "optionName": "上下行8道",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "expWay8lane",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "1",
        "mergeTitle": "高速公路(车道数量)",
        "value": "expWay8lane",
        "name": "上下行8道",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6380,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "交叉跨越配置",
        "optionName": "普通铁路（上下行2道）",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "railway2track",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "1",
        "mergeTitle": "普通铁路(车道数量)",
        "value": "railway2track",
        "name": "普通铁路（上下行2道）",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6381,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "交叉跨越配置",
        "optionName": "上下行4道",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "railway4track",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "1",
        "mergeTitle": "普通铁路(车道数量)",
        "value": "railway4track",
        "name": "上下行4道",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6382,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "交叉跨越配置",
        "optionName": "上下行8道",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "railway8track",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "1",
        "mergeTitle": "普通铁路(车道数量)",
        "value": "railway8track",
        "name": "上下行8道",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6383,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "交叉跨越配置",
        "optionName": "跨越单回线路",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "crossSingleLine",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "1",
        "mergeTitle": "10kV电力线",
        "value": "crossSingleLine",
        "name": "跨越单回线路",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6384,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "交叉跨越配置",
        "optionName": "跨越双回及以上线路",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "crossMultiLine",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "1",
        "mergeTitle": "10kV电力线",
        "value": "crossMultiLine",
        "name": "跨越双回及以上线路",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6385,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "交叉跨越配置",
        "optionName": "跨越单回线路",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "crossSingleLine2",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "1",
        "mergeTitle": "跨越带电10kV电力线",
        "value": "crossSingleLine2",
        "name": "跨越单回线路",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6386,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "交叉跨越配置",
        "optionName": "跨越双回及以上线路",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "crossMultiLine2",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "1",
        "mergeTitle": "跨越带电10kV电力线",
        "value": "crossMultiLine2",
        "name": "跨越双回及以上线路",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6387,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "交叉跨越配置",
        "optionName": "低压电力线",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "lowPowerLine",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "lowPowerLine",
        "name": "低压电力线",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6388,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "交叉跨越配置",
        "optionName": "通信线路",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "commLine",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "commLine",
        "name": "通信线路",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6389,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "交叉跨越配置",
        "optionName": "可同行机动车的土路",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "motorDirtRoad",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "motorDirtRoad",
        "name": "可同行机动车的土路",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6390,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "交叉跨越配置",
        "optionName": "经济作物",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "ecoCrops",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "ecoCrops",
        "name": "经济作物",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6391,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "交叉跨越配置",
        "optionName": "房屋",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "building",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "building",
        "name": "房屋",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6392,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "交叉跨越配置",
        "optionName": "备注",
        "optionContent": null,
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "jckyNote",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "0",
        "mergeTitle": null,
        "value": "jckyNote",
        "name": "备注",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6393,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "拉线配置",
        "optionName": "型号",
        "optionContent": null,
        "optionContentType": "object",
        "showNameVal": "moduleId#&#moduleCode",
        "defaultVal": null,
        "fieldName": "vlModuleId",
        "componentType": "2",
        "requestFlag": "1",
        "requestMethod": "get",
        "requestPath": "/sl/stayWireModule/moduleMaterialList",
        "requestParam": "[\n    {\n        \"key\": \"firstCategory\",\n        \"val\": \"\",\n        \"defaultVal\": \"V拉\",\n        \"source\": \"default\"\n    }\n]",
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "1",
        "mergeTitle": "V拉",
        "value": "vlModuleId",
        "name": "型号",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6394,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "拉线配置",
        "optionName": "拉线数量",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": "count",
        "defaultVal": null,
        "fieldName": "vlLxCount",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "1",
        "mergeTitle": "V拉",
        "value": "vlLxCount",
        "name": "拉线数量",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6395,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "拉线配置",
        "optionName": "拉盘",
        "optionContent": null,
        "optionContentType": "object",
        "showNameVal": "materialId#&#detailCode",
        "defaultVal": null,
        "fieldName": "vlMaterialId",
        "componentType": "2",
        "requestFlag": "1",
        "requestMethod": "get",
        "requestPath": "/sl/pullLatePairing/listNoPage",
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "1",
        "mergeTitle": "V拉",
        "value": "vlMaterialId",
        "name": "拉盘",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6396,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "拉线配置",
        "optionName": "拉盘数量",
        "optionContent": null,
        "optionContentType": "number",
        "showNameVal": "lpCount",
        "defaultVal": null,
        "fieldName": "vlLpCount",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "1",
        "mergeTitle": "V拉",
        "value": "vlLpCount",
        "name": "拉盘数量",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6397,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "拉线配置",
        "optionName": "型号",
        "optionContent": null,
        "optionContentType": "object",
        "showNameVal": "moduleId#&#moduleCode",
        "defaultVal": null,
        "fieldName": "plModuleId",
        "componentType": "2",
        "requestFlag": "1",
        "requestMethod": "get",
        "requestPath": "/sl/stayWireModule/moduleMaterialList",
        "requestParam": "[\n    {\n        \"key\": \"firstCategory\",\n        \"val\": \"\",\n        \"defaultVal\": \"普拉\",\n        \"source\": \"default\"\n    }\n]",
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "1",
        "mergeTitle": "普拉",
        "value": "plModuleId",
        "name": "型号",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6398,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "拉线配置",
        "optionName": "拉线数量",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": "count",
        "defaultVal": null,
        "fieldName": "plLxCount",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "1",
        "mergeTitle": "普拉",
        "value": "plLxCount",
        "name": "拉线数量",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6399,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "拉线配置",
        "optionName": "拉盘",
        "optionContent": null,
        "optionContentType": "object",
        "showNameVal": "materialId#&#detailCode",
        "defaultVal": null,
        "fieldName": "plMaterialId",
        "componentType": "2",
        "requestFlag": "1",
        "requestMethod": "get",
        "requestPath": "/sl/pullLatePairing/listNoPage",
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "1",
        "mergeTitle": "普拉",
        "value": "plMaterialId",
        "name": "拉盘",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6400,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "拉线配置",
        "optionName": "拉盘数量",
        "optionContent": null,
        "optionContentType": "number",
        "showNameVal": "lpCount",
        "defaultVal": null,
        "fieldName": "plLpCount",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "1",
        "mergeTitle": "普拉",
        "value": "plLpCount",
        "name": "拉盘数量",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6401,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "拉线配置",
        "optionName": "型号",
        "optionContent": null,
        "optionContentType": "object",
        "showNameVal": "moduleId#&#moduleCode",
        "defaultVal": null,
        "fieldName": "glModuleId",
        "componentType": "2",
        "requestFlag": "1",
        "requestMethod": "get",
        "requestPath": "/sl/stayWireModule/moduleMaterialList",
        "requestParam": "[\n    {\n        \"key\": \"firstCategory\",\n        \"val\": \"\",\n        \"defaultVal\": \"弓拉\",\n        \"source\": \"default\"\n    }\n]",
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "1",
        "mergeTitle": "弓拉",
        "value": "glModuleId",
        "name": "型号",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6402,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "拉线配置",
        "optionName": "拉线数量",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": "count",
        "defaultVal": null,
        "fieldName": "glLxCount",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "1",
        "mergeTitle": "弓拉",
        "value": "glLxCount",
        "name": "拉线数量",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6403,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "拉线配置",
        "optionName": "拉盘",
        "optionContent": null,
        "optionContentType": "object",
        "showNameVal": "materialId#&#detailCode",
        "defaultVal": null,
        "fieldName": "glMaterialId",
        "componentType": "2",
        "requestFlag": "1",
        "requestMethod": "get",
        "requestPath": "/sl/pullLatePairing/listNoPage",
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "1",
        "mergeTitle": "弓拉",
        "value": "glMaterialId",
        "name": "拉盘",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6404,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "拉线配置",
        "optionName": "拉盘数量",
        "optionContent": null,
        "optionContentType": "number",
        "showNameVal": "lpCount",
        "defaultVal": null,
        "fieldName": "glLpCount",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "1",
        "mergeTitle": "弓拉",
        "value": "glLpCount",
        "name": "拉盘数量",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6405,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "拉线配置",
        "optionName": "型号",
        "optionContent": null,
        "optionContentType": "object",
        "showNameVal": "moduleId#&#moduleCode",
        "defaultVal": null,
        "fieldName": "dlModuleId",
        "componentType": "2",
        "requestFlag": "1",
        "requestMethod": "get",
        "requestPath": "/sl/stayWireModule/moduleMaterialList",
        "requestParam": "[\n    {\n        \"key\": \"firstCategory\",\n        \"val\": \"\",\n        \"defaultVal\": \"对拉\",\n        \"source\": \"default\"\n    }\n]",
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "1",
        "mergeTitle": "对拉",
        "value": "dlModuleId",
        "name": "型号",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6406,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "拉线配置",
        "optionName": "拉线数量",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": "count",
        "defaultVal": null,
        "fieldName": "dlLxCount",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "1",
        "mergeTitle": "对拉",
        "value": "dlLxCount",
        "name": "拉线数量",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6407,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "拉线配置",
        "optionName": "钢绞线长度（m）",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "dlGjxcd",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "1",
        "mergeTitle": "对拉",
        "value": "dlGjxcd",
        "name": "钢绞线长度（m）",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6408,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "拉线配置",
        "optionName": "对侧拉线抱箍型号",
        "optionContent": null,
        "optionContentType": "object",
        "showNameVal": "materialId#&#description",
        "defaultVal": null,
        "fieldName": "dlLxbgxh",
        "componentType": "4",
        "requestFlag": "1",
        "requestMethod": "get",
        "requestPath": "/sl/stayWireHoop/listNoPage",
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "1",
        "mergeTitle": "对拉",
        "value": "dlLxbgxh",
        "name": "对侧拉线抱箍型号",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6409,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "拉线配置",
        "optionName": "型号",
        "optionContent": null,
        "optionContentType": "object",
        "showNameVal": "moduleId#&#moduleCode",
        "defaultVal": null,
        "fieldName": "splModuleId",
        "componentType": "2",
        "requestFlag": "1",
        "requestMethod": "get",
        "requestPath": "/sl/stayWireModule/moduleMaterialList",
        "requestParam": "[\n    {\n        \"key\": \"firstCategory\",\n        \"val\": \"\",\n        \"defaultVal\": \"水平拉\",\n        \"source\": \"default\"\n    }\n]",
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "1",
        "mergeTitle": "水平拉",
        "value": "splModuleId",
        "name": "型号",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6410,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "拉线配置",
        "optionName": "拉线数量",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": "count",
        "defaultVal": null,
        "fieldName": "splLxCount",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "1",
        "mergeTitle": "水平拉",
        "value": "splLxCount",
        "name": "拉线数量",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6411,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "拉线配置",
        "optionName": "拉盘",
        "optionContent": null,
        "optionContentType": "object",
        "showNameVal": "materialId#&#detailCode",
        "defaultVal": null,
        "fieldName": "splMaterialId",
        "componentType": "2",
        "requestFlag": "1",
        "requestMethod": "get",
        "requestPath": "/sl/pullLatePairing/listNoPage",
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "1",
        "mergeTitle": "水平拉",
        "value": "splMaterialId",
        "name": "拉盘",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6412,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "拉线配置",
        "optionName": "拉盘数量",
        "optionContent": null,
        "optionContentType": "number",
        "showNameVal": "lpCount",
        "defaultVal": null,
        "fieldName": "splLpCount",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "1",
        "mergeTitle": "水平拉",
        "value": "splLpCount",
        "name": "拉盘数量",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6413,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "拉线配置",
        "optionName": "钢绞线长度（m）",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "splGjxcd",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "1",
        "mergeTitle": "水平拉",
        "value": "splGjxcd",
        "name": "钢绞线长度（m）",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6414,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "拉线配置",
        "optionName": "水平拉电杆状态",
        "optionContent": "原有#&#新建",
        "optionContentType": "string",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "splState",
        "componentType": "2",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "1",
        "mergeTitle": "水平拉",
        "value": "splState",
        "name": "水平拉电杆状态",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6415,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "拉线配置",
        "optionName": "水平拉电杆型号",
        "optionContent": null,
        "optionContentType": "object",
        "showNameVal": "materialId#&#electricPoleType",
        "defaultVal": null,
        "fieldName": "splRodId",
        "componentType": "4",
        "requestFlag": "1",
        "requestMethod": "get",
        "requestPath": "/sl/coneRod/listNoPage",
        "requestParam": "[\n    {\n        \"key\": \"materialState\",\n        \"val\": \"splState\",\n        \"defaultVal\": \"\",\n        \"source\": \"this\"\n    }\n]",
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "1",
        "mergeTitle": "水平拉",
        "value": "splRodId",
        "name": "水平拉电杆型号",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6416,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "拉线配置",
        "optionName": "型号",
        "optionContent": null,
        "optionContentType": "object",
        "showNameVal": "moduleId#&#moduleCode",
        "defaultVal": null,
        "fieldName": "ylModuleId",
        "componentType": "2",
        "requestFlag": "1",
        "requestMethod": "get",
        "requestPath": "/sl/stayWireModule/moduleMaterialList",
        "requestParam": "[\n    {\n        \"key\": \"firstCategory\",\n        \"val\": \"\",\n        \"defaultVal\": \"Y拉\",\n        \"source\": \"default\"\n    }\n]",
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "1",
        "mergeTitle": "Y拉",
        "value": "ylModuleId",
        "name": "型号",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6417,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "拉线配置",
        "optionName": "拉线数量",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": "count",
        "defaultVal": null,
        "fieldName": "ylLxCount",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "1",
        "mergeTitle": "Y拉",
        "value": "ylLxCount",
        "name": "拉线数量",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6418,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "拉线配置",
        "optionName": "拉盘",
        "optionContent": null,
        "optionContentType": "object",
        "showNameVal": "materialId#&#detailCode",
        "defaultVal": null,
        "fieldName": "ylMaterialId",
        "componentType": "2",
        "requestFlag": "1",
        "requestMethod": "get",
        "requestPath": "/sl/pullLatePairing/listNoPage",
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "1",
        "mergeTitle": "Y拉",
        "value": "ylMaterialId",
        "name": "拉盘",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6419,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "拉线配置",
        "optionName": "拉盘数量",
        "optionContent": null,
        "optionContentType": "number",
        "showNameVal": "lpCount",
        "defaultVal": null,
        "fieldName": "ylLpCount",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "1",
        "isMergeTitle": "1",
        "mergeTitle": "Y拉",
        "value": "ylLpCount",
        "name": "拉盘数量",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6420,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "拉线配置",
        "optionName": "型号",
        "optionContent": null,
        "optionContentType": "object",
        "showNameVal": "moduleId#&#moduleCode",
        "defaultVal": null,
        "fieldName": "qlModuleId",
        "componentType": "2",
        "requestFlag": "1",
        "requestMethod": "get",
        "requestPath": "/sl/stayWireModule/moduleMaterialList",
        "requestParam": "[\n    {\n        \"key\": \"firstCategory\",\n        \"val\": \"\",\n        \"defaultVal\": \"墙拉\",\n        \"source\": \"default\"\n    }\n]",
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "1",
        "mergeTitle": "墙拉",
        "value": "qlModuleId",
        "name": "型号",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6421,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "拉线配置",
        "optionName": "拉线数量",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": "count",
        "defaultVal": null,
        "fieldName": "qlLxCount",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "1",
        "mergeTitle": "墙拉",
        "value": "qlLxCount",
        "name": "拉线数量",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6422,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "拉线配置",
        "optionName": "钢绞线长度（m）",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "qlGjxcd",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "1",
        "mergeTitle": "墙拉",
        "value": "qlGjxcd",
        "name": "钢绞线长度（m）",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6423,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "拉线配置",
        "optionName": "型号",
        "optionContent": null,
        "optionContentType": "object",
        "showNameVal": "moduleId#&#moduleCode",
        "defaultVal": null,
        "fieldName": "sglModuleId",
        "componentType": "2",
        "requestFlag": "1",
        "requestMethod": "get",
        "requestPath": "/sl/stayWireModule/moduleMaterialList",
        "requestParam": "[\n    {\n        \"key\": \"firstCategory\",\n        \"val\": \"\",\n        \"defaultVal\": \"双杆拉\",\n        \"source\": \"default\"\n    },\n      {\n        \"key\": \"rodTowerTypeCode\",\n        \"val\": \"rodTowerTypeCode\",\n        \"defaultVal\": \"\",\n        \"source\": \"this\"\n    }\n]",
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "1",
        "mergeTitle": "双杆拉",
        "value": "sglModuleId",
        "name": "型号",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6424,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "拉线配置",
        "optionName": "拉线数量",
        "optionContent": null,
        "optionContentType": "int",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "sglLxCount",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "1",
        "mergeTitle": "双杆拉",
        "value": "sglLxCount",
        "name": "拉线数量",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6425,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "拉线配置",
        "optionName": "拉盘1",
        "optionContent": null,
        "optionContentType": "object",
        "showNameVal": "materialId#&#detailCode",
        "defaultVal": null,
        "fieldName": "sglMaterialId1",
        "componentType": "2",
        "requestFlag": "1",
        "requestMethod": "get",
        "requestPath": "/sl/pullLatePairing/listNoPage",
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "1",
        "mergeTitle": "双杆拉",
        "value": "sglMaterialId1",
        "name": "拉盘1",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6426,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "拉线配置",
        "optionName": "拉盘1数量",
        "optionContent": null,
        "optionContentType": "number",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "sglLpCount1",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "1",
        "mergeTitle": "双杆拉",
        "value": "sglLpCount1",
        "name": "拉盘1数量",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6427,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "拉线配置",
        "optionName": "拉盘2",
        "optionContent": null,
        "optionContentType": "object",
        "showNameVal": "materialId#&#detailCode",
        "defaultVal": null,
        "fieldName": "sglMaterialId2",
        "componentType": "2",
        "requestFlag": "1",
        "requestMethod": "get",
        "requestPath": "/sl/pullLatePairing/listNoPage",
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "1",
        "mergeTitle": "双杆拉",
        "value": "sglMaterialId2",
        "name": "拉盘2",
        "conditionMap": []
    },
    {
        "createBy": "",
        "createTime": "2026-05-28 10:41:00",
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 6428,
        "optionOrder": null,
        "paramType": "设计参数",
        "optionType": "拉线配置",
        "optionName": "拉盘2数量",
        "optionContent": null,
        "optionContentType": "number",
        "showNameVal": null,
        "defaultVal": null,
        "fieldName": "sglLpCount2",
        "componentType": "1",
        "requestFlag": "0",
        "requestMethod": null,
        "requestPath": null,
        "requestParam": null,
        "requiredFlag": "0",
        "width": "5%",
        "isLeft": "0",
        "conditionList": null,
        "isMerge": "0",
        "isMergeTitle": "1",
        "mergeTitle": "双杆拉",
        "value": "sglLpCount2",
        "name": "拉盘2数量",
        "conditionMap": []
    }
]
const mergeCol = customColumnTitles.reduce((result, item, index) => {
  // 过滤条件：isMerge == 1
  if (item.isMerge == 1) {
    // 重组对象，index为原始数组的下标
    result.push({
      fieldName: item.fieldName,
      index: index, // 这里的index是元素在原始数组中的位置
      name: item.name
    });
  }
  return result;
}, [])

function getAjax(item, data = {}, success, error) {
  let baseUrl = 'http://localhost:9999'
  let token = localStorage.getItem('token')
  let params = item.requestMethod === 'get' ? data : JSON.stringify(data)
    $.ajax({
        url: `${baseUrl}${item.requestPath}`,
        type: item.requestMethod || 'get',
        contentType: "application/json",
        data: params,
        beforeSend: function (request) {
            request.setRequestHeader("Authorization", `Bearer ${token}`)
        },
        success(res) {
            success?.(res)
        },
        error(err) {
            error?.(err)
        }
    })
}

const getUniqueId = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

// 判断字符串时是否为空
const isEmptyString = (str) => {
    // 处理 null/undefined：视为空
    if (str == null) return true;
    // 转换为字符串（防止非字符串类型干扰，如数字 0、布尔 false）
    const strValue = String(str);
    // 去除首尾空白后，判断是否为空字符串
    return strValue.trim() === "";
}

/**
 * 工具栏表头
 * @param {string} optionType 按钮名称
 * @param {string} optionTypeKey 按钮类型
 * @param {string} paramTypeKey 按钮归属
 * @param {string} paramType 按钮归属名称
 * @param {boolean} isMenu 是否是菜单类型（true:按钮，false:非按钮）
 */
const tabPanel = [
    {
        "createBy": "",
        "createTime": null,
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 2060,
        "paramType": "设计参数",
        "paramTypeKey": "designParams",
        "optionType": "配电线路总览",
        "optionTypeKey": "wire",
        "optionName": "杆塔编号/设备名称",
        "fieldName": "rodTowerNo",
        "child": [
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2060,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "配电线路总览",
                "optionTypeKey": "wire",
                "optionName": "杆塔编号/设备名称",
                "fieldName": "rodTowerNo"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2061,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "配电线路总览",
                "optionTypeKey": "wire",
                "optionName": "是否变电站前三基",
                "fieldName": "isBase"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2062,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "配电线路总览",
                "optionTypeKey": "wire",
                "optionName": "杆塔/设备状态",
                "fieldName": "moduleState"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2063,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "配电线路总览",
                "optionTypeKey": "wire",
                "optionName": "杆塔结构",
                "fieldName": "rodTowerMaterial"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2064,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "配电线路总览",
                "optionTypeKey": "wire",
                "optionName": "回路数",
                "fieldName": "loopNumber"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2065,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "配电线路总览",
                "optionTypeKey": "wire",
                "optionName": "是否带低压",
                "fieldName": "isLowPressure"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2066,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "配电线路总览",
                "optionTypeKey": "wire",
                "optionName": "杆塔类型",
                "fieldName": "rodTowerTypeCode"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2067,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "配电线路总览",
                "optionTypeKey": "wire",
                "optionName": "线缆状态",
                "fieldName": "wireModuleState"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2068,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "配电线路总览",
                "optionTypeKey": "wire",
                "optionName": "线缆类型",
                "fieldName": "writeType"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2069,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "配电线路总览",
                "optionTypeKey": "wire",
                "optionName": "线缆截面",
                "fieldName": "crossSectionAreaTwo"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2070,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "配电线路总览",
                "optionTypeKey": "wire",
                "optionName": "档距或总长(m)",
                "fieldName": "wireSpan"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2071,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "配电线路总览",
                "optionTypeKey": "wire",
                "optionName": "杆型代号",
                "fieldName": "rodTypeModuleId"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2072,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "配电线路总览",
                "optionTypeKey": "wire",
                "optionName": "杆头代号",
                "fieldName": "rodHeadModuleId"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2073,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "配电线路总览",
                "optionTypeKey": "wire",
                "optionName": "电杆分段",
                "fieldName": "cementPoleSection"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2074,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "配电线路总览",
                "optionTypeKey": "wire",
                "optionName": "转角方向与度数",
                "fieldName": "angleDegree"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2075,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "配电线路总览",
                "optionTypeKey": "wire",
                "optionName": "数智查验参阅意见",
                "fieldName": "opinion"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2076,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "配电线路总览",
                "optionTypeKey": "wire",
                "optionName": "意见出处",
                "fieldName": "source"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2077,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "配电线路总览",
                "optionTypeKey": "wire",
                "optionName": "备注",
                "fieldName": "wireNote"
            }
        ],
    },
    {
        "createBy": "",
        "createTime": null,
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 2078,
        "paramType": "设计参数",
        "paramTypeKey": "designParams",
        "optionType": "柱上设备及附件配置",
        "optionTypeKey": "equipment",
        "optionName": "杆塔编号/设备名称",
        "fieldName": "rodTowerNo",
        "child": [
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2078,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "柱上设备及附件配置",
                "optionTypeKey": "equipment",
                "optionName": "杆塔编号/设备名称",
                "fieldName": "rodTowerNo"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2079,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "柱上设备及附件配置",
                "optionTypeKey": "equipment",
                "optionName": "杆塔/设备状态",
                "fieldName": "moduleState"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2080,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "柱上设备及附件配置",
                "optionTypeKey": "equipment",
                "optionName": "杆塔结构",
                "fieldName": "rodTowerMaterial"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2081,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "柱上设备及附件配置",
                "optionTypeKey": "equipment",
                "optionName": "杆型代号",
                "fieldName": "rodTypeModuleId"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2082,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "柱上设备及附件配置",
                "optionTypeKey": "equipment",
                "optionName": "线缆状态",
                "fieldName": "wireModuleState"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2083,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "柱上设备及附件配置",
                "optionTypeKey": "equipment",
                "optionName": "线缆类型",
                "fieldName": "writeType"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2084,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "柱上设备及附件配置",
                "optionTypeKey": "equipment",
                "optionName": "线缆截面",
                "fieldName": "crossSectionAreaTwo"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2085,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "柱上设备及附件配置",
                "optionTypeKey": "equipment",
                "optionName": "档距或总长(m)",
                "fieldName": "wireSpan"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2086,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "柱上设备及附件配置",
                "optionTypeKey": "equipment",
                "optionName": "电杆分段",
                "fieldName": "cementPoleSection"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2087,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "柱上设备及附件配置",
                "optionTypeKey": "equipment",
                "optionName": "线路避雷器类型",
                "fieldName": "blqModuleId"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2088,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "柱上设备及附件配置",
                "optionTypeKey": "equipment",
                "optionName": "接地挂环型号",
                "fieldName": "jdghModuleId"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2089,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "柱上设备及附件配置",
                "optionTypeKey": "equipment",
                "optionName": "防振锤型号",
                "fieldName": "fzcModuleId"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2090,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "柱上设备及附件配置",
                "optionTypeKey": "equipment",
                "optionName": "防振锤数量",
                "fieldName": "fzcCount"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2091,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "柱上设备及附件配置",
                "optionTypeKey": "equipment",
                "optionName": "设备类型",
                "fieldName": "equipmentType"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2092,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "柱上设备及附件配置",
                "optionTypeKey": "equipment",
                "optionName": "柱上开关类型",
                "fieldName": "breakerType"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2093,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "柱上设备及附件配置",
                "optionTypeKey": "equipment",
                "optionName": "杆上设备代号",
                "fieldName": "equipmentModuleId"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2094,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "柱上设备及附件配置",
                "optionTypeKey": "equipment",
                "optionName": "接地材质",
                "fieldName": "groundMaterial"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2095,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "柱上设备及附件配置",
                "optionTypeKey": "equipment",
                "optionName": "接地类型",
                "fieldName": "groundApplyType"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2096,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "柱上设备及附件配置",
                "optionTypeKey": "equipment",
                "optionName": "接地装置型号",
                "fieldName": "groundingModuleId"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2097,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "柱上设备及附件配置",
                "optionTypeKey": "equipment",
                "optionName": "备注",
                "fieldName": "equipmentNote"
            }
        ]
    },
    {
        "createBy": "",
        "createTime": null,
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 2098,
        "paramType": "设计参数",
        "paramTypeKey": "designParams",
        "optionType": "杆塔基础配置",
        "optionTypeKey": "towerSetting",
        "optionName": "杆塔编号/设备名称",
        "fieldName": "rodTowerNo",
        "child": [
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2098,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "杆塔基础配置",
                "optionTypeKey": "towerSetting",
                "optionName": "杆塔编号/设备名称",
                "fieldName": "rodTowerNo"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2099,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "杆塔基础配置",
                "optionTypeKey": "towerSetting",
                "optionName": "杆塔/设备状态",
                "fieldName": "moduleState"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2100,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "杆塔基础配置",
                "optionTypeKey": "towerSetting",
                "optionName": "杆塔结构",
                "fieldName": "rodTowerMaterial"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2101,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "杆塔基础配置",
                "optionTypeKey": "towerSetting",
                "optionName": "杆型代号",
                "fieldName": "rodTypeModuleId"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2102,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "杆塔基础配置",
                "optionTypeKey": "towerSetting",
                "optionName": "电杆分段",
                "fieldName": "cementPoleSection"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2103,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "杆塔基础配置",
                "optionTypeKey": "towerSetting",
                "optionName": "基础类型",
                "fieldName": "baseType"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2104,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "杆塔基础配置",
                "optionTypeKey": "towerSetting",
                "optionName": "底盘代号",
                "fieldName": "kpCode"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2105,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "杆塔基础配置",
                "optionTypeKey": "towerSetting",
                "optionName": "卡盘数量",
                "fieldName": "kpCount"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2106,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "杆塔基础配置",
                "optionTypeKey": "towerSetting",
                "optionName": "防撞配置",
                "fieldName": "antiConfig"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2107,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "杆塔基础配置",
                "optionTypeKey": "towerSetting",
                "optionName": "备注",
                "fieldName": "towerSettingNote"
            }
        ]
    },
    {
        "createBy": "",
        "createTime": null,
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 2108,
        "paramType": "设计参数",
        "paramTypeKey": "designParams",
        "optionType": "宽基塔塔腿",
        "optionTypeKey": "towerLeg",
        "optionName": "杆塔编号/设备名称",
        "fieldName": "rodTowerNo",
        "child": [
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2108,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "宽基塔塔腿",
                "optionTypeKey": "towerLeg",
                "optionName": "杆塔编号/设备名称",
                "fieldName": "rodTowerNo"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2109,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "宽基塔塔腿",
                "optionTypeKey": "towerLeg",
                "optionName": "杆塔/设备状态",
                "fieldName": "moduleState"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2110,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "宽基塔塔腿",
                "optionTypeKey": "towerLeg",
                "optionName": "杆塔结构",
                "fieldName": "rodTowerMaterial"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2111,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "宽基塔塔腿",
                "optionTypeKey": "towerLeg",
                "optionName": "杆型代号",
                "fieldName": "rodTypeModuleId"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2112,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "宽基塔塔腿",
                "optionTypeKey": "towerLeg",
                "optionName": "电杆分段",
                "fieldName": "cementPoleSection"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2113,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "宽基塔塔腿",
                "optionTypeKey": "towerLeg",
                "optionName": "宽基塔A腿高",
                "fieldName": "legA"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2114,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "宽基塔塔腿",
                "optionTypeKey": "towerLeg",
                "optionName": "宽基塔B腿高",
                "fieldName": "legB"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2115,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "宽基塔塔腿",
                "optionTypeKey": "towerLeg",
                "optionName": "宽基塔C腿高",
                "fieldName": "legC"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2116,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "宽基塔塔腿",
                "optionTypeKey": "towerLeg",
                "optionName": "宽基塔D腿高",
                "fieldName": "legD"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2117,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "宽基塔塔腿",
                "optionTypeKey": "towerLeg",
                "optionName": "备注",
                "fieldName": "towerLegNote"
            }
        ]
    },
    {
        "createBy": "",
        "createTime": null,
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 2118,
        "paramType": "设计参数",
        "paramTypeKey": "designParams",
        "optionType": "电缆参数配置",
        "optionTypeKey": "cable",
        "optionName": "杆塔编号/设备名称",
        "fieldName": "rodTowerNo",
        "child": [
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2118,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "电缆参数配置",
                "optionTypeKey": "cable",
                "optionName": "杆塔编号/设备名称",
                "fieldName": "rodTowerNo"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2119,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "电缆参数配置",
                "optionTypeKey": "cable",
                "optionName": "杆塔结构",
                "fieldName": "rodTowerMaterial"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2120,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "电缆参数配置",
                "optionTypeKey": "cable",
                "optionName": "线缆状态",
                "fieldName": "wireModuleState"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2121,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "电缆参数配置",
                "optionTypeKey": "cable",
                "optionName": "线缆类型",
                "fieldName": "writeType"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2122,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "电缆参数配置",
                "optionTypeKey": "cable",
                "optionName": "线缆截面",
                "fieldName": "crossSectionAreaTwo"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2123,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "电缆参数配置",
                "optionTypeKey": "cable",
                "optionName": "档距或总长(m)",
                "fieldName": "wireSpan"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2124,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "电缆参数配置",
                "optionTypeKey": "cable",
                "optionName": "杆型代号",
                "fieldName": "rodTypeModuleId"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2125,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "电缆参数配置",
                "optionTypeKey": "cable",
                "optionName": "电缆编号",
                "fieldName": "cableNo"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2126,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "电缆参数配置",
                "optionTypeKey": "cable",
                "optionName": "电缆名称",
                "fieldName": "cableName"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2127,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "电缆参数配置",
                "optionTypeKey": "cable",
                "optionName": "终端头型号",
                "fieldName": "terminalHeadId"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2128,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "电缆参数配置",
                "optionTypeKey": "cable",
                "optionName": "终端头数量",
                "fieldName": "terminalHeadCount"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2129,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "电缆参数配置",
                "optionTypeKey": "cable",
                "optionName": "中间接头型号",
                "fieldName": "intermediateJointId"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2130,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "电缆参数配置",
                "optionTypeKey": "cable",
                "optionName": "中间接头数量",
                "fieldName": "intermediateJointCount"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2131,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "电缆参数配置",
                "optionTypeKey": "cable",
                "optionName": "防火封堵材质",
                "fieldName": "blockingMaterial"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2132,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "电缆参数配置",
                "optionTypeKey": "cable",
                "optionName": "防火封堵型号",
                "fieldName": "blockingId"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2133,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "电缆参数配置",
                "optionTypeKey": "cable",
                "optionName": "防火封堵孔数",
                "fieldName": "blockingCount"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2134,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "电缆参数配置",
                "optionTypeKey": "cable",
                "optionName": "电缆标识牌数量",
                "fieldName": "signageCount"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2135,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "电缆参数配置",
                "optionTypeKey": "cable",
                "optionName": "电缆预留备注",
                "fieldName": "resNote"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2136,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "电缆参数配置",
                "optionTypeKey": "cable",
                "optionName": "备注",
                "fieldName": "cableNote"
            }
        ]
    },
    {
        "createBy": "",
        "createTime": null,
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 2137,
        "paramType": "设计参数",
        "paramTypeKey": "designParams",
        "optionType": "环网箱",
        "optionTypeKey": "ringBox",
        "optionName": "杆塔编号/设备名称",
        "fieldName": "rodTowerNo",
        "child": [
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2137,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "环网箱",
                "optionTypeKey": "ringBox",
                "optionName": "杆塔编号/设备名称",
                "fieldName": "rodTowerNo"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2138,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "环网箱",
                "optionTypeKey": "ringBox",
                "optionName": "杆塔/设备状态",
                "fieldName": "moduleState"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2139,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "环网箱",
                "optionTypeKey": "ringBox",
                "optionName": "性能等级",
                "fieldName": "hwxPerformanceLevel"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2140,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "环网箱",
                "optionTypeKey": "ringBox",
                "optionName": "设备间隔",
                "fieldName": "hwxEquipmentSpacing"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2141,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "环网箱",
                "optionTypeKey": "ringBox",
                "optionName": "是否带应急接口",
                "fieldName": "hwxIsInterface"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2142,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "环网箱",
                "optionTypeKey": "ringBox",
                "optionName": "备注",
                "fieldName": "hwxNote"
            }
        ]
    },
    {
        "createBy": "",
        "createTime": null,
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 2143,
        "paramType": "设计参数",
        "paramTypeKey": "designParams",
        "optionType": "箱式变电站",
        "optionTypeKey": "boxSubstation",
        "optionName": "杆塔编号/设备名称",
        "fieldName": "rodTowerNo",
        "child": [
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2143,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "箱式变电站",
                "optionTypeKey": "boxSubstation",
                "optionName": "杆塔编号/设备名称",
                "fieldName": "rodTowerNo"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2144,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "箱式变电站",
                "optionTypeKey": "boxSubstation",
                "optionName": "杆塔/设备状态",
                "fieldName": "moduleState"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2145,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "箱式变电站",
                "optionTypeKey": "boxSubstation",
                "optionName": "适用类型",
                "fieldName": "xsbdzApplyType"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2146,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "箱式变电站",
                "optionTypeKey": "boxSubstation",
                "optionName": "设备规格",
                "fieldName": "xsbdzEquipmentSpecifications"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2147,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "箱式变电站",
                "optionTypeKey": "boxSubstation",
                "optionName": "设备类型",
                "fieldName": "xsbdzEquipmentType"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2148,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "箱式变电站",
                "optionTypeKey": "boxSubstation",
                "optionName": "变压器容量",
                "fieldName": "xsbdzTransformerCapacity"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2149,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "箱式变电站",
                "optionTypeKey": "boxSubstation",
                "optionName": "备注",
                "fieldName": "xsbdzNote"
            }
        ]
    },
    {
        "createBy": "",
        "createTime": null,
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 2150,
        "paramType": "设计参数",
        "paramTypeKey": "designParams",
        "optionType": "双杆变",
        "optionTypeKey": "doublePoleTransformer",
        "optionName": "杆塔编号/设备名称",
        "fieldName": "rodTowerNo",
        "child": [
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2150,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "双杆变",
                "optionTypeKey": "doublePoleTransformer",
                "optionName": "杆塔编号/设备名称",
                "fieldName": "rodTowerNo"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2151,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "双杆变",
                "optionTypeKey": "doublePoleTransformer",
                "optionName": "杆塔/设备状态",
                "fieldName": "moduleState"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2152,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "双杆变",
                "optionTypeKey": "doublePoleTransformer",
                "optionName": "杆塔结构",
                "fieldName": "rodTowerMaterial"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2153,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "双杆变",
                "optionTypeKey": "doublePoleTransformer",
                "optionName": "回路数",
                "fieldName": "loopNumber"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2154,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "双杆变",
                "optionTypeKey": "doublePoleTransformer",
                "optionName": "杆塔类型",
                "fieldName": "rodTowerTypeCode"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2155,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "双杆变",
                "optionTypeKey": "doublePoleTransformer",
                "optionName": "杆型代号",
                "fieldName": "rodTypeModuleId"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2156,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "双杆变",
                "optionTypeKey": "doublePoleTransformer",
                "optionName": "柱上变压器状态",
                "fieldName": "sgzsbyqState"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2157,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "双杆变",
                "optionTypeKey": "doublePoleTransformer",
                "optionName": "应用场景",
                "fieldName": "sgzsbyqScene"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2158,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "双杆变",
                "optionTypeKey": "doublePoleTransformer",
                "optionName": "变压器类型",
                "fieldName": "sgzsbyqType"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2159,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "双杆变",
                "optionTypeKey": "doublePoleTransformer",
                "optionName": "变压器容量",
                "fieldName": "sgzsbyqCapacity"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2160,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "双杆变",
                "optionTypeKey": "doublePoleTransformer",
                "optionName": "是否成套",
                "fieldName": "sgzsbyqIsComplete"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2161,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "双杆变",
                "optionTypeKey": "doublePoleTransformer",
                "optionName": "接地材质",
                "fieldName": "sgzsbyqJdcz"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2162,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "双杆变",
                "optionTypeKey": "doublePoleTransformer",
                "optionName": "接地装置型号",
                "fieldName": "sgzsbyqJdModuleId"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2163,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "双杆变",
                "optionTypeKey": "doublePoleTransformer",
                "optionName": "备注",
                "fieldName": "sgzsbyqNote"
            }
        ]
    },
    {
        "createBy": "",
        "createTime": null,
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 2164,
        "paramType": "设计参数",
        "paramTypeKey": "designParams",
        "optionType": "单杆变",
        "optionTypeKey": "singlePoleTransformer",
        "optionName": "杆塔编号/设备名称",
        "fieldName": "rodTowerNo",
        "child": [
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2164,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "单杆变",
                "optionTypeKey": "singlePoleTransformer",
                "optionName": "杆塔编号/设备名称",
                "fieldName": "rodTowerNo"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2165,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "单杆变",
                "optionTypeKey": "singlePoleTransformer",
                "optionName": "杆塔/设备状态",
                "fieldName": "moduleState"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2166,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "单杆变",
                "optionTypeKey": "singlePoleTransformer",
                "optionName": "杆塔结构",
                "fieldName": "rodTowerMaterial"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2167,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "单杆变",
                "optionTypeKey": "singlePoleTransformer",
                "optionName": "回路数",
                "fieldName": "loopNumber"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2168,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "单杆变",
                "optionTypeKey": "singlePoleTransformer",
                "optionName": "杆塔类型",
                "fieldName": "rodTowerTypeCode"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2169,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "单杆变",
                "optionTypeKey": "singlePoleTransformer",
                "optionName": "柱上变压器状态",
                "fieldName": "dgzsbyqState"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2170,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "单杆变",
                "optionTypeKey": "singlePoleTransformer",
                "optionName": "应用场景",
                "fieldName": "dgzsbyqScene"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2171,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "单杆变",
                "optionTypeKey": "singlePoleTransformer",
                "optionName": "变压器类型",
                "fieldName": "dgzsbyqType"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2172,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "单杆变",
                "optionTypeKey": "singlePoleTransformer",
                "optionName": "变压器容量",
                "fieldName": "dgzsbyqCapacity"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2173,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "单杆变",
                "optionTypeKey": "singlePoleTransformer",
                "optionName": "是否成套",
                "fieldName": "dgzsbyqIsComplete"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2174,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "单杆变",
                "optionTypeKey": "singlePoleTransformer",
                "optionName": "接地材质",
                "fieldName": "dgzsbyqJdcz"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2175,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "单杆变",
                "optionTypeKey": "singlePoleTransformer",
                "optionName": "接地类型",
                "fieldName": "dgzsbyqJdlx"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2176,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "单杆变",
                "optionTypeKey": "singlePoleTransformer",
                "optionName": "接地装置型号",
                "fieldName": "dgzsbyqJdModuleId"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2177,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "单杆变",
                "optionTypeKey": "singlePoleTransformer",
                "optionName": "备注",
                "fieldName": "dgzsbyqNote"
            }
        ]
    },
    {
        "createBy": "",
        "createTime": null,
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 2178,
        "paramType": "设计参数",
        "paramTypeKey": "designParams",
        "optionType": "交叉跨越配置",
        "optionTypeKey": "crossing",
        "optionName": "杆塔编号/设备名称",
        "fieldName": "rodTowerNo",
        "child": [
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2178,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "交叉跨越配置",
                "optionTypeKey": "crossing",
                "optionName": "杆塔编号/设备名称",
                "fieldName": "rodTowerNo"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2179,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "交叉跨越配置",
                "optionTypeKey": "crossing",
                "optionName": "杆塔/设备状态",
                "fieldName": "moduleState"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2180,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "交叉跨越配置",
                "optionTypeKey": "crossing",
                "optionName": "杆塔结构",
                "fieldName": "rodTowerMaterial"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2181,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "交叉跨越配置",
                "optionTypeKey": "crossing",
                "optionName": "回路数",
                "fieldName": "loopNumber"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2182,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "交叉跨越配置",
                "optionTypeKey": "crossing",
                "optionName": "杆塔类型",
                "fieldName": "rodTowerTypeCode"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2183,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "交叉跨越配置",
                "optionTypeKey": "crossing",
                "optionName": "线缆状态",
                "fieldName": "wireModuleState"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2184,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "交叉跨越配置",
                "optionTypeKey": "crossing",
                "optionName": "线缆类型",
                "fieldName": "writeType"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2185,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "交叉跨越配置",
                "optionTypeKey": "crossing",
                "optionName": "线缆截面",
                "fieldName": "crossSectionAreaTwo"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2186,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "交叉跨越配置",
                "optionTypeKey": "crossing",
                "optionName": "档距或总长(m)",
                "fieldName": "wireSpan"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2187,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "交叉跨越配置",
                "optionTypeKey": "crossing",
                "optionName": "杆型代号",
                "fieldName": "rodTypeModuleId"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2188,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "交叉跨越配置",
                "optionTypeKey": "crossing",
                "optionName": "河流(宽度)/50以内",
                "fieldName": "within50"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2189,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "交叉跨越配置",
                "optionTypeKey": "crossing",
                "optionName": "河流(宽度)/150以内",
                "fieldName": "within150"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2190,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "交叉跨越配置",
                "optionTypeKey": "crossing",
                "optionName": "河流(宽度)/150以上",
                "fieldName": "above150"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2191,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "交叉跨越配置",
                "optionTypeKey": "crossing",
                "optionName": "公路(车道数量)/一般公路（双向4车道及以下）",
                "fieldName": "highway4lane"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2192,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "交叉跨越配置",
                "optionTypeKey": "crossing",
                "optionName": "公路(车道数量)/双向6车道",
                "fieldName": "highway6lane"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2193,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "交叉跨越配置",
                "optionTypeKey": "crossing",
                "optionName": "公路(车道数量)/双向8车道",
                "fieldName": "highway8lane"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2194,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "交叉跨越配置",
                "optionTypeKey": "crossing",
                "optionName": "高速公路(车道数量)/普通铁路（上下行2道）",
                "fieldName": "expWay4lane"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2195,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "交叉跨越配置",
                "optionTypeKey": "crossing",
                "optionName": "高速公路(车道数量)/上下行4道",
                "fieldName": "expWay6lane"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2196,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "交叉跨越配置",
                "optionTypeKey": "crossing",
                "optionName": "高速公路(车道数量)/上下行8道",
                "fieldName": "expWay8lane"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2197,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "交叉跨越配置",
                "optionTypeKey": "crossing",
                "optionName": "普通铁路(车道数量)/普通铁路（上下行2道）",
                "fieldName": "railway2track"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2198,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "交叉跨越配置",
                "optionTypeKey": "crossing",
                "optionName": "普通铁路(车道数量)/上下行4道",
                "fieldName": "railway4track"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2199,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "交叉跨越配置",
                "optionTypeKey": "crossing",
                "optionName": "普通铁路(车道数量)/上下行8道",
                "fieldName": "railway8track"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2200,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "交叉跨越配置",
                "optionTypeKey": "crossing",
                "optionName": "10kV电力线/跨越单回线路",
                "fieldName": "crossSingleLine"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2201,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "交叉跨越配置",
                "optionTypeKey": "crossing",
                "optionName": "10kV电力线/跨越双回及以上线路",
                "fieldName": "crossMultiLine"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2202,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "交叉跨越配置",
                "optionTypeKey": "crossing",
                "optionName": "跨越带电10kV电力线/跨越单回线路",
                "fieldName": "crossSingleLine2"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2203,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "交叉跨越配置",
                "optionTypeKey": "crossing",
                "optionName": "跨越带电10kV电力线/跨越双回及以上线路",
                "fieldName": "crossMultiLine2"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2204,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "交叉跨越配置",
                "optionTypeKey": "crossing",
                "optionName": "低压电力线",
                "fieldName": "lowPowerLine"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2205,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "交叉跨越配置",
                "optionTypeKey": "crossing",
                "optionName": "通信线路",
                "fieldName": "commLine"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2206,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "交叉跨越配置",
                "optionTypeKey": "crossing",
                "optionName": "可同行机动车的土路",
                "fieldName": "motorDirtRoad"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2207,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "交叉跨越配置",
                "optionTypeKey": "crossing",
                "optionName": "经济作物",
                "fieldName": "ecoCrops"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2208,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "交叉跨越配置",
                "optionTypeKey": "crossing",
                "optionName": "房屋",
                "fieldName": "building"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2209,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "交叉跨越配置",
                "optionTypeKey": "crossing",
                "optionName": "备注",
                "fieldName": "jckyNote"
            }
        ]
    },
    {
        "createBy": "",
        "createTime": null,
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 2210,
        "paramType": "设计参数",
        "paramTypeKey": "designParams",
        "optionType": "拉线配置",
        "optionTypeKey": "wireline",
        "optionName": "杆塔编号/设备名称",
        "fieldName": "rodTowerNo",
        "child": [
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2210,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "杆塔编号/设备名称",
                "fieldName": "rodTowerNo"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2211,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "杆型代号",
                "fieldName": "rodTypeModuleId"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2212,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "型号",
                "fieldName": "vlModuleId"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2213,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "拉线数量",
                "fieldName": "vlLxCount"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2214,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "拉盘",
                "fieldName": "vlMaterialId"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2215,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "拉盘数量",
                "fieldName": "vlLpCount"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2216,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "型号",
                "fieldName": "plModuleId"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2217,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "拉线数量",
                "fieldName": "plLxCount"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2218,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "拉盘",
                "fieldName": "plMaterialId"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2219,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "拉盘数量",
                "fieldName": "plLpCount"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2220,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "型号",
                "fieldName": "glModuleId"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2221,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "拉线数量",
                "fieldName": "glLxCount"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2222,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "拉盘",
                "fieldName": "glMaterialId"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2223,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "拉盘数量",
                "fieldName": "glLpCount"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2224,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "型号",
                "fieldName": "dlModuleId"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2225,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "拉线数量",
                "fieldName": "dlLxCount"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2226,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "钢绞线长度（m）",
                "fieldName": "dlGjxcd"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2227,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "对侧拉线抱箍型号",
                "fieldName": "dlLxbgxh"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2228,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "型号",
                "fieldName": "splModuleId"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2229,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "拉线数量",
                "fieldName": "splLxCount"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2230,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "拉盘",
                "fieldName": "splMaterialId"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2231,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "拉盘数量",
                "fieldName": "splLpCount"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2232,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "钢绞线长度（m）",
                "fieldName": "splGjxcd"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2233,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "水平拉电杆状态",
                "fieldName": "splState"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2234,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "水平拉电杆型号",
                "fieldName": "splRodId"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2235,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "型号",
                "fieldName": "ylModuleId"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2236,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "拉线数量",
                "fieldName": "ylLxCount"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2237,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "拉盘",
                "fieldName": "ylMaterialId"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2238,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "拉盘数量",
                "fieldName": "ylLpCount"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2239,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "型号",
                "fieldName": "qlModuleId"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2240,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "拉线数量",
                "fieldName": "qlLxCount"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2241,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "钢绞线长度（m）",
                "fieldName": "qlGjxcd"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2242,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "型号",
                "fieldName": "sglModuleId"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2243,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "拉线数量",
                "fieldName": "sglLxCount"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2244,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "拉盘1",
                "fieldName": "sglMaterialId1"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2245,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "拉盘1数量",
                "fieldName": "sglLpCount1"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2246,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "拉盘2",
                "fieldName": "sglMaterialId2"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2247,
                "paramType": "设计参数",
                "paramTypeKey": "designParams",
                "optionType": "拉线配置",
                "optionTypeKey": "wireline",
                "optionName": "拉盘2数量",
                "fieldName": "sglLpCount2"
            }
        ]
    },
    {
        "createBy": "",
        "createTime": null,
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 2248,
        "paramType": "造价参数",
        "paramTypeKey": "costParams",
        "optionType": "杆塔组立",
        "optionTypeKey": "costParam",
        "optionName": "杆塔编号/设备名称",
        "fieldName": "rodTowerNo",
        "child": [
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2248,
                "paramType": "造价参数",
                "paramTypeKey": "costParams",
                "optionType": "杆塔组立",
                "optionTypeKey": "costParam",
                "optionName": "杆塔编号/设备名称",
                "fieldName": "rodTowerNo"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2249,
                "paramType": "造价参数",
                "paramTypeKey": "costParams",
                "optionType": "杆塔组立",
                "optionTypeKey": "costParam",
                "optionName": "杆塔/设备状态",
                "fieldName": "moduleState"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2250,
                "paramType": "造价参数",
                "paramTypeKey": "costParams",
                "optionType": "杆塔组立",
                "optionTypeKey": "costParam",
                "optionName": "杆塔结构",
                "fieldName": "rodTowerMaterial"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2251,
                "paramType": "造价参数",
                "paramTypeKey": "costParams",
                "optionType": "杆塔组立",
                "optionTypeKey": "costParam",
                "optionName": "杆塔位置",
                "fieldName": "rodTowerPoint"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2252,
                "paramType": "造价参数",
                "paramTypeKey": "costParams",
                "optionType": "杆塔组立",
                "optionTypeKey": "costParam",
                "optionName": "基础路面结构类型",
                "fieldName": "groundType"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2253,
                "paramType": "造价参数",
                "paramTypeKey": "costParams",
                "optionType": "杆塔组立",
                "optionTypeKey": "costParam",
                "optionName": "地质情况",
                "fieldName": "geoCase"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2254,
                "paramType": "造价参数",
                "paramTypeKey": "costParams",
                "optionType": "杆塔组立",
                "optionTypeKey": "costParam",
                "optionName": "混凝土杆立杆方式",
                "fieldName": "rodMethod"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2255,
                "paramType": "造价参数",
                "paramTypeKey": "costParams",
                "optionType": "杆塔组立",
                "optionTypeKey": "costParam",
                "optionName": "杆塔坑开挖方式",
                "fieldName": "digMethod"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2256,
                "paramType": "造价参数",
                "paramTypeKey": "costParams",
                "optionType": "杆塔组立",
                "optionTypeKey": "costParam",
                "optionName": "杆塔坑开挖方案",
                "fieldName": "digPlan"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2257,
                "paramType": "造价参数",
                "paramTypeKey": "costParams",
                "optionType": "杆塔组立",
                "optionTypeKey": "costParam",
                "optionName": "备注",
                "fieldName": "costParamNote"
            }
        ]
    },
    {
        "createBy": "",
        "createTime": null,
        "updateBy": "",
        "updateTime": null,
        "remark": null,
        "skeId": 2258,
        "paramType": "造价参数",
        "paramTypeKey": "costParams",
        "optionType": "电缆敷设",
        "optionTypeKey": "cableLaying",
        "optionName": "杆塔编号/设备名称",
        "fieldName": "rodTowerNo",
        "child": [
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2258,
                "paramType": "造价参数",
                "paramTypeKey": "costParams",
                "optionType": "电缆敷设",
                "optionTypeKey": "cableLaying",
                "optionName": "杆塔编号/设备名称",
                "fieldName": "rodTowerNo"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2259,
                "paramType": "造价参数",
                "paramTypeKey": "costParams",
                "optionType": "电缆敷设",
                "optionTypeKey": "cableLaying",
                "optionName": "杆塔结构",
                "fieldName": "rodTowerMaterial"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2260,
                "paramType": "造价参数",
                "paramTypeKey": "costParams",
                "optionType": "电缆敷设",
                "optionTypeKey": "cableLaying",
                "optionName": "线缆状态",
                "fieldName": "wireModuleState"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2261,
                "paramType": "造价参数",
                "paramTypeKey": "costParams",
                "optionType": "电缆敷设",
                "optionTypeKey": "cableLaying",
                "optionName": "线缆类型",
                "fieldName": "writeType"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2262,
                "paramType": "造价参数",
                "paramTypeKey": "costParams",
                "optionType": "电缆敷设",
                "optionTypeKey": "cableLaying",
                "optionName": "线缆截面",
                "fieldName": "crossSectionAreaTwo"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2263,
                "paramType": "造价参数",
                "paramTypeKey": "costParams",
                "optionType": "电缆敷设",
                "optionTypeKey": "cableLaying",
                "optionName": "档距或总长(m)",
                "fieldName": "wireSpan"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2264,
                "paramType": "造价参数",
                "paramTypeKey": "costParams",
                "optionType": "电缆敷设",
                "optionTypeKey": "cableLaying",
                "optionName": "杆型代号",
                "fieldName": "rodTypeModuleId"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2265,
                "paramType": "造价参数",
                "paramTypeKey": "costParams",
                "optionType": "电缆敷设",
                "optionTypeKey": "cableLaying",
                "optionName": "直埋(m)",
                "fieldName": "directBurial"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2266,
                "paramType": "造价参数",
                "paramTypeKey": "costParams",
                "optionType": "电缆敷设",
                "optionTypeKey": "cableLaying",
                "optionName": "电缆沟(隧)道(m)",
                "fieldName": "cableTrench"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2267,
                "paramType": "造价参数",
                "paramTypeKey": "costParams",
                "optionType": "电缆敷设",
                "optionTypeKey": "cableLaying",
                "optionName": "排管内(m)",
                "fieldName": "pipeLaying"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2268,
                "paramType": "造价参数",
                "paramTypeKey": "costParams",
                "optionType": "电缆敷设",
                "optionTypeKey": "cableLaying",
                "optionName": "沿支架、墙面卡设(m)",
                "fieldName": "support"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2269,
                "paramType": "造价参数",
                "paramTypeKey": "costParams",
                "optionType": "电缆敷设",
                "optionTypeKey": "cableLaying",
                "optionName": "沿桥架(m)",
                "fieldName": "cableTray"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2270,
                "paramType": "造价参数",
                "paramTypeKey": "costParams",
                "optionType": "电缆敷设",
                "optionTypeKey": "cableLaying",
                "optionName": "竖直通道(m)",
                "fieldName": "channel"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2271,
                "paramType": "造价参数",
                "paramTypeKey": "costParams",
                "optionType": "电缆敷设",
                "optionTypeKey": "cableLaying",
                "optionName": "电缆上杆或进、出设备柜(m)",
                "fieldName": "cableOnPole"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2272,
                "paramType": "造价参数",
                "paramTypeKey": "costParams",
                "optionType": "电缆敷设",
                "optionTypeKey": "cableLaying",
                "optionName": "电缆调试说明",
                "fieldName": "cableDescribe"
            },
            {
                "createBy": "",
                "createTime": null,
                "updateBy": "",
                "updateTime": null,
                "remark": null,
                "skeId": 2273,
                "paramType": "造价参数",
                "paramTypeKey": "costParams",
                "optionType": "电缆敷设",
                "optionTypeKey": "cableLaying",
                "optionName": "备注",
                "fieldName": "layNote"
            }
        ]
    }
]

/**
 * 页面端条件错误导致的杆型无法匹配的提示词
 */
const fontCheckOpction = [
  {
    "weatherzone": "A#&#C#&#D1#&#D2#&#D4#&#D5#&#E1#&#E2",
    "loopNumber": "单回#&#双回",
    "rodTowerMaterial": "钢管杆",
    "rodTowerTypeCode": "1001#&#1002#&#1005#&#1006",
    "isLowPressure": "是",
    "marks": "钢管杆无带低压回路杆型，请调整参数。"
  },
  {
    "weatherzone": "A#&#C#&#D1#&#E1#&#E2",
    "loopNumber": "单回#&#双回",
    "rodTowerMaterial": "宽基塔",
    "rodTowerTypeCode": "3001#&#3002#&#3004#&#3005#&#3006",
    "isLowPressure": "是",
    "marks": "宽基塔无带低压回路杆型，请调整参数。"
  },
  {
    "weatherzone": "A#&#C#&#E1#&#E2",
    "loopNumber": "单回",
    "rodTowerMaterial": "双杆",
    "rodTowerTypeCode": "1001#&#2003#&#2004#&#2005#&#2006#&#1002",
    "isLowPressure": "是",
    "marks": "双杆无带低压回路杆型，请调整参数。"
  },
  {
    "weatherzone": "A#&#C#&#E1#&#E2",
    "loopNumber": "双回",
    "rodTowerMaterial": "双杆",
    "rodTowerTypeCode": "1001#&#2003#&#2004#&#2005#&#2006#&#1002",
    "isLowPressure": "否",
    "marks": "双杆无双回路杆型，请调整参数。"
  },
  {
    "weatherzone": "A#&#C#&#D1#&#D2#&#D4#&#D5#&#E1#&#E2",
    "loopNumber": "双回",
    "rodTowerMaterial": "侧担杆",
    "rodTowerTypeCode": "1003#&#1007#&#1001#&#1004#&#1005#&#1002",
    "isLowPressure": "否#&#是",
    "marks": "侧担杆无双回路杆型，请调整参数。"
  },
  {
    "weatherzone": "D1",
    "loopNumber": "双回",
    "rodTowerMaterial": "单杆",
    "rodTowerTypeCode": "1006#&#1001#&#1003#&#1004#&#1005#&#1007",
    "isLowPressure": "是",
    "marks": "在D1气象区，双回路单杆转角及耐张杆无带低压回路杆型 ，请调整参数。"
  },
  {
    "weatherzone": "D2",
    "loopNumber": "双回",
    "rodTowerMaterial": "单杆",
    "rodTowerTypeCode": "1006#&#1001#&#1003#&#1004#&#1005#&#1007",
    "isLowPressure": "是",
    "marks": "在D2气象区，双回路单杆转角及耐张杆无带低压回路杆型 ，请调整参数。"
  },
  {
    "weatherzone": "D4",
    "loopNumber": "双回",
    "rodTowerMaterial": "单杆",
    "rodTowerTypeCode": "1006#&#1001#&#1003#&#1004#&#1005#&#1007",
    "isLowPressure": "是",
    "marks": "在D4气象区，双回路单杆转角及耐张杆无带低压回路杆型 ，请调整参数。"
  },
  {
    "weatherzone": "D5",
    "loopNumber": "双回",
    "rodTowerMaterial": "单杆",
    "rodTowerTypeCode": "1006#&#1001#&#1003#&#1004#&#1005#&#1007",
    "isLowPressure": "是",
    "marks": "在D5气象区，双回路单杆转角及耐张杆无带低压回路杆型 ，请调整参数。"
  }
]

export default {
    container: "luckysheet", //容器的ID
    loading:{
        image: () => {
            return `<svg viewBox="25 25 50 50" class="circular">
            <circle cx="50" cy="50" r="20" fill="none"></circle>
            </svg>`
        },
        imageClass: "loadingAnimation"
    }, //自定义loading
    column: 60, //空表格默认的列数量
    row: 84, //空表格默认的行数据量
    allowCopy: true, //是否允许拷贝
    showtoolbar: true, //是否第二列显示工具栏
    showinfobar: true, //是否显示顶部名称栏
    showsheetbar: false, //是否显示底部表格名称区域
    showstatisticBar: false, //是否显示底部计数栏
    pointEdit: false, //是否是编辑器插入表格模式
    pointEditUpdate: null, //编辑器表格更新函数
    pointEditZoom: 1, //编辑器表格编辑时缩放比例
    // menu: "undo|redo|freezenrow|freezencolumn|download|share|chart|pivot",
    data: [{ "name": "Sheet1", color: "", "status": "1", "order": "0", "data": [], "config": {}, "index":0 }, { "name": "Sheet2", color: "", "status": "0", "order": "1", "data": [], "config": {}, "index":1  }, { "name": "Sheet3", color: "", "status": "0", "order": "2", "data": [], "config": {}, "index":2  }], //客户端sheet数据[sheet1, sheet2, sheet3]
    title: "Demo", //表格的名称
    userInfo:false,// 右上角的用户信息展示样式，支持 1. boolean类型：false:不展示，true:展示默认 '<i style="font-size:16px;color:#ff6a00;" class="fa fa-taxi" aria-hidden="true"></i> rabbit' ，2. HTML模板字符串或者普通字符串，如：'<i style="font-size:16px;color:#ff6a00;" class="fa fa-taxi" aria-hidden="true"></i> Lucky'或者'用户名'， 3. 对象格式，设置 userImage：用户头像地址 和 userName：用户名 4. 不设置或者设置undefined同设置false
    userMenuItem: [{url:"www.baidu.com", "icon":'<i class="fa fa-folder" aria-hidden="true"></i>', "name":"我的表格"}, {url:"www.baidu.com", "icon":'<i class="fa fa-sign-out" aria-hidden="true"></i>', "name":"退出登陆"}], //点击右上角的用户信息弹出的菜单
    myFolderUrl: "www.baidu.com", //左上角<返回按钮的链接
    config: {}, //表格行高、列宽、合并单元格、公式等设置
    pdfPageInfo: { // 表格预览 || 导出的 页面配置
      'IsLandscape': false, // 横版
      'LeftMargin': 0, // 左边距
      'RightMargin': 200, // 右边距
      'TopMargin': 200, // 上边距
      'BottomMargin': 200, // 下边距
      'ScaleToPages': 0, // 缩放至一页
      'ScaleToPagesX': 0, // 缩放列至一页
      'ScaleToPagesY': 0, // 缩放行至一页
      'Size': { // 尺寸（与IsLandscape联动【默认横向时width为Size中max(Width, Height)，height为Size中min(Width, Height)；竖向时width为Size中min(Width, Height)，height为Size中max(Width, Height)】）
        'Height': 29700, // 宽
        'Width': 21000 // 高
      }
    },
    printData:{}, // 表格打印配置
    fullscreenmode: true, //是否全屏模式，非全屏模式下，标记框不会强制选中。
    devicePixelRatio: window.devicePixelRatio, //设备比例，比例越大表格分标率越高
    allowEdit: false, //是否允许前台编辑
    metadataEdit: false, // 元数据允许编辑
    loadUrl: "", // 配置loadUrl的地址，luckysheet会通过ajax请求表格数据，默认载入status为1的sheet数据中的所有data，其余的sheet载入除data字段外的所有字段
    loadSheetUrl: "", //配置loadSheetUrl的地址，参数为gridKey（表格主键） 和 index（sheet主键合集，格式为[1,2,3]），返回的数据为sheet的data字段数据集合
    gridKey: "", // 表格唯一标识符
    updateUrl: "", //表格数据的更新地址
    updateImageUrl: "", //缩略图的更新地址
    allowUpdate: false, //是否允许编辑后的后台更新
    functionButton: "", //右上角功能按钮，例如'<button id="" class="btn btn-primary" style="padding:3px 6px;font-size: 12px;margin-right: 10px;">下载</button>    <button id="" class="btn btn-primary btn-danger" style="    padding:3px 6px;    font-size: 12px;    margin-right: 10px;">分享</button>    <button id="luckysheet-share-btn-title" class="btn btn-primary btn-danger" style="    padding:3px 6px;    font-size: 12px;    margin-right: 10px;">秀数据</button>'
    showConfigWindowResize: true, //图表和数据透视表的配置会在右侧弹出，设置弹出后表格是否会自动缩进
    enableAddRow: false,//允许添加行
    enableAddBackTop: true,//允许回到顶部
    // enablePage: false,//允许加载下一页
    autoFormatw: false,  //自动格式化超过4位数的数字为 亿万格式 例：true or "true" or "TRUE"
    accuracy: undefined,  //设置传输来的数值的精确位数，小数点后n位 传参数为数字或数字字符串，例： "0" 或 0
    pageInfo:{
        'queryExps':'',
        'reportId':'',
        'fields':'',
        'mobile':'',
        'frezon':'',
        'currentPage':'',
        "totalPage":10,
        "pageUrl":"",
    },
    editMode: false, //是否为编辑模式
    beforeCreateDom: null,//表格创建之前的方法
    fireMousedown: null, //单元格数据下钻
    lang: 'en', //language
    plugins: [], //plugins, e.g. ['chart']
    forceCalculation:false,//强制刷新公式，公式较多会有性能问题，慎用
    rowHeaderWidth: 70, // 序号栏宽度
    showCheckbox: true, // 是否展示复选框
    checkboxWidth: 30, // 复选框宽度
    columnHeaderHeight: 130, //表头高度
    defaultColWidth:73,
    defaultRowHeight:24,
    defaultFontSize:11,
    limitSheetNameLength:true,    //是否限制工作表名的长度
    defaultSheetNameMaxLength:31,  //默认工作表名称的最大长度
    sheetFormulaBar:false, //是否显示公式栏
    showtoolbarConfig:{}, //自定义工具栏
    showsheetbarConfig:{}, //自定义底部sheet页
    showstatisticBarConfig:{}, //自定义计数栏
    cellRightClickConfig:{
      copy: true, // 复制
      copyAs: false, // 复制为
      paste: true, // 粘贴
      shear: true, // 剪切
      insertRow: true, // 插入行
      insertColumn: false, // 插入列
      deleteRow: true, // 删除选中行
      deleteColumn: false, // 删除选中列
      deleteCell: false, // 删除单元格
      hideRow: false, // 隐藏选中行和显示选中行
      hideColumn: true, // 隐藏选中列和显示选中列
      rowHeight: false, // 行高
      columnWidth: false, // 列宽
      clear: false, // 清除内容
      matrix: false, // 矩阵操作选区
      sort: false, // 排序选区
      filter: false, // 筛选选区
      chart: false, // 图表生成
      image: false, // 插入图片
      link: false, // 插入链接
      data: false, // 数据验证
      cellFormat: false, // 设置单元格格式
      relieve: true, //解除关联
    }, //自定义单元格右键菜单
    sheetRightClickConfig:{}, //自定义底部sheet页右击菜单
    imageUpdateMethodConfig:{}, //自定义图片同步方式
    showtoolbarListenConfig:{}, //自定义工具栏监听事件
    luckysheetupdateCellConfig: {}, // 单元格双击点击事件
    focusingCellConfig: {}, // 单元格聚焦点击事件
    imgFocusCellConfig: {}, // 图片聚焦点击事件
    menuButtonCellConfig: {}, // 菜单按钮事件
    extendedParameters: {
        isImageDrag: true, // 图片是否可拖拽
    },
    isImageLs: true, // 图片是否可拉伸
    customColumnTitles: customColumnTitles, // 表头
    mergeCol: mergeCol, // 需要合并的表头
    dropDrownObj: null, //下拉框数据
    errorRow: [], // 报错行
    editRow: [], // 编辑行
    fullCellTower: {}, //自动填充杆头信息
    sheetSave: { // 保存
      call: function() {
        console.log('当前表格的页面配置', luckysheet.getPagePdfConfig())
        console.log('当前表格的页面配置', luckysheet.getConfig())
        console.log('当前tojson', luckysheet.toJson())
        console.log('当前表格值', luckysheet.getcellvalue())
      }
    },
    sheetBranch: { // 设置分支线路电源点
      call: function(luckysheet_select_save) {
        console.log('branch', luckysheet_select_save)
      }
    },
    sheetCalculation: { // 量价计算
      call: function() {
        console.log('sheetCalculation')
      }
    },
    sheetRelieve: { // 解除关联
      call: function(list) {
        console.log('解除关联', list)
      }
    },
    towerHead: { // 杆头配置
      call: function(list) {
        console.log('杆头配置', list)
      }
    },
    verifyData: { // 数据查验
      call: function(list) {
        console.log('数据查验', list)
      }
    },
    costParam: { // 杆塔组立
      call: function(list) {
        console.log('杆塔组立', list)
      }
    },
    cable: { // 电缆
      call: function(list) {
        console.log('电缆', list)
      }
    },
    cableLaying: { // 电缆敷设
      call: function(list) {
        console.log('电缆敷设', list)
      }
    },
    towerHeadDialog: { // 杆头弹框
      call: function(rowIndex, colIndex) {
        console.log('杆头弹框', rowIndex, colIndex)
      }
    },
    tabPanel: tabPanel, // tab面板配置
    getAjax: getAjax, // 获取接口数据
    getUniqueId: getUniqueId,
    isEmptyString: isEmptyString,
    defaultColor: '#000',
    branchColor: '#FFC300', // 分支线路电源点字体颜色
    markColor: '#e33c64', // 备注字体颜色
    activePanel: 'wire', // 默认选中表头类别
    verityShow: true, // 数智查验显隐
    fontCheckOpction,
    projectData: {
    "projectId": 2954,
    "geoConfig": {
        "city": "福州市",
        "county": "鼓楼区",
        "dirtyDensity": "＞0.1～0.25",
        "dirtyDistance": "≥5.2",
        "dirtyLevel": "重污区d",
        "disasterLevel": "Z2",
        "disasterScene": "山区",
        "district": "鼓东街道",
        "fullName": "福州市鼓楼区鼓东街道",
        "iceLevel": "轻冰区",
        "iceThickness": "＞5至≤10",
        "info": "城区（市区含县级市）",
        "params": {},
        "skeId": 1,
        "sortNum": 1,
        "thunderAccount": "Td＞90d",
        "thunderDensity": "Ng≥7.98",
        "thunderLevel": "强雷区D",
        "type": "A+",
        "weatherLevel": "≤30",
        "weatherzone": "C"
    },
    "globalConfig": {
        "poleMaterial": "普通非预应力",
        "tyingMethod": "铜塑线",
        "tensionClampTypeJY": "剥皮NXL",
        "tensionClampTypeL": "螺栓型NLL",
        "parallelTrenchClampType": "铝绞线C形线夹",
        "comprehensiveCoefficient": "1.03",
        "lightningArresterType": "可装卸式",
        "withLeadWire": "是",
        "resetWireClamp": "是",
        "includeOutWire": "不包含出线部分",
        "arresterGroundingType": "BV-35",
        "cableLayingRelaxation": "1.025",
        "fireproofMaterial": "防火堵料",
        "fireproofMaterialWeight": "5",
        "cableTest": "交流耐压试验"
    },
    "disBaseConfig": [
        {
            "componentType": "2",
            "createTime": "2025-10-11 11:33:36",
            "crossArmType": "双横担",
            "crossArmTypeVal": "双横担",
            "disasterLevel": "Z2",
            "disasterScene": "山区",
            "isBase": "否",
            "jumperInsulatorType": "瓷横担绝缘子#&#固定间隙避雷器#&#35kV柱式复合绝缘子",
            "jumperInsulatorTypeVal": "瓷横担绝缘子",
            "params": {},
            "skeId": 4,
            "weatherzone": "C",
            "crossArmTypeOptions": [
                "双横担"
            ],
            "straightInsulatorTypeOptions": [],
            "tensionInsulatorTypeOptions": [],
            "jumperInsulatorTypeOptions": [
                "瓷横担绝缘子",
                "固定间隙避雷器",
                "35kV柱式复合绝缘子"
            ]
        },
        {
            "componentType": "2",
            "createTime": "2025-10-11 11:33:36",
            "crossArmType": "双横担",
            "crossArmTypeVal": "双横担",
            "disasterLevel": "Z2",
            "disasterScene": "山区",
            "isBase": "是",
            "jumperInsulatorType": "柱式瓷绝缘子#&#10kV柱式复合绝缘子",
            "jumperInsulatorTypeVal": "柱式瓷绝缘子",
            "params": {},
            "skeId": 17,
            "weatherzone": "C",
            "crossArmTypeOptions": [
                "双横担"
            ],
            "straightInsulatorTypeOptions": [],
            "tensionInsulatorTypeOptions": [],
            "jumperInsulatorTypeOptions": [
                "柱式瓷绝缘子",
                "10kV柱式复合绝缘子"
            ]
        }
    ],
    "disRodConfig": [
        {
            "componentType": "2",
            "createTime": "2025-11-19 16:02:39",
            "crossArmType": "单横担#&#双横担",
            "crossArmTypeVal": "单横担",
            "disasterLevel": "Z2",
            "disasterScene": "山区",
            "equipmentInsulatorType": "绝缘横担引下线跳线绝缘子",
            "equipmentInsulatorTypeVal": "绝缘横担引下线跳线绝缘子",
            "fuseType": "跌落式#&#封闭式",
            "fuseTypeVal": "跌落式",
            "isBase": "否",
            "isGrounding": "是#&#否",
            "isGroundingVal": "否",
            "isolatingSwitchType": "瓷绝缘子#&#复合绝缘子",
            "isolatingSwitchTypeVal": "瓷绝缘子",
            "jumperInsulatorType": "瓷横担绝缘子#&#固定间隙避雷器#&#35kV柱式复合绝缘子",
            "jumperInsulatorTypeVal": "瓷横担绝缘子",
            "leadSupportInsulatorType": "瓷横担绝缘子#&#35kV柱式复合绝缘子",
            "leadSupportInsulatorTypeVal": "瓷横担绝缘子",
            "params": {},
            "skeId": 60,
            "straightCornerInsulatorType": "瓷横担绝缘子",
            "straightCornerInsulatorTypeVal": "瓷横担绝缘子",
            "straightInsulatorType": "瓷横担绝缘子#&#普通弯矩复合绝缘横担#&#大弯矩复合绝缘横担",
            "straightInsulatorTypeVal": "瓷横担绝缘子",
            "tensionInsulatorType": "3片盘形悬式瓷绝缘子#&#4片盘形悬式瓷绝缘子#&#35kV棒形悬式复合绝缘子",
            "tensionInsulatorTypeVal": "3片盘形悬式瓷绝缘子",
            "weatherzone": "C",
            "crossArmTypeOptions": [
                "单横担",
                "双横担"
            ],
            "equipmentInsulatorTypeOptions": [
                "绝缘横担引下线跳线绝缘子"
            ],
            "fuseTypeOptions": [
                "跌落式",
                "封闭式"
            ],
            "isGroundingOptions": [
                "是",
                "否"
            ],
            "isolatingSwitchTypeOptions": [
                "瓷绝缘子",
                "复合绝缘子"
            ],
            "jumperInsulatorTypeOptions": [
                "瓷横担绝缘子",
                "固定间隙避雷器",
                "35kV柱式复合绝缘子"
            ],
            "leadSupportInsulatorTypeOptions": [
                "瓷横担绝缘子",
                "35kV柱式复合绝缘子"
            ],
            "straightCornerInsulatorTypeOptions": [
                "瓷横担绝缘子"
            ],
            "straightInsulatorTypeOptions": [
                "瓷横担绝缘子",
                "普通弯矩复合绝缘横担",
                "大弯矩复合绝缘横担"
            ],
            "tensionInsulatorTypeOptions": [
                "3片盘形悬式瓷绝缘子",
                "4片盘形悬式瓷绝缘子",
                "35kV棒形悬式复合绝缘子"
            ]
        },
        {
            "componentType": "2",
            "createTime": "2025-11-19 16:02:39",
            "crossArmType": "单横担#&#双横担",
            "crossArmTypeVal": "单横担",
            "disasterLevel": "Z2",
            "disasterScene": "山区",
            "equipmentInsulatorTypeVal": "无",
            "fuseType": "跌落式#&#封闭式",
            "fuseTypeVal": "跌落式",
            "isBase": "是",
            "isGrounding": "是",
            "isGroundingVal": "是",
            "isolatingSwitchType": "瓷绝缘子#&#复合绝缘子",
            "isolatingSwitchTypeVal": "瓷绝缘子",
            "jumperInsulatorType": "柱式瓷绝缘子#&#10kV柱式复合绝缘子",
            "jumperInsulatorTypeVal": "柱式瓷绝缘子",
            "leadSupportInsulatorType": "柱式瓷绝缘子#&#10kV柱式复合绝缘子",
            "leadSupportInsulatorTypeVal": "柱式瓷绝缘子",
            "params": {},
            "skeId": 73,
            "straightCornerInsulatorType": "柱式瓷绝缘子#&#10kV柱式复合绝缘子",
            "straightCornerInsulatorTypeVal": "柱式瓷绝缘子",
            "straightInsulatorType": "柱式瓷绝缘子#&#10kV柱式复合绝缘子",
            "straightInsulatorTypeVal": "柱式瓷绝缘子",
            "tensionInsulatorType": "2片盘形悬式瓷绝缘子#&#10kV棒形悬式复合绝缘子",
            "tensionInsulatorTypeVal": "2片盘形悬式瓷绝缘子",
            "weatherzone": "C",
            "crossArmTypeOptions": [
                "单横担",
                "双横担"
            ],
            "equipmentInsulatorTypeOptions": [],
            "fuseTypeOptions": [
                "跌落式",
                "封闭式"
            ],
            "isGroundingOptions": [
                "是"
            ],
            "isolatingSwitchTypeOptions": [
                "瓷绝缘子",
                "复合绝缘子"
            ],
            "jumperInsulatorTypeOptions": [
                "柱式瓷绝缘子",
                "10kV柱式复合绝缘子"
            ],
            "leadSupportInsulatorTypeOptions": [
                "柱式瓷绝缘子",
                "10kV柱式复合绝缘子"
            ],
            "straightCornerInsulatorTypeOptions": [
                "柱式瓷绝缘子",
                "10kV柱式复合绝缘子"
            ],
            "straightInsulatorTypeOptions": [
                "柱式瓷绝缘子",
                "10kV柱式复合绝缘子"
            ],
            "tensionInsulatorTypeOptions": [
                "2片盘形悬式瓷绝缘子",
                "10kV棒形悬式复合绝缘子"
            ]
        }
    ],
    "disSteelConfig": [
        {
            "componentType": "2",
            "createTime": "2025-10-11 11:34:34",
            "crossArmType": "双横担",
            "crossArmTypeVal": "双横担",
            "disasterLevel": "Z2",
            "disasterScene": "山区",
            "isBase": "否",
            "jumperInsulatorType": "瓷横担绝缘子#&#固定间隙避雷器#&#35kV柱式复合绝缘子",
            "jumperInsulatorTypeVal": "瓷横担绝缘子",
            "params": {},
            "skeId": 4,
            "straightInsulatorType": "柱式瓷绝缘子#&#10kV柱式复合绝缘子",
            "straightInsulatorTypeVal": "柱式瓷绝缘子",
            "tensionInsulatorType": "3片盘形悬式瓷绝缘子#&#4片盘形悬式瓷绝缘子#&#35kV棒形悬式复合绝缘子",
            "tensionInsulatorTypeVal": "3片盘形悬式瓷绝缘子",
            "weatherzone": "C",
            "crossArmTypeOptions": [
                "双横担"
            ],
            "jumperInsulatorTypeOptions": [
                "瓷横担绝缘子",
                "固定间隙避雷器",
                "35kV柱式复合绝缘子"
            ],
            "straightInsulatorTypeOptions": [
                "柱式瓷绝缘子",
                "10kV柱式复合绝缘子"
            ],
            "tensionInsulatorTypeOptions": [
                "3片盘形悬式瓷绝缘子",
                "4片盘形悬式瓷绝缘子",
                "35kV棒形悬式复合绝缘子"
            ]
        },
        {
            "componentType": "2",
            "createTime": "2025-10-11 11:34:34",
            "crossArmType": "双横担",
            "crossArmTypeVal": "双横担",
            "disasterLevel": "Z2",
            "disasterScene": "山区",
            "isBase": "是",
            "jumperInsulatorType": "柱式瓷绝缘子#&#10kV柱式复合绝缘子",
            "jumperInsulatorTypeVal": "柱式瓷绝缘子",
            "params": {},
            "skeId": 17,
            "straightInsulatorType": "柱式瓷绝缘子#&#10kV柱式复合绝缘子",
            "straightInsulatorTypeVal": "柱式瓷绝缘子",
            "tensionInsulatorType": "2片盘形悬式瓷绝缘子#&#10kV棒形悬式复合绝缘子",
            "tensionInsulatorTypeVal": "2片盘形悬式瓷绝缘子",
            "weatherzone": "C",
            "crossArmTypeOptions": [
                "双横担"
            ],
            "jumperInsulatorTypeOptions": [
                "柱式瓷绝缘子",
                "10kV柱式复合绝缘子"
            ],
            "straightInsulatorTypeOptions": [
                "柱式瓷绝缘子",
                "10kV柱式复合绝缘子"
            ],
            "tensionInsulatorTypeOptions": [
                "2片盘形悬式瓷绝缘子",
                "10kV棒形悬式复合绝缘子"
            ]
        }
    ],
    "disTwinConfig": [
        {
            "componentType": "2",
            "createTime": "2025-10-11 11:35:00",
            "crossArmType": "双横担",
            "crossArmTypeVal": "双横担",
            "disasterLevel": "Z2",
            "disasterScene": "山区",
            "isBase": "否",
            "isGrounding": "是#&#否",
            "isGroundingVal": "否",
            "isolatingSwitchType": "瓷绝缘子#&#复合绝缘子",
            "isolatingSwitchTypeVal": "瓷绝缘子",
            "jumperInsulatorType": "瓷横担绝缘子#&#固定间隙避雷器#&#35kV柱式复合绝缘子",
            "jumperInsulatorTypeVal": "瓷横担绝缘子",
            "leadSupportInsulatorType": "瓷横担绝缘子#&#35kV柱式复合绝缘子",
            "leadSupportInsulatorTypeVal": "瓷横担绝缘子",
            "params": {},
            "skeId": 4,
            "straightInsulatorType": "悬垂3片盘形悬式瓷绝缘子串#&#悬垂35kV棒形悬式复合绝缘子串#&#悬垂绝缘横担",
            "straightInsulatorTypeVal": "悬垂3片盘形悬式瓷绝缘子串",
            "tensionInsulatorType": "3片盘形悬式瓷绝缘子#&#4片盘形悬式瓷绝缘子#&#35kV棒形悬式复合绝缘子",
            "tensionInsulatorTypeVal": "3片盘形悬式瓷绝缘子",
            "weatherzone": "C",
            "crossArmTypeOptions": [
                "双横担"
            ],
            "isGroundingOptions": [
                "是",
                "否"
            ],
            "isolatingSwitchTypeOptions": [
                "瓷绝缘子",
                "复合绝缘子"
            ],
            "jumperInsulatorTypeOptions": [
                "瓷横担绝缘子",
                "固定间隙避雷器",
                "35kV柱式复合绝缘子"
            ],
            "leadSupportInsulatorTypeOptions": [
                "瓷横担绝缘子",
                "35kV柱式复合绝缘子"
            ],
            "straightInsulatorTypeOptions": [
                "悬垂3片盘形悬式瓷绝缘子串",
                "悬垂35kV棒形悬式复合绝缘子串",
                "悬垂绝缘横担"
            ],
            "tensionInsulatorTypeOptions": [
                "3片盘形悬式瓷绝缘子",
                "4片盘形悬式瓷绝缘子",
                "35kV棒形悬式复合绝缘子"
            ]
        },
        {
            "componentType": "2",
            "createTime": "2025-10-11 11:35:00",
            "crossArmType": "双横担",
            "crossArmTypeVal": "双横担",
            "disasterLevel": "Z2",
            "disasterScene": "山区",
            "isBase": "是",
            "isGrounding": "是",
            "isGroundingVal": "是",
            "isolatingSwitchType": "瓷绝缘子#&#复合绝缘子",
            "isolatingSwitchTypeVal": "瓷绝缘子",
            "jumperInsulatorType": "柱式瓷绝缘子#&#10kV柱式复合绝缘子",
            "jumperInsulatorTypeVal": "柱式瓷绝缘子",
            "leadSupportInsulatorType": "柱式瓷绝缘子#&#10kV柱式复合绝缘子",
            "leadSupportInsulatorTypeVal": "柱式瓷绝缘子",
            "params": {},
            "skeId": 17,
            "straightInsulatorType": "悬垂2片盘形悬式瓷绝缘子串",
            "straightInsulatorTypeVal": "悬垂2片盘形悬式瓷绝缘子串",
            "tensionInsulatorType": "2片盘形悬式瓷绝缘子#&#10kV棒形悬式复合绝缘子",
            "tensionInsulatorTypeVal": "2片盘形悬式瓷绝缘子",
            "weatherzone": "C",
            "crossArmTypeOptions": [
                "双横担"
            ],
            "isGroundingOptions": [
                "是"
            ],
            "isolatingSwitchTypeOptions": [
                "瓷绝缘子",
                "复合绝缘子"
            ],
            "jumperInsulatorTypeOptions": [
                "柱式瓷绝缘子",
                "10kV柱式复合绝缘子"
            ],
            "leadSupportInsulatorTypeOptions": [
                "柱式瓷绝缘子",
                "10kV柱式复合绝缘子"
            ],
            "straightInsulatorTypeOptions": [
                "悬垂2片盘形悬式瓷绝缘子串"
            ],
            "tensionInsulatorTypeOptions": [
                "2片盘形悬式瓷绝缘子",
                "10kV棒形悬式复合绝缘子"
            ]
        }
    ],
    "disTowerConfig": [
        {
            "componentType": "2",
            "createTime": "2025-11-19 16:03:16",
            "crossArmType": "单横担#&#双横担",
            "crossArmTypeVal": "单横担",
            "disasterLevel": "Z2",
            "disasterScene": "山区",
            "equipmentInsulatorType": "绝缘横担引下线跳线绝缘子",
            "equipmentInsulatorTypeVal": "绝缘横担引下线跳线绝缘子",
            "fuseType": "跌落式#&#封闭式",
            "fuseTypeVal": "跌落式",
            "isBase": "否",
            "isGrounding": "是#&#否",
            "isGroundingVal": "否",
            "isolatingSwitchType": "瓷绝缘子#&#复合绝缘子",
            "isolatingSwitchTypeVal": "瓷绝缘子",
            "jumperInsulatorType": "瓷横担绝缘子#&#固定间隙避雷器#&#35kV柱式复合绝缘子",
            "jumperInsulatorTypeVal": "瓷横担绝缘子",
            "leadSupportInsulatorType": "瓷横担绝缘子#&#35kV柱式复合绝缘子",
            "leadSupportInsulatorTypeVal": "瓷横担绝缘子",
            "params": {},
            "skeId": 60,
            "straightCornerInsulatorType": "瓷横担绝缘子",
            "straightCornerInsulatorTypeVal": "瓷横担绝缘子",
            "straightInsulatorType": "瓷横担绝缘子#&#普通弯矩复合绝缘横担#&#大弯矩复合绝缘横担",
            "straightInsulatorTypeVal": "瓷横担绝缘子",
            "tensionInsulatorType": "3片盘形悬式瓷绝缘子#&#4片盘形悬式瓷绝缘子#&#35kV棒形悬式复合绝缘子",
            "tensionInsulatorTypeVal": "3片盘形悬式瓷绝缘子",
            "weatherzone": "C",
            "crossArmTypeOptions": [
                "单横担",
                "双横担"
            ],
            "equipmentInsulatorTypeOptions": [
                "绝缘横担引下线跳线绝缘子"
            ],
            "fuseTypeOptions": [
                "跌落式",
                "封闭式"
            ],
            "isGroundingOptions": [
                "是",
                "否"
            ],
            "isolatingSwitchTypeOptions": [
                "瓷绝缘子",
                "复合绝缘子"
            ],
            "jumperInsulatorTypeOptions": [
                "瓷横担绝缘子",
                "固定间隙避雷器",
                "35kV柱式复合绝缘子"
            ],
            "leadSupportInsulatorTypeOptions": [
                "瓷横担绝缘子",
                "35kV柱式复合绝缘子"
            ],
            "straightCornerInsulatorTypeOptions": [
                "瓷横担绝缘子"
            ],
            "straightInsulatorTypeOptions": [
                "瓷横担绝缘子",
                "普通弯矩复合绝缘横担",
                "大弯矩复合绝缘横担"
            ],
            "tensionInsulatorTypeOptions": [
                "3片盘形悬式瓷绝缘子",
                "4片盘形悬式瓷绝缘子",
                "35kV棒形悬式复合绝缘子"
            ]
        },
        {
            "componentType": "2",
            "createTime": "2025-11-19 16:03:16",
            "crossArmType": "单横担#&#双横担",
            "crossArmTypeVal": "单横担",
            "disasterLevel": "Z2",
            "disasterScene": "山区",
            "equipmentInsulatorTypeVal": "无",
            "fuseType": "跌落式#&#封闭式",
            "fuseTypeVal": "跌落式",
            "isBase": "是",
            "isGrounding": "是",
            "isGroundingVal": "是",
            "isolatingSwitchType": "瓷绝缘子#&#复合绝缘子",
            "isolatingSwitchTypeVal": "瓷绝缘子",
            "jumperInsulatorType": "柱式瓷绝缘子#&#10kV柱式复合绝缘子",
            "jumperInsulatorTypeVal": "柱式瓷绝缘子",
            "leadSupportInsulatorType": "柱式瓷绝缘子#&#10kV柱式复合绝缘子",
            "leadSupportInsulatorTypeVal": "柱式瓷绝缘子",
            "params": {},
            "skeId": 73,
            "straightCornerInsulatorType": "柱式瓷绝缘子#&#10kV柱式复合绝缘子",
            "straightCornerInsulatorTypeVal": "柱式瓷绝缘子",
            "straightInsulatorType": "柱式瓷绝缘子#&#10kV柱式复合绝缘子",
            "straightInsulatorTypeVal": "柱式瓷绝缘子",
            "tensionInsulatorType": "2片盘形悬式瓷绝缘子#&#10kV棒形悬式复合绝缘子",
            "tensionInsulatorTypeVal": "2片盘形悬式瓷绝缘子",
            "weatherzone": "C",
            "crossArmTypeOptions": [
                "单横担",
                "双横担"
            ],
            "equipmentInsulatorTypeOptions": [],
            "fuseTypeOptions": [
                "跌落式",
                "封闭式"
            ],
            "isGroundingOptions": [
                "是"
            ],
            "isolatingSwitchTypeOptions": [
                "瓷绝缘子",
                "复合绝缘子"
            ],
            "jumperInsulatorTypeOptions": [
                "柱式瓷绝缘子",
                "10kV柱式复合绝缘子"
            ],
            "leadSupportInsulatorTypeOptions": [
                "柱式瓷绝缘子",
                "10kV柱式复合绝缘子"
            ],
            "straightCornerInsulatorTypeOptions": [
                "柱式瓷绝缘子",
                "10kV柱式复合绝缘子"
            ],
            "straightInsulatorTypeOptions": [
                "柱式瓷绝缘子",
                "10kV柱式复合绝缘子"
            ],
            "tensionInsulatorTypeOptions": [
                "2片盘形悬式瓷绝缘子",
                "10kV棒形悬式复合绝缘子"
            ]
        }
    ],
    "disSideConfig": [
        {
            "componentType": "2",
            "createTime": "2025-11-19 16:02:56",
            "crossArmType": "单横担#&#双横担",
            "crossArmTypeVal": "单横担",
            "disasterLevel": "Z2",
            "disasterScene": "山区",
            "equipmentInsulatorType": "绝缘横担引下线跳线绝缘子",
            "equipmentInsulatorTypeVal": "绝缘横担引下线跳线绝缘子",
            "fuseType": "跌落式#&#封闭式",
            "fuseTypeVal": "跌落式",
            "isBase": "否",
            "isGrounding": "是#&#否",
            "isGroundingVal": "否",
            "isolatingSwitchType": "瓷绝缘子#&#复合绝缘子",
            "isolatingSwitchTypeVal": "瓷绝缘子",
            "jumperInsulatorType": "瓷横担绝缘子#&#固定间隙避雷器#&#35kV柱式复合绝缘子",
            "jumperInsulatorTypeVal": "瓷横担绝缘子",
            "leadSupportInsulatorType": "瓷横担绝缘子#&#35kV柱式复合绝缘子",
            "leadSupportInsulatorTypeVal": "瓷横担绝缘子",
            "params": {},
            "skeId": 60,
            "straightCornerInsulatorType": "柱式瓷绝缘子#&#10kV柱式复合绝缘子",
            "straightCornerInsulatorTypeVal": "柱式瓷绝缘子",
            "straightInsulatorType": "柱式瓷绝缘子#&#10kV柱式复合绝缘子",
            "straightInsulatorTypeVal": "柱式瓷绝缘子",
            "tensionInsulatorType": "3片盘形悬式瓷绝缘子#&#4片盘形悬式瓷绝缘子#&#35kV棒形悬式复合绝缘子",
            "tensionInsulatorTypeVal": "3片盘形悬式瓷绝缘子",
            "weatherzone": "C",
            "crossArmTypeOptions": [
                "单横担",
                "双横担"
            ],
            "equipmentInsulatorTypeOptions": [
                "绝缘横担引下线跳线绝缘子"
            ],
            "fuseTypeOptions": [
                "跌落式",
                "封闭式"
            ],
            "isGroundingOptions": [
                "是",
                "否"
            ],
            "isolatingSwitchTypeOptions": [
                "瓷绝缘子",
                "复合绝缘子"
            ],
            "jumperInsulatorTypeOptions": [
                "瓷横担绝缘子",
                "固定间隙避雷器",
                "35kV柱式复合绝缘子"
            ],
            "leadSupportInsulatorTypeOptions": [
                "瓷横担绝缘子",
                "35kV柱式复合绝缘子"
            ],
            "straightCornerInsulatorTypeOptions": [
                "柱式瓷绝缘子",
                "10kV柱式复合绝缘子"
            ],
            "straightInsulatorTypeOptions": [
                "柱式瓷绝缘子",
                "10kV柱式复合绝缘子"
            ],
            "tensionInsulatorTypeOptions": [
                "3片盘形悬式瓷绝缘子",
                "4片盘形悬式瓷绝缘子",
                "35kV棒形悬式复合绝缘子"
            ]
        },
        {
            "componentType": "2",
            "createTime": "2025-11-19 16:02:56",
            "crossArmType": "单横担#&#双横担",
            "crossArmTypeVal": "单横担",
            "disasterLevel": "Z2",
            "disasterScene": "山区",
            "equipmentInsulatorTypeVal": "无",
            "fuseType": "跌落式#&#封闭式",
            "fuseTypeVal": "跌落式",
            "isBase": "是",
            "isGrounding": "是",
            "isGroundingVal": "是",
            "isolatingSwitchType": "瓷绝缘子#&#复合绝缘子",
            "isolatingSwitchTypeVal": "瓷绝缘子",
            "jumperInsulatorType": "柱式瓷绝缘子#&#10kV柱式复合绝缘子",
            "jumperInsulatorTypeVal": "柱式瓷绝缘子",
            "leadSupportInsulatorType": "柱式瓷绝缘子#&#10kV柱式复合绝缘子",
            "leadSupportInsulatorTypeVal": "柱式瓷绝缘子",
            "params": {},
            "skeId": 73,
            "straightCornerInsulatorType": "柱式瓷绝缘子#&#10kV柱式复合绝缘子",
            "straightCornerInsulatorTypeVal": "柱式瓷绝缘子",
            "straightInsulatorType": "柱式瓷绝缘子#&#10kV柱式复合绝缘子",
            "straightInsulatorTypeVal": "柱式瓷绝缘子",
            "tensionInsulatorType": "2片盘形悬式瓷绝缘子#&#10kV棒形悬式复合绝缘子",
            "tensionInsulatorTypeVal": "2片盘形悬式瓷绝缘子",
            "weatherzone": "C",
            "crossArmTypeOptions": [
                "单横担",
                "双横担"
            ],
            "equipmentInsulatorTypeOptions": [],
            "fuseTypeOptions": [
                "跌落式",
                "封闭式"
            ],
            "isGroundingOptions": [
                "是"
            ],
            "isolatingSwitchTypeOptions": [
                "瓷绝缘子",
                "复合绝缘子"
            ],
            "jumperInsulatorTypeOptions": [
                "柱式瓷绝缘子",
                "10kV柱式复合绝缘子"
            ],
            "leadSupportInsulatorTypeOptions": [
                "柱式瓷绝缘子",
                "10kV柱式复合绝缘子"
            ],
            "straightCornerInsulatorTypeOptions": [
                "柱式瓷绝缘子",
                "10kV柱式复合绝缘子"
            ],
            "straightInsulatorTypeOptions": [
                "柱式瓷绝缘子",
                "10kV柱式复合绝缘子"
            ],
            "tensionInsulatorTypeOptions": [
                "2片盘形悬式瓷绝缘子",
                "10kV棒形悬式复合绝缘子"
            ]
        }
    ],
    "arrangeConfig": [
        {
            "defaultValue": "上字型排列",
            "insulatorType": "瓷横担绝缘子#&#普通弯矩复合绝缘横担",
            "loopNumber": "单回",
            "optionContent": "上字型排列",
            "params": {},
            "rodTowerMaterial": "单杆",
            "rodTowerType": "直线杆",
            "rodTowerTypeCode": "1002",
            "skeId": 100250580
        },
        {
            "defaultValue": "三角排列",
            "insulatorType": "柱式瓷绝缘子#&#10kV柱式复合绝缘子#&#悬垂10kV棒形悬式复合绝缘子串#&#悬垂35kV棒形悬式复合绝缘子串",
            "loopNumber": "单回",
            "optionContent": "三角排列",
            "params": {},
            "rodTowerMaterial": "单杆",
            "rodTowerType": "直线杆",
            "rodTowerTypeCode": "1002",
            "skeId": 100250581
        },
        {
            "defaultValue": "上字型排列",
            "insulatorType": "瓷横担绝缘子#&#普通弯矩复合绝缘横担",
            "loopNumber": "单回",
            "optionContent": "上字型排列",
            "params": {},
            "rodTowerMaterial": "单杆",
            "rodTowerType": "直线转角杆",
            "rodTowerTypeCode": "1004",
            "skeId": 100250582
        },
        {
            "defaultValue": "三角排列",
            "insulatorType": "瓷横担绝缘子#&#柱式瓷绝缘子#&#10kV柱式复合绝缘子",
            "loopNumber": "单回",
            "optionContent": "三角排列",
            "params": {},
            "rodTowerMaterial": "单杆",
            "rodTowerType": "直线转角杆",
            "rodTowerTypeCode": "1004",
            "skeId": 100250583
        },
        {
            "defaultValue": "三角排列",
            "loopNumber": "单回",
            "optionContent": "三角排列",
            "params": {},
            "rodTowerMaterial": "单杆",
            "rodTowerType": "直线耐张(转角)杆",
            "rodTowerTypeCode": "1003",
            "skeId": 100250584
        },
        {
            "defaultValue": "三角排列",
            "loopNumber": "单回",
            "optionContent": "三角排列",
            "params": {},
            "rodTowerMaterial": "单杆",
            "rodTowerType": "转角0°～15°耐张杆#&#转角15°～45°耐张杆",
            "rodTowerTypeCode": "1005#&#1007",
            "skeId": 100250585
        },
        {
            "defaultValue": "三角排列",
            "loopNumber": "单回",
            "optionContent": "三角排列",
            "params": {},
            "rodTowerMaterial": "单杆",
            "rodTowerType": "转角90°耐张杆",
            "rodTowerTypeCode": "1006",
            "skeId": 100250586
        },
        {
            "defaultValue": "三角排列",
            "loopNumber": "单回",
            "optionContent": "三角排列",
            "params": {},
            "rodTowerMaterial": "单杆",
            "rodTowerType": "终端杆",
            "rodTowerTypeCode": "1001",
            "skeId": 100250587
        },
        {
            "defaultValue": "双垂直排列",
            "loopNumber": "双回",
            "optionContent": "双三角排列#&#双垂直排列",
            "params": {},
            "rodTowerMaterial": "单杆",
            "rodTowerType": "直线杆",
            "rodTowerTypeCode": "1002",
            "skeId": 100250588
        },
        {
            "defaultValue": "双垂直排列",
            "loopNumber": "双回",
            "optionContent": "双三角排列#&#双垂直排列",
            "params": {},
            "rodTowerMaterial": "单杆",
            "rodTowerType": "直线转角杆",
            "rodTowerTypeCode": "1004",
            "skeId": 100250589
        },
        {
            "defaultValue": "双垂直排列",
            "loopNumber": "双回",
            "optionContent": "双三角排列#&#双垂直排列",
            "params": {},
            "rodTowerMaterial": "单杆",
            "rodTowerType": "直线耐张(转角)杆",
            "rodTowerTypeCode": "1003",
            "skeId": 100250590
        },
        {
            "defaultValue": "双垂直排列",
            "loopNumber": "双回",
            "optionContent": "双三角排列#&#双垂直排列",
            "params": {},
            "rodTowerMaterial": "单杆",
            "rodTowerType": "转角45°耐张杆",
            "rodTowerTypeCode": "1005",
            "skeId": 100250591
        },
        {
            "defaultValue": "双垂直排列",
            "loopNumber": "双回",
            "optionContent": "双三角排列#&#双垂直排列",
            "params": {},
            "rodTowerMaterial": "单杆",
            "rodTowerType": "转角90°耐张杆",
            "rodTowerTypeCode": "1006",
            "skeId": 100250592
        },
        {
            "defaultValue": "双垂直排列",
            "loopNumber": "双回",
            "optionContent": "双三角排列#&#双垂直排列",
            "params": {},
            "rodTowerMaterial": "单杆",
            "rodTowerType": "终端杆",
            "rodTowerTypeCode": "1001",
            "skeId": 100250593
        },
        {
            "defaultValue": "水平排列",
            "loopNumber": "单回",
            "optionContent": "水平排列",
            "params": {},
            "rodTowerMaterial": "双杆",
            "rodTowerType": "直线杆",
            "rodTowerTypeCode": "2002",
            "skeId": 100250594
        },
        {
            "defaultValue": "水平排列",
            "loopNumber": "单回",
            "optionContent": "水平排列",
            "params": {},
            "rodTowerMaterial": "双杆",
            "rodTowerType": "转角0°～10°耐张杆",
            "rodTowerTypeCode": "2003",
            "skeId": 100250595
        },
        {
            "defaultValue": "水平排列",
            "loopNumber": "单回",
            "optionContent": "水平排列",
            "params": {},
            "rodTowerMaterial": "双杆",
            "rodTowerType": "转角10°～30°耐张杆",
            "rodTowerTypeCode": "2004",
            "skeId": 100250596
        },
        {
            "defaultValue": "水平排列",
            "loopNumber": "单回",
            "optionContent": "水平排列",
            "params": {},
            "rodTowerMaterial": "双杆",
            "rodTowerType": "转角30°～60°耐张杆",
            "rodTowerTypeCode": "2005",
            "skeId": 100250597
        },
        {
            "defaultValue": "水平排列",
            "loopNumber": "单回",
            "optionContent": "水平排列",
            "params": {},
            "rodTowerMaterial": "双杆",
            "rodTowerType": "转角60°～90°耐张杆",
            "rodTowerTypeCode": "2006",
            "skeId": 100250598
        },
        {
            "defaultValue": "水平排列",
            "loopNumber": "单回",
            "optionContent": "水平排列",
            "params": {},
            "rodTowerMaterial": "双杆",
            "rodTowerType": "终端杆",
            "rodTowerTypeCode": "2001",
            "skeId": 100250599
        },
        {
            "defaultValue": "上字型排列",
            "insulatorType": "瓷横担绝缘子#&#普通弯矩复合绝缘横担",
            "loopNumber": "单回",
            "optionContent": "上字型排列",
            "params": {},
            "rodTowerMaterial": "窄基塔",
            "rodTowerType": "直线塔",
            "rodTowerTypeCode": "3002",
            "skeId": 100250605
        },
        {
            "defaultValue": "三角排列",
            "insulatorType": "柱式瓷绝缘子#&#10kV柱式复合绝缘子",
            "loopNumber": "单回",
            "optionContent": "三角排列",
            "params": {},
            "rodTowerMaterial": "窄基塔",
            "rodTowerType": "直线塔",
            "rodTowerTypeCode": "3002",
            "skeId": 100250606
        },
        {
            "defaultValue": "三角排列",
            "loopNumber": "单回",
            "optionContent": "三角排列",
            "params": {},
            "rodTowerMaterial": "窄基塔",
            "rodTowerType": "转角0°～30°耐张塔",
            "rodTowerTypeCode": "3004",
            "skeId": 100250607
        },
        {
            "defaultValue": "三角排列",
            "loopNumber": "单回",
            "optionContent": "三角排列",
            "params": {},
            "rodTowerMaterial": "窄基塔",
            "rodTowerType": "转角30°～60°耐张塔",
            "rodTowerTypeCode": "3005",
            "skeId": 100250608
        },
        {
            "defaultValue": "三角排列",
            "loopNumber": "单回",
            "optionContent": "三角排列",
            "params": {},
            "rodTowerMaterial": "窄基塔",
            "rodTowerType": "转角60°～90°耐张塔",
            "rodTowerTypeCode": "3006",
            "skeId": 100250609
        },
        {
            "defaultValue": "三角排列",
            "loopNumber": "单回",
            "optionContent": "三角排列",
            "params": {},
            "rodTowerMaterial": "窄基塔",
            "rodTowerType": "终端塔",
            "rodTowerTypeCode": "3001",
            "skeId": 100250610
        },
        {
            "defaultValue": "双垂直排列",
            "loopNumber": "双回",
            "optionContent": "双垂直排列",
            "params": {},
            "rodTowerMaterial": "窄基塔",
            "rodTowerType": "直线塔",
            "rodTowerTypeCode": "3002",
            "skeId": 100250611
        },
        {
            "defaultValue": "双垂直排列",
            "loopNumber": "双回",
            "optionContent": "双垂直排列",
            "params": {},
            "rodTowerMaterial": "窄基塔",
            "rodTowerType": "转角0°～30°耐张塔",
            "rodTowerTypeCode": "3004",
            "skeId": 100250612
        },
        {
            "defaultValue": "双垂直排列",
            "loopNumber": "双回",
            "optionContent": "双垂直排列",
            "params": {},
            "rodTowerMaterial": "窄基塔",
            "rodTowerType": "转角30°～60°耐张塔",
            "rodTowerTypeCode": "3005",
            "skeId": 100250613
        },
        {
            "defaultValue": "双垂直排列",
            "loopNumber": "双回",
            "optionContent": "双垂直排列",
            "params": {},
            "rodTowerMaterial": "窄基塔",
            "rodTowerType": "转角60°～90°耐张塔",
            "rodTowerTypeCode": "3006",
            "skeId": 100250614
        },
        {
            "defaultValue": "双垂直排列",
            "loopNumber": "双回",
            "optionContent": "双垂直排列",
            "params": {},
            "rodTowerMaterial": "窄基塔",
            "rodTowerType": "终端塔",
            "rodTowerTypeCode": "3001",
            "skeId": 100250615
        },
        {
            "defaultValue": "上字型排列",
            "loopNumber": "单回",
            "optionContent": "上字型排列",
            "params": {},
            "rodTowerMaterial": "宽基塔",
            "rodTowerType": "直线塔",
            "rodTowerTypeCode": "8002",
            "skeId": 100250620
        },
        {
            "defaultValue": "上字型排列",
            "loopNumber": "单回",
            "optionContent": "上字型排列",
            "params": {},
            "rodTowerMaterial": "宽基塔",
            "rodTowerType": "转角0°～30°耐张塔",
            "rodTowerTypeCode": "8004",
            "skeId": 100250621
        },
        {
            "defaultValue": "上字型排列",
            "loopNumber": "单回",
            "optionContent": "上字型排列",
            "params": {},
            "rodTowerMaterial": "宽基塔",
            "rodTowerType": "转角30°～60°耐张塔",
            "rodTowerTypeCode": "8005",
            "skeId": 100250622
        },
        {
            "defaultValue": "上字型排列",
            "loopNumber": "单回",
            "optionContent": "上字型排列",
            "params": {},
            "rodTowerMaterial": "宽基塔",
            "rodTowerType": "转角60°～90°耐张塔",
            "rodTowerTypeCode": "8006",
            "skeId": 100250623
        },
        {
            "defaultValue": "上字型排列",
            "loopNumber": "单回",
            "optionContent": "上字型排列",
            "params": {},
            "rodTowerMaterial": "宽基塔",
            "rodTowerType": "终端塔",
            "rodTowerTypeCode": "8001",
            "skeId": 100250624
        },
        {
            "defaultValue": "双垂直排列",
            "loopNumber": "双回",
            "optionContent": "双垂直排列",
            "params": {},
            "rodTowerMaterial": "宽基塔",
            "rodTowerType": "直线塔",
            "rodTowerTypeCode": "8002",
            "skeId": 100250625
        },
        {
            "defaultValue": "双垂直排列",
            "loopNumber": "双回",
            "optionContent": "双垂直排列",
            "params": {},
            "rodTowerMaterial": "宽基塔",
            "rodTowerType": "转角0°～30°耐张塔",
            "rodTowerTypeCode": "8004",
            "skeId": 100250626
        },
        {
            "defaultValue": "双垂直排列",
            "loopNumber": "双回",
            "optionContent": "双垂直排列",
            "params": {},
            "rodTowerMaterial": "宽基塔",
            "rodTowerType": "转角30°～60°耐张塔",
            "rodTowerTypeCode": "8005",
            "skeId": 100250627
        },
        {
            "defaultValue": "双垂直排列",
            "loopNumber": "双回",
            "optionContent": "双垂直排列",
            "params": {},
            "rodTowerMaterial": "宽基塔",
            "rodTowerType": "转角60°～90°耐张塔",
            "rodTowerTypeCode": "8006",
            "skeId": 100250628
        },
        {
            "defaultValue": "双垂直排列",
            "loopNumber": "双回",
            "optionContent": "双垂直排列",
            "params": {},
            "rodTowerMaterial": "宽基塔",
            "rodTowerType": "终端塔",
            "rodTowerTypeCode": "8001",
            "skeId": 100250629
        },
        {
            "componentType": "2",
            "defaultValue": "三角排列",
            "isShow": "1",
            "loopNumber": "单回",
            "optionContent": "三角排列#&#垂直排列",
            "params": {},
            "rodTowerMaterial": "侧担杆",
            "rodTowerType": "直线杆",
            "rodTowerTypeCode": "1002",
            "showName": "直线杆",
            "skeId": 100250600,
            "splitOptions": [
                "三角排列",
                "垂直排列"
            ]
        },
        {
            "componentType": "2",
            "defaultValue": "三角排列",
            "isShow": "1",
            "loopNumber": "单回",
            "optionContent": "三角排列#&#垂直排列",
            "params": {},
            "rodTowerMaterial": "侧担杆",
            "rodTowerType": "直线转角杆",
            "rodTowerTypeCode": "1004",
            "showName": "直线转角杆",
            "skeId": 100250601,
            "splitOptions": [
                "三角排列",
                "垂直排列"
            ]
        },
        {
            "componentType": "2",
            "defaultValue": "三角排列",
            "isShow": "1",
            "loopNumber": "单回",
            "optionContent": "三角排列#&#垂直排列",
            "params": {},
            "rodTowerMaterial": "侧担杆",
            "rodTowerType": "直线耐张(转角)杆",
            "rodTowerTypeCode": "1003",
            "showName": "直线耐张(转角)杆",
            "skeId": 100250602,
            "splitOptions": [
                "三角排列",
                "垂直排列"
            ]
        },
        {
            "componentType": "2",
            "defaultValue": "三角排列",
            "isShow": "1",
            "loopNumber": "单回",
            "optionContent": "三角排列#&#垂直排列",
            "params": {},
            "rodTowerMaterial": "侧担杆",
            "rodTowerType": "转角45°耐张杆",
            "rodTowerTypeCode": "1005",
            "showName": "转角45°耐张杆",
            "skeId": 100250603,
            "splitOptions": [
                "三角排列",
                "垂直排列"
            ]
        },
        {
            "componentType": "2",
            "defaultValue": "三角排列",
            "isShow": "1",
            "loopNumber": "单回",
            "optionContent": "三角排列#&#垂直排列",
            "params": {},
            "rodTowerMaterial": "侧担杆",
            "rodTowerType": "终端杆",
            "rodTowerTypeCode": "1001",
            "showName": "终端杆",
            "skeId": 100250604,
            "splitOptions": [
                "三角排列",
                "垂直排列"
            ]
        },
        {
            "componentType": "2",
            "defaultValue": "水平排列",
            "isShow": "1",
            "loopNumber": "单回",
            "optionContent": "水平排列",
            "params": {},
            "rodTowerMaterial": "钢管杆",
            "rodTowerType": "直线杆",
            "rodTowerTypeCode": "4002",
            "showName": "直线杆",
            "skeId": 100250616,
            "splitOptions": [
                "水平排列"
            ]
        },
        {
            "componentType": "2",
            "defaultValue": "水平排列",
            "isShow": "1",
            "loopNumber": "单回",
            "optionContent": "水平排列#&#三角排列",
            "params": {},
            "rodTowerMaterial": "钢管杆",
            "rodTowerType": "转角45°耐张杆#&#转角90°耐张杆#&#终端杆",
            "rodTowerTypeCode": "4001#&#4003#&#4004",
            "showName": "耐张(含終端)杆",
            "skeId": 100250617,
            "splitOptions": [
                "水平排列",
                "三角排列"
            ]
        },
        {
            "componentType": "2",
            "defaultValue": "双垂直排列",
            "isShow": "1",
            "loopNumber": "双回",
            "optionContent": "双三角排列#&#双垂直排列",
            "params": {},
            "rodTowerMaterial": "钢管杆",
            "rodTowerType": "直线杆",
            "rodTowerTypeCode": "4002",
            "showName": "直线杆",
            "skeId": 100250618,
            "splitOptions": [
                "双三角排列",
                "双垂直排列"
            ]
        },
        {
            "componentType": "2",
            "defaultValue": "双垂直排列",
            "isShow": "1",
            "loopNumber": "双回",
            "optionContent": "双三角排列#&#双垂直排列",
            "params": {},
            "rodTowerMaterial": "钢管杆",
            "rodTowerType": "转角45°耐张杆#&#转角90°耐张杆#&#终端杆",
            "rodTowerTypeCode": "4001#&#4003#&#4004",
            "showName": "耐张(含終端)杆",
            "skeId": 100250619,
            "splitOptions": [
                "双三角排列",
                "双垂直排列"
            ]
        }
    ]
}
    
}
